(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6898,5991],{

/***/ 2711:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/model/[modelId]/[modelSlug]",
      function () {
        return __webpack_require__(28148);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 25991:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ VideoPlayer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_intersection_observer__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(97650);
/* harmony import */ var react_player_lazy__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(56310);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57833);
/* harmony import */ var _MediaQueries__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57402);
/* harmony import */ var _bit_NextImage__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(49138);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    height: 100%;\n    width: 100%;\n    position: relative;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    video {\n      object-fit: ",
        " !important;\n    }\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var Styled = {
    PlayerWrapper: styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
        displayName: "VideoPlayer__PlayerWrapper",
        componentId: "sc-3553134d-0"
    })(_templateObject()),
    ReactPlayer: (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(react_player_lazy__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).attrs({
        width: "100%",
        height: "100%"
    }).withConfig({
        displayName: "VideoPlayer__ReactPlayer",
        componentId: "sc-3553134d-1"
    })(_templateObject1(), function(p) {
        return p.$cover ? "cover" : "contain";
    })
};
var isUrlIsVideo = function(url) {
    var videoExtensions = [
        "mp4",
        "webm",
        "ogg"
    ];
    var urlExtension = url.split(".").pop();
    return videoExtensions.includes(urlExtension);
};
function VideoPlayer(_param) {
    var url = _param.url, label = _param.label, playingState = _param.playingState, imgUrlDesktop = _param.imgUrlDesktop, imgUrlMobile = _param.imgUrlMobile, imgAlt = _param.imgAlt, _cover = _param.cover, cover = _cover === void 0 ? true : _cover, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_param, [
        "url",
        "label",
        "playingState",
        "imgUrlDesktop",
        "imgUrlMobile",
        "imgAlt",
        "cover"
    ]);
    var player = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), videoLoaded = ref[0], setVideoLoaded = ref[1];
    // add useInView to load video only when in view with 300 pixel offset
    var ref1 = (0,react_intersection_observer__WEBPACK_IMPORTED_MODULE_8__/* .useInView */ .YD)({
        threshold: 0,
        triggerOnce: true,
        rootMargin: "800px"
    }), ref2 = ref1.ref, inView = ref1.inView;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Styled.PlayerWrapper, {
        ref: ref2,
        children: [
            inView && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Styled.ReactPlayer, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, props), {
                $cover: cover,
                url: inView ? url : "",
                ref: player,
                controls: false,
                playing: playingState,
                muted: true,
                onReady: function() {
                    return setVideoLoaded(true);
                },
                fallback: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_MediaQueries__WEBPACK_IMPORTED_MODULE_3__/* .Desktop */ .Hi, {
                            children: !videoLoaded && !isUrlIsVideo(imgUrlDesktop) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_bit_NextImage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                cover: cover,
                                image: {
                                    imageUrl: imgUrlDesktop,
                                    alt: imgAlt
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_MediaQueries__WEBPACK_IMPORTED_MODULE_3__/* .Mobile */ .ij, {
                            children: !videoLoaded && !isUrlIsVideo(imgUrlMobile) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_bit_NextImage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                cover: cover,
                                image: {
                                    imageUrl: imgUrlMobile,
                                    alt: imgAlt
                                }
                            })
                        })
                    ]
                }),
                config: {
                    file: {
                        attributes: {
                            "aria-label": "סרטון המתאר את ".concat(label)
                        }
                    }
                },
                // for iphone!
                playsinline: true
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_MediaQueries__WEBPACK_IMPORTED_MODULE_3__/* .Desktop */ .Hi, {
                children: !videoLoaded && !isUrlIsVideo(imgUrlDesktop) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_bit_NextImage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    cover: cover,
                    image: {
                        imageUrl: imgUrlDesktop,
                        alt: imgAlt
                    }
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_MediaQueries__WEBPACK_IMPORTED_MODULE_3__/* .Mobile */ .ij, {
                children: !videoLoaded && !isUrlIsVideo(imgUrlMobile) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_bit_NextImage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    cover: cover,
                    image: {
                        imageUrl: imgUrlMobile,
                        alt: imgAlt
                    }
                })
            })
        ]
    });
}


/***/ }),

/***/ 74962:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41810);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57833);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  /* display: flex; */\n  /* flex-wrap: wrap; */\n  /* gap: ",
        "px; */\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: ",
        ";\n  ",
        " {\n    width: 50%;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  height: 44px;\n  border: solid 1px transparent;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 5px;\n  background-color: ",
        ";\n  font-size: 16px;\n  direction: ",
        ";\n  cursor: pointer;\n  position: relative;\n  ",
        "\n\n  @media print {\n    display: none;\n    justify-content: flex-start;\n    box-shadow: none;\n    background-image: none !important;\n\n    span {\n      justify-content: flex-start;\n    }\n  }\n\n  b {\n    font-size: 1.5em;\n  }\n\n  span {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: absolute;\n    inset: 0;\n    line-height: 1;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  border: 0;\n  margin: -1px;\n  padding: 0;\n  border-radius: 50%;\n  width: 1px;\n  height: 1px;\n  opacity: 0;\n\n  &:focus-visible + label {\n    border: 2px dashed white;\n    outline: 3px dashed #0e3487;\n    outline-offset: 2px;\n  }\n\n  :checked + ",
        " {\n    border-color: ",
        ";\n    color: ",
        ';\n    background-image: url("/battery-button.svg");\n    @media print {\n      display: block;\n      border: none;\n    }\n  }\n\n  :focus + ',
        " {\n    border-color: ",
        ";\n    color: ",
        ';\n    background-image: url("/battery-button.svg");\n    @media print {\n      display: block;\n      border: none;\n    }\n  }\n'
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var StyledContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "SingleButtonSelection__StyledContainer",
    componentId: "sc-f3a656e3-0"
})(_templateObject(), function(props) {
    return props.$gap;
});
var StyledButtonWrap = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    displayName: "SingleButtonSelection__StyledButtonWrap",
    componentId: "sc-f3a656e3-1"
})(_templateObject1(), function(props) {
    return props.$itemsPerRow === "auto" ? "auto" : "calc(100% / ".concat(props.$itemsPerRow, " - ").concat(props.$gap, "px * (").concat(props.$itemsPerRow, " - 1) / ").concat(props.$itemsPerRow, ") ");
}, function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledLabel = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].label.withConfig */ .ZP.label.withConfig({
    displayName: "SingleButtonSelection__StyledLabel",
    componentId: "sc-f3a656e3-2"
})(_templateObject2(), function(p) {
    return p.theme.colors.white;
}, function(p) {
    return p.$isBattery ? "ltr" : "rtl";
}, function(p) {
    return !p.$isBattery && "box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.1);";
}, function(p) {
    return p.$isBattery ? "\n    background-image:url('/battery-disabled.svg');\n    background-size:contain;\n    background-repeat:no-repeat;\n    border:none;\n    height: 0;\n    padding-bottom: calc( 100% * 59 / 232);\n    position: relative;\n\n  " : "background-image:none !important;";
});
var StyledRadio = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].input.withConfig */ .ZP.input.withConfig({
    displayName: "SingleButtonSelection__StyledRadio",
    componentId: "sc-f3a656e3-3"
})(_templateObject3(), StyledLabel, function(param) {
    var theme = param.theme;
    return theme.colors.black;
}, function(param) {
    var theme = param.theme;
    return theme.colors.black;
}, StyledLabel, function(param) {
    var theme = param.theme;
    return theme.colors.black;
}, function(param) {
    var theme = param.theme;
    return theme.colors.black;
});
var SingleButtonSelection = function(param) {
    var id = param.id, // title,
    items = param.items, onSelect = param.onSelect, isBattery = param.isBattery, customButton = param.customButton, // headlineComponent,
    selectedValue = param.selectedValue, className = param.className, _itemsPerRow = param.itemsPerRow, itemsPerRow = _itemsPerRow === void 0 ? 2 : _itemsPerRow, _gap = param.gap, gap = _gap === void 0 ? 0 : _gap;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(selectedValue || items[0].value), selectedButton = ref[0], setSelectedButton = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (!items || !items.length) {
            return;
        }
        setSelectedButton(selectedValue || items[0].value);
    }, [
        items,
        selectedValue
    ]);
    var handleChange = function(value, index) {
        setSelectedButton(value);
        onSelect(value, index);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledContainer, {
        role: "radiogroup",
        "aria-labelledby": id,
        $gap: gap,
        className: className,
        children: items.map(function(item, index) {
            var ref;
            var radioId = "radio_".concat(id, "_").concat(item.value);
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledButtonWrap, {
                tabIndex: -1,
                role: "presentation",
                focusRipple: true,
                $itemsPerRow: itemsPerRow,
                $gap: gap,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledRadio, {
                        "aria-label": "כפתור רדיו",
                        type: "radio",
                        name: id,
                        value: item.value,
                        id: radioId,
                        checked: item.value === selectedButton,
                        // disabled={!color.details.inStock}
                        onChange: function() {
                            handleChange(item.value, index);
                            setSelectedButton(item.value);
                        }
                    }),
                    customButton ? customButton(radioId, item.value === selectedButton, item, index) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledLabel, {
                        $isBattery: isBattery,
                        htmlFor: radioId,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("span", {
                            children: [
                                item.secondaryName && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("b", {
                                    children: [
                                        item.secondaryName.toUpperCase(),
                                        "\xa0"
                                    ]
                                }),
                                (ref = item.name) === null || ref === void 0 ? void 0 : ref.toUpperCase()
                            ]
                        })
                    })
                ]
            }, "".concat(id, "-").concat(item.value, "-").concat(index));
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(SingleButtonSelection));


/***/ }),

/***/ 48868:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_text_truncate__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37856);
/* harmony import */ var react_text_truncate__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_text_truncate__WEBPACK_IMPORTED_MODULE_1__);


// expmple of usage:
// const StyledTruncateText = styled(TruncateText)`
//   text-align: right;
//   font-size: 14px;
//   color: ${(p) => p.theme.colors.marbleGrey};
// `
// <StyledTruncateText
// line={2}
// element="span"
// truncateText="…"
// text={productData.short_description}
// />
var TruncateText = function(param) {
    var line = param.line, element = param.element, truncateText = param.truncateText, text = param.text, textTruncateChild = param.textTruncateChild, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((react_text_truncate__WEBPACK_IMPORTED_MODULE_1___default()), {
        className: className,
        line: line,
        element: element,
        truncateText: truncateText,
        text: text,
        textTruncateChild: textTruncateChild,
        style: {
            display: "flex"
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TruncateText);


/***/ }),

/***/ 90227:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ buildShopLink; }
/* harmony export */ });
var buildShopLink = function(detailing, color, carId) {
    var utmParams = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "";
    var details = detailing && "detailing=".concat(detailing);
    var colorParam = color && "&color=".concat(color);
    var utmParamsParam = utmParams && "&".concat(utmParams);
    return "/shop/".concat(carId, "/?").concat(details).concat(colorParam).concat(utmParamsParam, "#/detailing");
};


/***/ }),

/***/ 13354:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ isValidMediaUrl; }
/* harmony export */ });
var isValidMediaUrl = function(url) {
    try {
        var parsedUrl = new URL(url);
        return (parsedUrl.protocol === "http:" || parsedUrl.protocol === "https:") && parsedUrl.pathname !== "/";
    } catch (error) {
        return false;
    }
};


/***/ }),

/***/ 15642:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(17812);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var reusable_icons_VideoPlayIcon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87749);
/* harmony import */ var reusable_icons_VideoStopIcon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5089);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(57833);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-height: ",
        ";\n  height: ",
        ";\n  ",
        " {\n    height: ",
        ";\n  }\n  width: 100%;\n  position: relative;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  bottom: 0;\n  padding: 0;\n  width: 80px;\n  margin-bottom: 90px;\n  ",
        "\n  ",
        " {\n    margin-bottom: 40px;\n    ",
        "\n  }\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var VideoPlayer = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5726), __webpack_require__.e(5991)]).then(__webpack_require__.bind(__webpack_require__, 25991));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(25991)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
            children: "..."
        });
    }
});
var StyledVideoWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "VideoModelFullScreen__StyledVideoWrapper",
    componentId: "sc-19b1a628-0"
})(_templateObject(), function(p) {
    return p.$maxHeight || "100vh";
}, function(p) {
    return p.$mobileHeight || p.$height;
}, function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return p.$height;
});
var StyledIconButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z).withConfig({
    displayName: "VideoModelFullScreen__StyledIconButton",
    componentId: "sc-19b1a628-1"
})(_templateObject1(), function(p) {
    return p.$iconPosition === "left" ? p.$iconSize === "small" ? "margin-left: 40px; left: 0; margin-bottom: 40px;" : "margin-left: 10px; left: 0;" : "margin-right: 10px; right: 0;";
}, function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return p.$iconPosition === "left" ? "margin-left: 40px; left: 0;" : "margin-right: 40px; right: 0;";
}, function(p) {
    return p.$iconSize === "small" ? "width: 24px; height: 24px;" : "width: 80px;";
});
var VideoModelFullScreen = function(param) {
    var src = param.src, imgDesktop = param.imgDesktop, imgMobile = param.imgMobile, alt = param.alt, maxHeight = param.maxHeight, mobileHeight = param.mobileHeight, _iconSize = param.iconSize, iconSize = _iconSize === void 0 ? "large" : _iconSize, iconPosition = param.iconPosition;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), playing = ref[0], setPlaying = ref[1];
    var videoRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    var observer = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        if (false) {}
        return new IntersectionObserver(function(param) {
            var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(param, 1), entry = _param[0];
            return setPlaying(entry.isIntersecting);
        });
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        observer === null || observer === void 0 ? void 0 : observer.observe(videoRef.current);
        return function() {
            observer === null || observer === void 0 ? void 0 : observer.disconnect();
        };
    }, [
        videoRef,
        observer
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledVideoWrapper, {
        $height: "90vh",
        ref: videoRef,
        $maxHeight: maxHeight,
        $mobileHeight: mobileHeight,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(VideoPlayer, {
                url: src,
                light: false,
                label: alt,
                playingState: playing,
                loop: true,
                imgAlt: alt,
                imgUrlDesktop: imgDesktop,
                imgUrlMobile: imgMobile
            }),
            playing ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledIconButton, {
                onClick: function() {
                    setPlaying(false);
                },
                "aria-label": "עצור סרטון",
                $iconSize: iconSize,
                $iconPosition: iconPosition,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(reusable_icons_VideoStopIcon__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {})
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledIconButton, {
                onClick: function() {
                    return setPlaying(true);
                },
                "aria-label": "התחל סרטון",
                $iconSize: iconSize,
                $iconPosition: iconPosition,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(reusable_icons_VideoPlayIcon__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {})
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (VideoModelFullScreen);


/***/ }),

/***/ 42903:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export StyledImage */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var common_MediaQueries__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57402);
/* harmony import */ var common_bit_NextImage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49138);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57833);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  /* height: 100%; */\n  aspect-ratio: 16 / 9;\n  position: relative;\n  flex-grow: 1;\n  ",
        " {\n    width: 110%;\n    flex-grow: 0;\n    // aspect-ratio: 15 / 9;\n    margin-bottom: calc(-1% * 15 / 9);\n    overflow: hidden;\n  }\n  ",
        " {\n    max-width: 100vw;\n    height: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  overflow: hidden;\n  cursor: grab;\n  width: 100%;\n  height: 100%;\n  &:focus-visible {\n    :after {\n      // contact from aria-label\n      content: "',
        '";\n      position: absolute;\n      top: 0;\n      right: 0;\n      padding: 5px;\n      background: rgba(0, 0, 0, 0.8);\n      color: white;\n    }\n  }\n'
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  width: 100%;\n  aspect-ratio: 16 / 9;\n  ",
        " {\n    /* margin-top: 40px; */\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  display: block;\n  height: 100%;\n  object-fit: cover;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 32px;\n  position: absolute;\n  bottom: 0;\n  left: 50%;\n  transform: translate(-50%, 0);\n  height: 32px;\n  cursor: grab;\n  user-select: none;\n  ",
        " {\n    width: 50px;\n    transform: translate(-50%, 50%);\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}





var TOTAL_FRAMES = 24;
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "ThreeSixtyViewer__StyledWrapper",
    componentId: "sc-bd049a62-0"
})(_templateObject(), function(p) {
    return p.theme.breakpoints.down("sm");
}, function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledImagesContainer = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "ThreeSixtyViewer__StyledImagesContainer",
    componentId: "sc-bd049a62-1"
})(_templateObject1(), function(p) {
    return p["data-a11y"];
});
var ImageWrap = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "ThreeSixtyViewer__ImageWrap",
    componentId: "sc-bd049a62-2"
})(_templateObject2(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledImage = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].img.withConfig */ .ZP.img.withConfig({
    displayName: "ThreeSixtyViewer__StyledImage",
    componentId: "sc-bd049a62-3"
})(_templateObject3());
var StyledThreeSixtyIcon = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].img.withConfig */ .ZP.img.withConfig({
    displayName: "ThreeSixtyViewer__StyledThreeSixtyIcon",
    componentId: "sc-bd049a62-4"
})(_templateObject4(), function(p) {
    return p.theme.breakpoints.up("md");
});
var ThreeSixtyViewer = function(param) {
    var imageList = param.imageList, alt = param.alt, className = param.className, _enable = param.enable, enable = _enable === void 0 ? true : _enable, _showIcon = param.showIcon, showIcon = _showIcon === void 0 ? false : _showIcon;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(0), activeImage = ref[0], setActiveImage = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(0), enableSpin = ref1[0], setEnableSpin = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false), activeImageLoaded = ref2[0], setActiveImageLoaded = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(null), circlrInstance = ref3[0], setCirclrInstance = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false), isDragging = ref4[0], setIsDragging = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(0), prevX = ref5[0], setPrevX = ref5[1];
    var isDesktop = (0,common_MediaQueries__WEBPACK_IMPORTED_MODULE_2__/* .useIsDesktop */ .Ce)();
    var handleMouseDown = function(e) {
        setIsDragging(true);
        setPrevX(e.clientX);
    };
    var handleMouseMove = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(function(e) {
        if (!isDragging || !circlrInstance) return;
        var deltaX = e.clientX - prevX;
        if (deltaX > 0) {
            circlrInstance.next();
        } else if (deltaX < 0) {
            circlrInstance.prev();
        }
        setPrevX(e.clientX);
    }, [
        isDragging,
        circlrInstance,
        prevX
    ]);
    var handleMouseUp = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(function() {
        setIsDragging(false);
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        if (isDragging) {
            document.addEventListener("mousemove", handleMouseMove);
            document.addEventListener("mouseup", handleMouseUp);
        }
        return function() {
            document.removeEventListener("mousemove", handleMouseMove);
            document.removeEventListener("mouseup", handleMouseUp);
        };
    }, [
        isDragging,
        handleMouseMove,
        handleMouseUp
    ]);
    var images = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(function() {
        var _images = imageList || [] // Ensure imageList is always an array
        ;
        return _images.length - 1 === TOTAL_FRAMES ? _images : (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_images).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(Array(TOTAL_FRAMES - _images.length).fill(_images[0] || "")));
    }, [
        imageList
    ]);
    var imagesContainerRef = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(function(node) {
        if (!node || !enableSpin) return;
        __webpack_require__.e(/* import() */ 3672).then(__webpack_require__.t.bind(__webpack_require__, 53672, 23)).then(function(param) {
            var circlr = param.default;
            var circlrObj = circlr(node).scroll(false).on("show", function(i) {
                setActiveImage(i);
            });
            setCirclrInstance(circlrObj);
        });
    }, [
        enableSpin
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        setActiveImageLoaded(false);
    }, [
        imageList
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        if (enable) {
            setEnableSpin(function(prev) {
                return prev + 1;
            });
        }
    }, [
        enable
    ]);
    var getImageProps = function(image) {
        return isDesktop ? {
            src: "".concat(image, "?width=760")
        } : {
            src: "".concat(image, "?width=375"),
            sizes: "100vw",
            srcSet: "".concat(image, "?width=375 1x,\n                   ").concat(image, "?width=750 2x,\n                   ").concat(image, "?width=1125 3x")
        };
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledImagesContainer, {
                ref: imagesContainerRef,
                style: {
                    pointerEvents: !enable ? "none" : "auto"
                },
                tabIndex: !enable ? -1 : 0,
                role: "application",
                "data-a11y": "רכיב קרוסלת 360 מעלות. ניתן לשנות תמונה על ידי שימוש בחצי המקלדת ימינה ושמאלה",
                id: "three-sixty-viewer",
                onKeyDown: function(e) {
                    e.stopPropagation();
                    // e.preventDefault()
                    if (e.key === "ArrowLeft") {
                        circlrInstance === null || circlrInstance === void 0 ? void 0 : circlrInstance.next();
                    } else if (e.key === "ArrowRight") {
                        circlrInstance === null || circlrInstance === void 0 ? void 0 : circlrInstance.prev();
                    }
                },
                children: images.map(function(image, i) {
                    return i === 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ImageWrap, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(common_bit_NextImage__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            image: {
                                imageUrl: images[0],
                                // imageUrl: image,
                                alt: "".concat(alt, "=0")
                            },
                            imageSizes: [
                                "100vw",
                                "760px"
                            ],
                            priority: true,
                            loadingEager: enableSpin && activeImageLoaded ? true : false,
                            onLoadCallBack: function() {
                                if (activeImage === i) {
                                    setActiveImageLoaded(true);
                                }
                            }
                        })
                    }, i) : !!enableSpin && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ImageWrap, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledImage, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, getImageProps(image)), {
                            alt: "".concat(alt, "=").concat(i),
                            loading: enableSpin && activeImageLoaded ? "eager" : "lazy",
                            onLoad: function() {
                                if (activeImage === i) {
                                    setActiveImageLoaded(true);
                                }
                            }
                        }))
                    }, i);
                })
            }),
            showIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledThreeSixtyIcon, {
                src: "/icons/rotate-icon.svg",
                alt: "",
                title: "לחץ וגרור לסובב רכב",
                onMouseDown: handleMouseDown,
                onTouchStart: function() {
                    return setIsDragging(true);
                },
                onTouchEnd: function() {
                    return setIsDragging(false);
                },
                style: {
                    cursor: isDragging ? "grabbing" : "grab"
                }
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(ThreeSixtyViewer));


/***/ }),

/***/ 86437:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export keyFrameCircle */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57833);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  0% { opacity: 1; scale:1; }\n  60% { opacity: 0.6; }\n  80% { opacity: 0.3; scale:120; }\n  100% { opacity: 0; scale:120; }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        " ",
        "\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 50px;\n  height: 50px;\n  margin: 0px auto;\n  border-radius: 100%;\n  background-color: ",
        ";\n  z-index: 10;\n  opacity: 0;\n  animation: ",
        ";\n  /* mix-blend-mode: multiply; */\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var keyFrameCircle = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .keyframes */ .F4)(_templateObject());
var StyledWrap = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "ColorCircleAnimation__StyledWrap",
    componentId: "sc-833f03dd-0"
})(_templateObject1());
var StyledColorAnimation = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "ColorCircleAnimation__StyledColorAnimation",
    componentId: "sc-833f03dd-1"
})(_templateObject3(), function(p) {
    return p.$color;
}, function(param) {
    var $colorChange = param.$colorChange, $animationTime = param.$animationTime;
    return $colorChange && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject2(), keyFrameCircle, $animationTime ? "2000ms linear forwards" : "1200ms linear forwards");
});
var ColorCircleAnimation = function(param) {
    var animationFlag = param.animationFlag, hex = param.hex, className = param.className, animationTime = param.animationTime;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: animationFlag && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledWrap, {
            className: className,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledColorAnimation, {
                $colorChange: animationFlag,
                $color: hex,
                $animationTime: animationTime
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ColorCircleAnimation);


/***/ }),

/***/ 72820:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var theme_colors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22038);






var SvgComponent = function(_param) {
    var _color = _param.color, color = _color === void 0 ? theme_colors__WEBPACK_IMPORTED_MODULE_2__/* ["default"].darkGrey */ .Z.darkGrey : _color, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "color"
    ]);
    var w = 50;
    var h = 50;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        viewBox: "0 0 ".concat(w, " ").concat(h),
        width: w,
        height: h,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            width: "50",
            height: "50",
            viewBox: "0 0 50 50",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                    x: "1",
                    y: "1",
                    width: "48",
                    height: "48",
                    rx: "24",
                    stroke: color,
                    strokeWidth: "2"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M20.5 22.75L25 27.25L29.5 22.75",
                    stroke: color,
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    id: "arrow"
                })
            ]
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgComponent);


/***/ }),

/***/ 87749:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40872);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);





var SvgComponent = function(_param) {
    var props = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, _param);
    var w = 50;
    var h = 50;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        width: w,
        height: h,
        viewBox: "0 0 ".concat(w, " ").concat(h),
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                width: "50",
                height: "50",
                rx: "25",
                fill: "white"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M31.8126 24.8908L31.8126 24.8908L31.817 24.8935C31.8355 24.9046 31.8507 24.9203 31.8613 24.9391L32.7321 24.4474L31.8613 24.9391C31.8719 24.9578 31.8775 24.979 31.8775 25.0005C31.8775 25.0221 31.8719 25.0432 31.8613 25.062C31.8507 25.0807 31.8355 25.0964 31.817 25.1076L31.817 25.1075L31.8126 25.1103L21.6876 31.2907L21.6804 31.2951L21.6733 31.2996C21.6594 31.3084 21.6434 31.3132 21.6269 31.3135C21.6105 31.3138 21.5942 31.3096 21.58 31.3013L21.5689 31.2949L21.5576 31.2887C21.5401 31.2791 21.5255 31.2649 21.5154 31.2478L20.6541 31.7559L21.5154 31.2478C21.5053 31.2306 21.4999 31.211 21.5 31.1911V31.188V18.813H21.5L21.5 18.81C21.4999 18.7901 21.5053 18.7705 21.5154 18.7533C21.5255 18.7361 21.5401 18.722 21.5576 18.7124L21.5689 18.7062L21.58 18.6997C21.5942 18.6914 21.6104 18.6872 21.6269 18.6875C21.6434 18.6878 21.6594 18.6926 21.6733 18.7015L21.6804 18.7059L21.6876 18.7103L31.8126 24.8908Z",
                fill: "#616161",
                stroke: "#616161",
                strokeWidth: "2"
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgComponent);


/***/ }),

/***/ 5089:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40872);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);





var SvgComponent = function(_param) {
    var props = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, _param);
    var w = 50;
    var h = 50;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        width: w,
        height: h,
        viewBox: "0 0 ".concat(w, " ").concat(h),
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                width: "50",
                height: "50",
                rx: "25",
                fill: "white"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M30.0625 18.8125H27.5312C27.2206 18.8125 26.9688 19.0643 26.9688 19.375V30.625C26.9688 30.9357 27.2206 31.1875 27.5312 31.1875H30.0625C30.3732 31.1875 30.625 30.9357 30.625 30.625V19.375C30.625 19.0643 30.3732 18.8125 30.0625 18.8125Z",
                fill: "#616161",
                stroke: "#616161",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M22.4688 18.8125H19.9375C19.6268 18.8125 19.375 19.0643 19.375 19.375V30.625C19.375 30.9357 19.6268 31.1875 19.9375 31.1875H22.4688C22.7794 31.1875 23.0312 30.9357 23.0312 30.625V19.375C23.0312 19.0643 22.7794 18.8125 22.4688 18.8125Z",
                fill: "#616161",
                stroke: "#616161",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgComponent);


/***/ }),

/***/ 61593:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52663);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(17812);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(22318);
/* harmony import */ var reusable_icons_CloseIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2423);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57833);
/* harmony import */ var theme_colors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22038);
/* harmony import */ var theme_shared__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6089);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .MuiDialog-paper {\n    width: calc(100% - 40px);\n    border-radius: 8px;\n    background-color: ",
        ";\n    padding: 20px;\n    box-shadow: ",
        ";\n    max-width: 700px !important;\n    max-height: calc(100vh - 40px);\n    padding-left: 0px;\n    ",
        " {\n      padding-top: 25px;\n    }\n  }\n\n  /* mobile size: */\n  ",
        " {\n    .MuiDialog-container {\n      margin: auto;\n    }\n    .MuiDialog-paperScrollBody {\n      margin: auto;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  max-height: calc(100vh - 60px);\n  overflow: scroll;\n  form {\n    height: 100%;\n  }\n  ",
        " {\n    padding-left: 20px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  top: 2px;\n  right: 2px;\n  ",
        " {\n    top: -5px;\n    right: 0px;\n    padding: 5px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: center;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: center;\n  max-width: 400px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  justify-content: center;\n  gap: 10px;\n  /* if children */\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}






var StyledDialog = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    displayName: "InformationPopUp__StyledDialog",
    componentId: "sc-7d76dbcf-0"
})(_templateObject(), function(p) {
    return p.theme.colors.white;
}, function(p) {
    return p.theme.boxShadows.cardShadow;
}, function(p) {
    return p.theme.breakpoints.down("sm");
}, function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "InformationPopUp__StyledWrapper",
    componentId: "sc-7d76dbcf-1"
})(_templateObject1(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledIconButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z).withConfig({
    displayName: "InformationPopUp__StyledIconButton",
    componentId: "sc-7d76dbcf-2"
})(_templateObject2(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledTitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z).attrs({
    variant: "h2"
}).withConfig({
    displayName: "InformationPopUp__StyledTitle",
    componentId: "sc-7d76dbcf-3"
})(_templateObject3());
var StyledSubtitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z).attrs({
    variant: "body1"
}).withConfig({
    displayName: "InformationPopUp__StyledSubtitle",
    componentId: "sc-7d76dbcf-4"
})(_templateObject4());
var StyledPopUpTop = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "InformationPopUp__StyledPopUpTop",
    componentId: "sc-7d76dbcf-5"
})(_templateObject5(), function(p) {
    return p.$hasChildren && "margin-bottom: 20px;";
});
var InformationPopUp = function(param) {
    var open = param.open, setOpen = param.setOpen, onClose = param.onClose, children = param.children, icon = param.icon, title = param.title, text = param.text, className = param.className, _backgroundColor = param.backgroundColor, backgroundColor = _backgroundColor === void 0 ? true : _backgroundColor, _withDivider = param.withDivider, withDivider = _withDivider === void 0 ? false : _withDivider, subtitle = param.subtitle;
    var handleClose = function() {
        if (setOpen) {
            setOpen(false);
        }
        if (onClose) {
            onClose();
        }
    };
    // todo change this based on new design with two titles
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledDialog, {
        open: open,
        onClose: handleClose,
        scroll: "paper",
        className: className,
        $backgroundColor: backgroundColor,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledIconButton, {
                onClick: handleClose,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(reusable_icons_CloseIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    width: 35,
                    height: 35
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledPopUpTop, {
                        $hasChildren: children !== undefined || withDivider,
                        children: [
                            icon && icon,
                            subtitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledTitle, {
                                children: subtitle
                            }),
                            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledTitle, {
                                children: title
                            }),
                            text && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledSubtitle, {
                                children: text
                            })
                        ]
                    }),
                    withDivider && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_shared__WEBPACK_IMPORTED_MODULE_4__/* .StyledDividerH */ .aV, {
                        $color: theme_colors__WEBPACK_IMPORTED_MODULE_3__/* ["default"].darkGrey */ .Z.darkGrey,
                        $width: 0.5,
                        $radius: 3,
                        $mb: "20px"
                    }),
                    children
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (InformationPopUp);


/***/ }),

/***/ 28148:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _modelSlug_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./common/SeoMetaData.tsx
var SeoMetaData = __webpack_require__(25384);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./common/MediaQueries.tsx + 5 modules
var MediaQueries = __webpack_require__(57402);
// EXTERNAL MODULE: ./common/bit/hooks/useScrollDirection.tsx
var useScrollDirection = __webpack_require__(3466);
// EXTERNAL MODULE: ./common/bit/scrollSection/index.ts + 5 modules
var scrollSection = __webpack_require__(39361);
// EXTERNAL MODULE: ./components/shopFeatures/detailing/detailingSlice.ts
var detailingSlice = __webpack_require__(52909);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/value/use-scroll.mjs + 25 modules
var use_scroll = __webpack_require__(10521);
// EXTERNAL MODULE: ./layout/header/Header.tsx + 10 modules
var Header = __webpack_require__(43628);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
// EXTERNAL MODULE: ./theme/animation.ts
var animation = __webpack_require__(78373);
// EXTERNAL MODULE: ./theme/shared.tsx
var shared = __webpack_require__(6089);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/IconButton/IconButton.js
var IconButton = __webpack_require__(17812);
// EXTERNAL MODULE: ./common/bit/NextImage.tsx + 1 modules
var NextImage = __webpack_require__(49138);
// EXTERNAL MODULE: ./common/bit/NextLink.tsx
var NextLink = __webpack_require__(60687);
// EXTERNAL MODULE: ./common/isValidMediaUrl.ts
var isValidMediaUrl = __webpack_require__(13354);
;// CONCATENATED MODULE: ./components/carModelPage/TopBanner/ModelPageTopBanner.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-bottom: 1px solid rgba(76, 96, 126, 0.2);\n  background: #d0d3da;\n  ",
        "\n  height: 64px;\n  position: relative;\n  padding: 0;\n  padding-right: 60px;\n  gap: 16px;\n  z-index: 2;\n  margin-top: 50px;\n  margin-bottom: -60px;\n  ",
        " {\n    height: 80px;\n    margin-top: 81px;\n    margin-bottom: -80px;\n    padding: 0 176px 0 32px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  height: 100%;\n  right: 0;\n  width: 160px;\n  ",
        " {\n    width: 60px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n\n  height: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 9px 0;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  line-height: 1.2;\n  ",
        " {\n    font-size: 8px;\n    line-height: 16px;\n  }\n  p {\n    margin: 0;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  background-color: #4c607e;\n  border-color: #4c607e;\n\n  ",
        " {\n    padding-right: 5px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}







var StyledTopBanner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ModelPageTopBanner__StyledTopBanner",
    componentId: "sc-9514c58c-0"
})(_templateObject(), function(p) {
    return p.$bgColor && "background-color: ".concat(p.$bgColor, ";");
}, function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ModelPageTopBanner__StyledImageWrapper",
    componentId: "sc-9514c58c-1"
})(_templateObject1(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ModelPageTopBanner__StyledContent",
    componentId: "sc-9514c58c-2"
})(_templateObject2());
var StyledTextWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ModelPageTopBanner__StyledTextWrapper",
    componentId: "sc-9514c58c-3"
})(_templateObject3());
var StyledTypography = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).withConfig({
    displayName: "ModelPageTopBanner__StyledTypography",
    componentId: "sc-9514c58c-4"
})(_templateObject4(), function(p) {
    return p.theme.breakpoints.down("sm");
});
// const StyledTypographySubtitle = styled(Typography)`
//   position: relative;
//   ${(p) => p.theme.breakpoints.down("sm")} {
//     font-size: 12px;
//   }
// `
var StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    displayName: "ModelPageTopBanner__StyledButton",
    componentId: "sc-9514c58c-5"
})(_templateObject5(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var BannerImage = function(param) {
    var image = param.image;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage/* default */.Z, {
        image: image,
        priority: true,
        cover: false,
        objectPosition: "bottom right"
    });
};
var ModelPageTopBanner = function(param) {
    var data = param.data;
    if (!data) return null;
    var imageMob = data.imageMob, imageWeb = data.imageWeb, buttonText = data.buttonText, buttonUrl = data.buttonUrl, isActive = data.isActive, isButtonActive = data.isButtonActive, titleMob = data.titleMob, titleWeb = data.titleWeb, color = data.color;
    if (!isActive) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTopBanner, {
        $bgColor: color,
        children: [
            (0,isValidMediaUrl/* isValidMediaUrl */.d)(imageMob === null || imageMob === void 0 ? void 0 : imageMob.imageUrl) && /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaQueries/* Mobile */.ij, {
                aboveTheFold: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImageWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerImage, {
                        image: imageMob
                    })
                })
            }),
            (0,isValidMediaUrl/* isValidMediaUrl */.d)(imageWeb === null || imageWeb === void 0 ? void 0 : imageWeb.imageUrl) && /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaQueries/* Desktop */.Hi, {
                aboveTheFold: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImageWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerImage, {
                        image: imageWeb
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContent, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTextWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaQueries/* Mobile */.ij, {
                                children: titleMob && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTypography, {
                                    variant: "h2",
                                    component: "div",
                                    dangerouslySetInnerHTML: {
                                        __html: titleMob
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaQueries/* Desktop */.Hi, {
                                children: titleWeb && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTypography, {
                                    variant: "h2",
                                    component: "div",
                                    dangerouslySetInnerHTML: {
                                        __html: titleWeb
                                    }
                                })
                            })
                        ]
                    }),
                    isButtonActive && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaQueries/* Desktop */.Hi, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                    href: buttonUrl,
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                                        "aria-label": buttonText,
                                        children: buttonText
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaQueries/* Mobile */.ij, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                    href: buttonUrl,
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                        "aria-label": buttonText,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            width: "18",
                                            height: "18",
                                            viewBox: "0 0 18 18",
                                            fill: "none",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M11.25 4.5L6.75 9L11.25 13.5",
                                                stroke: "#4C607E",
                                                strokeWidth: "2",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            })
                                        })
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var TopBanner_ModelPageTopBanner = (ModelPageTopBanner);

// EXTERNAL MODULE: ./components/carModelPage/navigation/CarModelNavBar.tsx + 1 modules
var CarModelNavBar = __webpack_require__(63269);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./api/index.ts + 2 modules
var api = __webpack_require__(71537);
// EXTERNAL MODULE: ./common/analytics.ts + 10 modules
var analytics = __webpack_require__(87018);
// EXTERNAL MODULE: ./common/bit/utils/utmParams.ts
var utils_utmParams = __webpack_require__(21172);
// EXTERNAL MODULE: ./common/buildShopLink.ts
var buildShopLink = __webpack_require__(90227);
// EXTERNAL MODULE: ./node_modules/next/dist/client/router.js
var client_router = __webpack_require__(90387);
// EXTERNAL MODULE: ./reusable/ButtonBaseBlank.tsx
var ButtonBaseBlank = __webpack_require__(59041);
// EXTERNAL MODULE: ./store.ts + 2 modules
var store = __webpack_require__(13328);
// EXTERNAL MODULE: ./theme/colors.ts
var colors = __webpack_require__(22038);
// EXTERNAL MODULE: ./components/Schedule/getIframeLink.ts
var getIframeLink = __webpack_require__(44039);
// EXTERNAL MODULE: ./components/shopFeatures/wizard/constants.ts
var constants = __webpack_require__(45053);
// EXTERNAL MODULE: ./reusable/popups/ClassicPopUp.tsx
var ClassicPopUp = __webpack_require__(66395);
// EXTERNAL MODULE: ./components/carModelPage/popups/testDrive/TestDrivePopup.tsx + 2 modules
var TestDrivePopup = __webpack_require__(12821);
// EXTERNAL MODULE: ./components/carModelPage/popups/purchaseTools/PurchaseToolsRow.tsx
var PurchaseToolsRow = __webpack_require__(33041);
;// CONCATENATED MODULE: ./components/carModelPage/popups/purchaseTools/PurchaseToolsPopup.tsx



function PurchaseToolsPopup_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  overflow: auto;\n  width: 100%;\n"
    ]);
    PurchaseToolsPopup_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PurchaseToolsPopup_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 10px;\n  background-color: ",
        ";\n  border-radius: 3px;\n  height: 45px;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  cursor: pointer;\n"
    ]);
    PurchaseToolsPopup_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function PurchaseToolsPopup_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  max-width: 300px;\n  align-self: center;\n"
    ]);
    PurchaseToolsPopup_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function PurchaseToolsPopup_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  label {\n    padding-top: 30px;\n  }\n"
    ]);
    PurchaseToolsPopup_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}














var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "PurchaseToolsPopup__StyledWrapper",
    componentId: "sc-f192906b-0"
})(PurchaseToolsPopup_templateObject());
var PurchaseToolsPopup_StyledButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "PurchaseToolsPopup__StyledButton",
    componentId: "sc-f192906b-1"
})(PurchaseToolsPopup_templateObject1(), function(p) {
    return p.$dark ? p.theme.colors.black : p.theme.colors.white;
});
var StyledNextLink = (0,styled_components_browser_esm/* default */.ZP)(NextLink/* default */.Z).withConfig({
    displayName: "PurchaseToolsPopup__StyledNextLink",
    componentId: "sc-f192906b-2"
})(PurchaseToolsPopup_templateObject2());
var StyledTestDrivePopup = (0,styled_components_browser_esm/* default */.ZP)(TestDrivePopup/* default */.Z).withConfig({
    displayName: "PurchaseToolsPopup__StyledTestDrivePopup",
    componentId: "sc-f192906b-3"
})(PurchaseToolsPopup_templateObject3());
var PurchaseToolsPopup = function(param) {
    var onClose = param.onClose, open = param.open, openTestDrivePopup = param.openTestDrivePopup, shopUrl = param.shopUrl, modelId = param.modelId;
    var ref = (0,react.useState)(false), leadFormPopupOpen = ref[0], setLeadFormPopupOpen = ref[1];
    var ref1 = (0,react.useState)([]), showRoomList = ref1[0], setShowRoomList = ref1[1];
    var auth = (0,store/* useTypedSelector */.ix)(function(state) {
        return state;
    }).auth;
    (0,react.useEffect)(function() {
        var fetchData = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var data;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                (0,api/* getShowroomAll */.jz)(null, null).then(api/* extractData */.Kj)
                            ];
                        case 1:
                            data = _state.sent();
                            setShowRoomList(data === null || data === void 0 ? void 0 : data.body);
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchData() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchData().catch(function(error) {
            return console.log(error);
        });
    }, []);
    var userInfo = auth.userInfo;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ClassicPopUp/* default */.Z, {
            open: open,
            onClose: onClose,
            title: "נשמח לעזור לך לבחור",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTestDrivePopup, {
                            open: leadFormPopupOpen,
                            onClose: function() {
                                setLeadFormPopupOpen(false);
                            },
                            showRoomsList: showRoomList,
                            dialogClass: "summaryTestDrive",
                            title: "פגישה באולם תצוגה",
                            modelId: modelId,
                            userInfo: userInfo,
                            buttonText: "תאמו איתי פגישה",
                            analyticName: "showrooms meeting",
                            isShop: true
                        }),
                        (0,getIframeLink/* isModelHasMeetingIframe */.Vs)(modelId) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                            href: "/meeting/".concat(modelId),
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PurchaseToolsRow/* default */.Z, {
                                text: "לתיאום פגישה באולם תצוגה",
                                iconName: "fi_calendar",
                                page: constants/* STEPS_EN.summary */.Ws.summary,
                                onClick: function() {
                                    (0,analytics/* trackPopUpOpen */.W1)("showrooms meeting");
                                }
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PurchaseToolsRow/* default */.Z, {
                            text: "לתיאום פגישה באולם תצוגה",
                            iconName: "fi_calendar",
                            page: constants/* STEPS_EN.summary */.Ws.summary,
                            onClick: function() {
                                setLeadFormPopupOpen(true);
                                (0,analytics/* trackPopUpOpen */.W1)("showrooms meeting");
                            }
                        }),
                        (0,getIframeLink/* isModelHasTestDriveIframe */.yz)(modelId) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                            href: "/test-drive/".concat(modelId),
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PurchaseToolsRow/* default */.Z, {
                                text: "להזמנת נסיעת הדגמה",
                                iconName: "location-pin",
                                onClick: function() {
                                    return openTestDrivePopup(false);
                                }
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PurchaseToolsRow/* default */.Z, {
                            text: "להזמנת נסיעת הדגמה",
                            iconName: "location-pin",
                            onClick: function() {
                                return openTestDrivePopup(true);
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                            href: "/contact-us",
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PurchaseToolsRow/* default */.Z, {
                                text: "יצירת קשר",
                                iconName: "fi_send"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledNextLink, {
                    href: shopUrl,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PurchaseToolsPopup_StyledButton, {
                        $dark: true,
                        onClick: analytics/* trackBuildMazdaPopUp */.L3,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* TypographyCenter */.kc, {
                            $color: colors/* default.white */.Z.white,
                            children: "רכישה Online"
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var purchaseTools_PurchaseToolsPopup = (PurchaseToolsPopup);

;// CONCATENATED MODULE: ./components/carModelPage/navigation/StickyBottomCTA.tsx



function StickyBottomCTA_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  position: sticky;\n  width: 100%;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 5;\n  padding: 20px;\n  z-index: 100;\n"
    ]);
    StickyBottomCTA_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function StickyBottomCTA_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  width: 100%;\n  padding: 4px;\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);\n  border-radius: 5px;\n  max-width: 320px;\n  margin: 0 auto;\n"
    ]);
    StickyBottomCTA_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function StickyBottomCTA_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 3px;\n  height: 45px;\n  width: 100%;\n"
    ]);
    StickyBottomCTA_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function StickyBottomCTA_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  border-radius: 3px;\n  height: 45px;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n"
    ]);
    StickyBottomCTA_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}














var StickyBottomCTA_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "StickyBottomCTA__StyledWrapper",
    componentId: "sc-76dc97fa-0"
})(StickyBottomCTA_templateObject(), function(p) {
    return p.theme.colors.transparent;
});
var StyledCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "StickyBottomCTA__StyledCard",
    componentId: "sc-76dc97fa-1"
})(StickyBottomCTA_templateObject1(), function(p) {
    return p.theme.colors.white;
});
var StyledButtonBaseBlank = (0,styled_components_browser_esm/* default */.ZP)(ButtonBaseBlank/* default */.Z).withConfig({
    displayName: "StickyBottomCTA__StyledButtonBaseBlank",
    componentId: "sc-76dc97fa-2"
})(StickyBottomCTA_templateObject2());
var StyledFakeButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "StickyBottomCTA__StyledFakeButton",
    componentId: "sc-76dc97fa-3"
})(StickyBottomCTA_templateObject3(), function(p) {
    return p.$dark ? p.theme.colors.black : p.theme.colors.white;
});
var StickyBottomCTA = function(param) {
    var setPopupOpen = param.setPopupOpen, numberOfFinishingLevels = param.numberOfFinishingLevels, modelId = param.modelId;
    var ref = (0,react.useState)(false), testDrivePopupOpen = ref[0], setTestDrivePopupOpen = ref[1];
    var ref1 = (0,react.useState)(false), purchaseToolsPopupOpen = ref1[0], setPurchaseToolsPopupOpen = ref1[1];
    var ref2 = (0,react.useState)([]), showRoomsList = ref2[0], setShowRoomList = ref2[1];
    var ref3 = (0,react.useState)(""), utmParams = ref3[0], setUtmParams = ref3[1];
    var detailData = (0,store/* useTypedSelector */.ix)(function(state) {
        return state === null || state === void 0 ? void 0 : state.detailing;
    });
    var detailing = detailData.detailing, color = detailData.color;
    var shopUrl = "".concat((0,buildShopLink/* buildShopLink */.u)(detailing, color, modelId, utmParams));
    var router = (0,client_router.useRouter)();
    (0,react.useEffect)(function() {
        var isComponentMounted = true;
        var fetchData = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var data;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!isComponentMounted) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                (0,api/* getShowroomAll */.jz)(null, null).then(api/* extractData */.Kj)
                            ];
                        case 1:
                            data = _state.sent();
                            setShowRoomList(data === null || data === void 0 ? void 0 : data.body);
                            _state.label = 2;
                        case 2:
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchData() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchData().catch(console.error);
        setUtmParams((0,utils_utmParams/* keepOnlyUtmParams */.p)(window.location.href.split("?")[1] || "" || window.location.search));
        return function() {
            isComponentMounted = false;
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StickyBottomCTA_StyledWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCard, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(shared/* StyledRow */.N0, {
                        $fullWidth: true,
                        $gap: "2px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButtonBaseBlank, {
                                onClick: function() {
                                    return setPurchaseToolsPopupOpen(true);
                                },
                                role: "button",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFakeButton, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(shared/* StyledRow */.N0, {
                                        $fullWidth: true,
                                        $justify: "center",
                                        $gap: "4px",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* TypographyCenter */.kc, {
                                                variant: "body2",
                                                children: "לפעולות נוספות"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* StyledSvgIcon */.vV, {
                                                src: "/icons/fi_chevron-down.svg",
                                                alt: "downArrow",
                                                w: 18,
                                                h: 18
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButtonBaseBlank, {
                                onClick: function() {
                                    (0,analytics/* trackBuildMazdaCTA */.i8)(), router.push(shopUrl);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFakeButton, {
                                    $dark: true,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* TypographyCenter */.kc, {
                                            variant: "body2",
                                            $color: colors/* default.white */.Z.white,
                                            children: "להרכבת המאזדה שלך"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* TypographyCenter */.kc, {
                                            variant: "caption",
                                            $color: colors/* default.darkGrey */.Z.darkGrey,
                                            children: "".concat(numberOfFinishingLevels, " רמות גימור לבחירה")
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(purchaseTools_PurchaseToolsPopup, {
                setPopupOpen: setPopupOpen,
                open: purchaseToolsPopupOpen,
                onClose: function() {
                    return setPurchaseToolsPopupOpen(false);
                },
                openTestDrivePopup: function(openForm) {
                    if (openForm) {
                        setTestDrivePopupOpen(true);
                    }
                    setPurchaseToolsPopupOpen(false);
                },
                modelId: modelId,
                shopUrl: shopUrl,
                numberOfFinishingLevels: numberOfFinishingLevels
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TestDrivePopup/* default */.Z, {
                open: testDrivePopupOpen,
                onClose: function() {
                    return setTestDrivePopupOpen(false);
                },
                showRoomsList: showRoomsList,
                modelId: modelId,
                formType: "test-drive",
                title: "תיאום נסיעת מבחן",
                dialogClass: "mobile-margin"
            })
        ]
    });
};
/* harmony default export */ var navigation_StickyBottomCTA = (StickyBottomCTA);

// EXTERNAL MODULE: ./common/VideoPlayer.tsx
var VideoPlayer = __webpack_require__(25991);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 90 modules
var swiper_esm = __webpack_require__(50067);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 13 modules
var swiper_react = __webpack_require__(22546);
;// CONCATENATED MODULE: ./components/carModelPage/sections/safety/SwiperControllerRow.tsx

function SwiperControllerRow_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  .swiper-button-disabled {\n    display: block;\n    opacity: 0.5;\n    cursor: default;\n    button {\n      cursor: default;\n    }\n    pointer-events: none;\n  }\n"
    ]);
    SwiperControllerRow_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var StyledSwiperControllerRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SwiperControllerRow__StyledSwiperControllerRow",
    componentId: "sc-ceb3c7ee-0"
})(SwiperControllerRow_templateObject());
var SwiperControllerRow = function(param) {
    var className = param.className, prevRef = param.prevRef, nextRef = param.nextRef, trackEvent = param.trackEvent, children = param.children, setActiveIndex = param.setActiveIndex;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSwiperControllerRow, {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: prevRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                    onClick: function() {
                        setActiveIndex && setActiveIndex(function(prev) {
                            return prev === 0 ? 0 : prev - 1;
                        });
                        if (trackEvent) trackEvent();
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* StyledSvgIcon */.vV, {
                        src: "/icons/fi_chevron-right.svg",
                        alt: "right",
                        w: 24,
                        h: 24
                    })
                })
            }),
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: nextRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                    onClick: function() {
                        setActiveIndex && setActiveIndex(function(prev) {
                            return prev + 1;
                        });
                        if (trackEvent) trackEvent();
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* StyledSvgIcon */.vV, {
                        src: "/icons/fi_chevron-left.svg",
                        alt: "left",
                        w: 24,
                        h: 24
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var safety_SwiperControllerRow = (SwiperControllerRow);

;// CONCATENATED MODULE: ./components/carModelPage/sections/drivingExperience/features/FeaturesWrapper.tsx

function FeaturesWrapper_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 90vh;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  max-width: 450px;\n  ",
        " {\n    padding-bottom: 40px;\n  }\n"
    ]);
    FeaturesWrapper_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function FeaturesWrapper_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 32px;\n  margin-top: 41px;\n"
    ]);
    FeaturesWrapper_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function FeaturesWrapper_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    FeaturesWrapper_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function FeaturesWrapper_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.1);\n  }\n  100% {\n    transform: scale(1);\n  }\n"
    ]);
    FeaturesWrapper_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function FeaturesWrapper_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  aspect-ratio: 360/240;\n  position: relative;\n  overflow: hidden;\n  img {\n    width: 250px;\n    height: 250px;\n    animation: ",
        " 1s ease-in-out;\n  }\n  video {\n    clip-path: inset(1px 1px);\n  }\n"
    ]);
    FeaturesWrapper_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function FeaturesWrapper_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    display: flex;\n    flex-direction: column;\n    padding: 0 16px;\n  }\n"
    ]);
    FeaturesWrapper_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}














var StyledWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FeaturesWrapper__StyledWrap",
    componentId: "sc-532b5845-0"
})(FeaturesWrapper_templateObject(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var FeaturesWrapper_StyledSwiperControllerRow = (0,styled_components_browser_esm/* default */.ZP)(safety_SwiperControllerRow).withConfig({
    displayName: "FeaturesWrapper__StyledSwiperControllerRow",
    componentId: "sc-532b5845-1"
})(FeaturesWrapper_templateObject1());
var StyledSwiper = (0,styled_components_browser_esm/* default */.ZP)(swiper_react/* Swiper */.tq).attrs({}).withConfig({
    displayName: "FeaturesWrapper__StyledSwiper",
    componentId: "sc-532b5845-2"
})(FeaturesWrapper_templateObject2());
var zoomInAndOut = (0,styled_components_browser_esm/* keyframes */.F4)(FeaturesWrapper_templateObject3());
var StyledImageContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FeaturesWrapper__StyledImageContainer",
    componentId: "sc-532b5845-3"
})(FeaturesWrapper_templateObject4(), function(p) {
    return p.$zoomIn ? zoomInAndOut : "none";
});
var StyledTextContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FeaturesWrapper__StyledTextContainer",
    componentId: "sc-532b5845-4"
})(FeaturesWrapper_templateObject5(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var GifEnum;
(function(GifEnum) {
    GifEnum["NORMAL"] = "/img/knob/media-knob-inactive.png";
    GifEnum["TURN"] = "/img/knob/media-knob-turn-single.gif";
    GifEnum["CLICK"] = "/img/knob/media-knob-click-single.gif";
})(GifEnum || (GifEnum = {}));
var FeaturesWrapper = function(param) {
    var data = param.data, openFeaturesModel = param.openFeaturesModel;
    var ref;
    var ref1 = (0,react.useState)(false), animating = ref1[0], setAnimating = ref1[1];
    var ref2 = (0,react.useState)(GifEnum.NORMAL), gifSrc = ref2[0], setGifSrc = ref2[1];
    var navigationPrevRef = (0,react.useRef)(null);
    var navigationNextRef = (0,react.useRef)(null);
    var swiperRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        // re load gif with time out
        var timeout = setTimeout(function() {
            setGifSrc(GifEnum.NORMAL);
        }, 1000);
        return function() {
            return clearTimeout(timeout);
        };
    }, [
        gifSrc
    ]);
    var animatePic = function() {
        setGifSrc(GifEnum.CLICK);
        setAnimating(true);
        setTimeout(function() {
            return setAnimating(false);
        }, 1000);
        swiperRef && swiperRef.current.swiper.slideNext();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrap, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSwiper, {
                modules: [
                    swiper_esm/* Navigation */.W_,
                    swiper_esm/* A11y */.s5,
                    swiper_esm/* Keyboard */.N1
                ],
                slidesPerView: 1,
                centeredSlides: true,
                keyboard: {
                    enabled: true
                },
                navigation: {
                    enabled: true,
                    prevEl: navigationPrevRef.current,
                    nextEl: navigationNextRef.current
                },
                onSlideChange: function() {
                    setGifSrc(GifEnum.TURN);
                },
                loop: true,
                ref: swiperRef,
                children: data === null || data === void 0 ? void 0 : (ref = data.displayComponents) === null || ref === void 0 ? void 0 : ref.map(function(item, index) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                        style: {
                            width: "max-content",
                            height: "auto"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImageContainer, {
                                    $zoomIn: animating,
                                    children: (item === null || item === void 0 ? void 0 : item.videoUrl) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoPlayer["default"], {
                                        url: item.videoUrl,
                                        light: false,
                                        label: "mazda",
                                        playingState: true,
                                        loop: true,
                                        imgAlt: item === null || item === void 0 ? void 0 : item.alt,
                                        imgUrlDesktop: item === null || item === void 0 ? void 0 : item.imageUrl,
                                        imgUrlMobile: item === null || item === void 0 ? void 0 : item.imageUrl,
                                        cover: false
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage/* default */.Z, {
                                        image: {
                                            imageUrl: item === null || item === void 0 ? void 0 : item.imageUrl,
                                            alt: item === null || item === void 0 ? void 0 : item.alt
                                        },
                                        cover: false
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTextContainer, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* TypographyCenter */.kc, {
                                            variant: "h2",
                                            $mb: "10px",
                                            $mt: "10px",
                                            children: item === null || item === void 0 ? void 0 : item.name
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* TypographyCenter */.kc, {
                                            variant: "body1",
                                            $color: colors/* default.disable */.Z.disable,
                                            children: item === null || item === void 0 ? void 0 : item.description
                                        })
                                    ]
                                })
                            ]
                        })
                    }, index);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturesWrapper_StyledSwiperControllerRow, {
                prevRef: navigationPrevRef,
                nextRef: navigationNextRef,
                trackEvent: analytics/* trackSpinModelPageClicks */.uW,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonBaseBlank/* default */.Z, {
                    onClick: function() {
                        animatePic();
                        (0,analytics/* trackSpinModelPageClicks */.uW)();
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: gifSrc,
                        alt: "knob",
                        width: 94,
                        height: 86,
                        lazyBoundary: "800px"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                variant: "contained",
                onClick: openFeaturesModel,
                children: "לפיצ׳רים נוספים"
            })
        ]
    });
};
/* harmony default export */ var features_FeaturesWrapper = (FeaturesWrapper);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ButtonBase/ButtonBase.js + 4 modules
var ButtonBase = __webpack_require__(41810);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/CircularProgress/CircularProgress.js
var CircularProgress = __webpack_require__(95477);
// EXTERNAL MODULE: ./node_modules/react-countup/build/index.js
var build = __webpack_require__(17857);
// EXTERNAL MODULE: ./node_modules/react-intersection-observer/react-intersection-observer.modern.mjs
var react_intersection_observer_modern = __webpack_require__(97650);
// EXTERNAL MODULE: ./node_modules/use-long-press/dist/index.module.js
var index_module = __webpack_require__(19287);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_extends.mjs
var _extends = __webpack_require__(40872);
;// CONCATENATED MODULE: ./reusable/icons/IgnationIcon.tsx





var SvgComponent = function(_param) {
    var props = (0,_extends/* default */.Z)({}, _param);
    var w = 140;
    var h = 140;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: w,
        height: h,
        viewBox: "0 0 140 140",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                filter: "url(#filter1_di_4131_322278)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    x: "20",
                    y: "20",
                    width: "100",
                    height: "100",
                    rx: "50",
                    fill: "#F5F5F5"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                filter: "url(#filter2_i_4131_322278)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        x: "29",
                        y: "29",
                        width: "82",
                        height: "82",
                        rx: "41",
                        fill: "#F5F5F5"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                        filter: "url(#filter3_i_4131_322278)",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M76.3611 64.6406C77.6195 65.8994 78.4764 67.5031 78.8234 69.2488C79.1704 70.9946 78.992 72.804 78.3107 74.4484C77.6295 76.0927 76.4759 77.4982 74.9959 78.487C73.5159 79.4758 71.776 80.0035 69.9961 80.0035C68.2162 80.0035 66.4762 79.4758 64.9963 78.487C63.5163 77.4982 62.3627 76.0927 61.6815 74.4484C61.0002 72.804 60.8218 70.9946 61.1688 69.2488C61.5158 67.5031 62.3727 65.8994 63.6311 64.6406",
                                stroke: "#910A2D",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M70 60V70",
                                stroke: "#910A2D",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                        id: "filter1_di_4131_322278",
                        x: "10",
                        y: "10",
                        width: "120",
                        height: "124",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feOffset", {
                                dy: "4"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                                stdDeviation: "5"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_4131_322278"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_4131_322278",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feOffset", {
                                dy: "-10"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                                stdDeviation: "5"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect2_innerShadow_4131_322278"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                        id: "filter2_i_4131_322278",
                        x: "29",
                        y: "29",
                        width: "82",
                        height: "92",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "BackgroundImageFix",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feOffset", {
                                dy: "10"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                                stdDeviation: "5"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect1_innerShadow_4131_322278"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                        id: "filter3_i_4131_322278",
                        x: "58",
                        y: "58",
                        width: "24",
                        height: "25",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "BackgroundImageFix",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feOffset", {
                                dy: "1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                                stdDeviation: "0.75"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.9875 0 0 0 0 0.164583 0 0 0 0 0.377932 0 0 0 1 0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect1_innerShadow_4131_322278"
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var IgnationIcon = (SvgComponent);

;// CONCATENATED MODULE: ./reusable/icons/InfoIcon.tsx





var InfoIcon_SvgComponent = function(_param) {
    var props = (0,_extends/* default */.Z)({}, _param);
    var w = 42;
    var h = 42;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: w,
        height: h,
        viewBox: "0 0 52 52",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                filter: "url(#filter0_i_4131_322301)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        x: "1",
                        y: "1",
                        width: "50",
                        height: "50",
                        rx: "25",
                        fill: "#F5F5F5"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        x: "0.5",
                        y: "0.5",
                        width: "51",
                        height: "51",
                        rx: "25.5",
                        stroke: "white"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                filter: "url(#filter1_i_4131_322301)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        x: "5.5",
                        y: "5.5",
                        width: "41",
                        height: "41",
                        rx: "20.5",
                        fill: "#F5F5F5"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M26 36C31.5228 36 36 31.5228 36 26C36 20.4772 31.5228 16 26 16C20.4772 16 16 20.4772 16 26C16 31.5228 20.4772 36 26 36Z",
                        stroke: "#616161",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M26 30V26",
                        stroke: "#616161",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M26 22H26.01",
                        stroke: "#616161",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                        id: "filter0_i_4131_322301",
                        x: "0",
                        y: "-10",
                        width: "52",
                        height: "62",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "BackgroundImageFix",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feOffset", {
                                dy: "-10"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                                stdDeviation: "5"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect1_innerShadow_4131_322301"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                        id: "filter1_i_4131_322301",
                        x: "5.5",
                        y: "5.5",
                        width: "41",
                        height: "51",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "BackgroundImageFix",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feOffset", {
                                dy: "10"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                                stdDeviation: "5"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect1_innerShadow_4131_322301"
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var InfoIcon = (InfoIcon_SvgComponent);

;// CONCATENATED MODULE: ./reusable/icons/VolumeIcon.tsx





var VolumeIcon_SvgComponent = function(_param) {
    var props = (0,_extends/* default */.Z)({}, _param);
    var w = 42;
    var h = 42;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: w,
        height: h,
        viewBox: "0 0 52 52",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                filter: "url(#filter0_i_4131_322302)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        x: "1",
                        y: "1",
                        width: "50",
                        height: "50",
                        rx: "25",
                        fill: "#F5F5F5"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        x: "0.5",
                        y: "0.5",
                        width: "51",
                        height: "51",
                        rx: "25.5",
                        stroke: "white"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                filter: "url(#filter1_i_4131_322302)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        x: "5.5",
                        y: "5.5",
                        width: "41",
                        height: "41",
                        rx: "20.5",
                        fill: "#F5F5F5"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M25 19L20 23H16V29H20L25 33V19Z",
                        stroke: "#616161",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M33.0691 18.9297C34.9438 20.805 35.9969 23.348 35.9969 25.9997C35.9969 28.6513 34.9438 31.1944 33.0691 33.0697M29.5391 22.4597C30.4764 23.3973 31.003 24.6689 31.003 25.9947C31.003 27.3205 30.4764 28.592 29.5391 29.5297",
                        stroke: "#616161",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                        id: "filter0_i_4131_322302",
                        x: "0",
                        y: "-10",
                        width: "52",
                        height: "62",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "BackgroundImageFix",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feOffset", {
                                dy: "-10"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                                stdDeviation: "5"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect1_innerShadow_4131_322302"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                        id: "filter1_i_4131_322302",
                        x: "5.5",
                        y: "5.5",
                        width: "41",
                        height: "51",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "BackgroundImageFix",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feOffset", {
                                dy: "10"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                                stdDeviation: "5"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect1_innerShadow_4131_322302"
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var VolumeIcon = (VolumeIcon_SvgComponent);

;// CONCATENATED MODULE: ./reusable/icons/VolumeMuteIcon.tsx





var VolumeMuteIcon_SvgComponent = function(_param) {
    var props = (0,_extends/* default */.Z)({}, _param);
    var w = 42;
    var h = 42;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: w,
        height: h,
        viewBox: "0 0 52 52",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                filter: "url(#filter0_i_4877_95904)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        x: "1",
                        y: "1",
                        width: "50",
                        height: "50",
                        rx: "25",
                        fill: "#F5F5F5"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        x: "0.5",
                        y: "0.5",
                        width: "51",
                        height: "51",
                        rx: "25.5",
                        stroke: "white"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                filter: "url(#filter1_i_4877_95904)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        x: "5.5",
                        y: "5.5",
                        width: "41",
                        height: "41",
                        rx: "20.5",
                        fill: "#F5F5F5"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M37 23L31 29",
                        stroke: "#616161",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M31 23L37 29",
                        stroke: "#616161",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M25 19L20 23H16V29H20L25 33V19Z",
                        stroke: "#616161",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                        id: "filter0_i_4877_95904",
                        x: "0",
                        y: "-10",
                        width: "52",
                        height: "62",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "BackgroundImageFix",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feOffset", {
                                dy: "-10"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                                stdDeviation: "5"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect1_innerShadow_4877_95904"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                        id: "filter1_i_4877_95904",
                        x: "5.5",
                        y: "5.5",
                        width: "41",
                        height: "51",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "BackgroundImageFix",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feOffset", {
                                dy: "10"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                                stdDeviation: "5"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect1_innerShadow_4877_95904"
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var VolumeMuteIcon = (VolumeMuteIcon_SvgComponent);

;// CONCATENATED MODULE: ./components/carModelPage/sections/drivingExperience/performance/PerformanceNumber.tsx

function PerformanceNumber_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  height: 1px;\n  opacity: 0.3;\n  min-width: 100px;\n  max-width: 100%;\n"
    ]);
    PerformanceNumber_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PerformanceNumber_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  margin-right: 10px;\n  margin-left: 10px;\n"
    ]);
    PerformanceNumber_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function PerformanceNumber_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ';\n  font-size: 20px;\n  fontfamily: "MazdaType, OENaPro, sans-serif;";\n'
    ]);
    PerformanceNumber_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function PerformanceNumber_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    PerformanceNumber_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var StyledLine = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "PerformanceNumber__StyledLine",
    componentId: "sc-7d4d7485-0"
})(PerformanceNumber_templateObject(), function(p) {
    return p.theme.colors.disable;
});
var StyledLineWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "PerformanceNumber__StyledLineWrapper",
    componentId: "sc-7d4d7485-1"
})(PerformanceNumber_templateObject1());
var StyledNumber = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "PerformanceNumber__StyledNumber",
    componentId: "sc-7d4d7485-2"
})(PerformanceNumber_templateObject2(), function(p) {
    return p.theme.colors.black;
});
var StyledText = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
    variant: "caption"
}).withConfig({
    displayName: "PerformanceNumber__StyledText",
    componentId: "sc-7d4d7485-3"
})(PerformanceNumber_templateObject3());
var PerformanceNumber = function(param) {
    var reference = param.reference, text = param.text, press = param.press, number = param.number;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLineWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledNumber, {
                ref: reference,
                children: !press && number
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLine, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledText, {
                children: text
            })
        ]
    });
};
/* harmony default export */ var performance_PerformanceNumber = (PerformanceNumber);

;// CONCATENATED MODULE: ./components/carModelPage/sections/drivingExperience/performance/PerformanceWrapper.tsx






function PerformanceWrapper_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-height: 90vh;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  max-width: 450px;\n  justify-content: center;\n  ",
        " {\n    padding-bottom: 80px;\n  }\n"
    ]);
    PerformanceWrapper_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PerformanceWrapper_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: 18px;\n  font-weight: 400;\n"
    ]);
    PerformanceWrapper_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function PerformanceWrapper_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  text-align: center;\n  font-size: 24px;\n  font-weight: 400;\n  ",
        " {\n    width: 90%;\n  }\n"
    ]);
    PerformanceWrapper_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function PerformanceWrapper_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 236px;\n  height: 253px;\n  margin-top: 20px;\n  video {\n    clip-path: inset(1px 1px);\n  }\n"
    ]);
    PerformanceWrapper_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function PerformanceWrapper_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  margin-top: 20px;\n  ",
        " {\n    overflow: hidden;\n    width: 100%;\n    justify-content: center;\n  }\n"
    ]);
    PerformanceWrapper_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function PerformanceWrapper_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  margin-top: 20px;\n  justify-content: center;\n  ",
        " {\n    width: 100%;\n  }\n"
    ]);
    PerformanceWrapper_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  position: relative;\n  width: 140px;\n  height: 140px;\n  .MuiCircularProgress-root {\n    position: absolute;\n    width: 100% !important;\n    height: 100% !important;\n    left: 0px;\n    border-radius: 50%;\n    background: ",
        ";\n    box-shadow: 0px 0px 19px rgb(0 0 0 / 22%),\n      inset 0px -10px 10px rgb(0 0 0 / 4%);\n  }\n\n  .MuiCircularProgress-circleDeterminate {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  outline: none;\n  border: none;\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  background: none;\n  cursor: pointer;\n  user-select: none;\n  svg {\n    position: relative;\n    z-index: 1;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}














var PerformanceWrapper_VideoPlayer = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 25991));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(25991)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            children: "..."
        });
    }
});
var StyledSectionWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "PerformanceWrapper__StyledSectionWrapper",
    componentId: "sc-70c5c5e1-0"
})(PerformanceWrapper_templateObject(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledCaption = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
    variant: "h2"
}).withConfig({
    displayName: "PerformanceWrapper__StyledCaption",
    componentId: "sc-70c5c5e1-1"
})(PerformanceWrapper_templateObject1(), function(p) {
    return p.theme.colors.disable;
});
var StyledTitle = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
    variant: "h3"
}).withConfig({
    displayName: "PerformanceWrapper__StyledTitle",
    componentId: "sc-70c5c5e1-2"
})(PerformanceWrapper_templateObject2(), function(p) {
    return p.theme.colors.black;
}, function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledVideoWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "PerformanceWrapper__StyledVideoWrapper",
    componentId: "sc-70c5c5e1-3"
})(PerformanceWrapper_templateObject3());
var StyledInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "PerformanceWrapper__StyledInfo",
    componentId: "sc-70c5c5e1-4"
})(PerformanceWrapper_templateObject4(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var ActionWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "PerformanceWrapper__ActionWrapper",
    componentId: "sc-70c5c5e1-5"
})(PerformanceWrapper_templateObject5(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var SvgWrapperButton = (0,styled_components_browser_esm/* default */.ZP)(ButtonBase/* default */.Z).withConfig({
    displayName: "PerformanceWrapper__SvgWrapperButton",
    componentId: "sc-70c5c5e1-6"
})(_templateObject6(), function(p) {
    return p.theme.colors.gainsboro;
}, function(p) {
    return p.theme.colors.mazdaRed;
});
var StyledButtonDiv = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "PerformanceWrapper__StyledButtonDiv",
    componentId: "sc-70c5c5e1-7"
})(_templateObject7());
var PerformanceWrapper = function(param) {
    var drivingExpirience = param.drivingExpirience, setModalOpen = param.setModalOpen;
    var data = drivingExpirience === null || drivingExpirience === void 0 ? void 0 : drivingExpirience.engine[0];
    var ref = (0,react.useState)(0), progress = ref[0], setProgress = ref[1];
    var ref1 = (0,react.useState)(false), videoPlay = ref1[0], setVideoPlay = ref1[1];
    var ref2 = (0,react.useState)(false), press = ref2[0], setPressed = ref2[1];
    var ref3 = (0,react.useState)(false), longPressFinished = ref3[0], setLongPressFinished = ref3[1];
    var ref4 = (0,react.useState)(false), muted = ref4[0], setMuted = ref4[1];
    var playPromiseRef = (0,react.useRef)(null);
    var audioRef = (0,react.useRef)(null);
    var numbers = (0,react.useMemo)(function() {
        var ref, ref1;
        return {
            first: (data === null || data === void 0 ? void 0 : data.engineIdName) ? data.engineIdName.substring(0, data.engineIdName.length - 1) : "3.5",
            second: ((ref = data === null || data === void 0 ? void 0 : data.performanceItems[1]) === null || ref === void 0 ? void 0 : ref.value) ? data.performanceItems[1].value : "0",
            third: ((ref1 = data === null || data === void 0 ? void 0 : data.performanceItems[2]) === null || ref1 === void 0 ? void 0 : ref1.value) ? data.performanceItems[2].value : "0"
        };
    }, [
        drivingExpirience
    ]);
    var ref11 = (0,react.useRef)(null);
    var ref21 = (0,react.useRef)(null);
    var ref31 = (0,react.useRef)(null);
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,react_intersection_observer_modern/* useInView */.YD)({
        threshold: 0,
        triggerOnce: true
    }), 2), refInView = ref5[0], inView = ref5[1];
    var ref6 = (0,build/* useCountUp */.$i)({
        ref: ref11,
        start: 0,
        end: 5,
        decimals: 1,
        delay: 1000,
        duration: 5,
        suffix: "L"
    }), reset1 = ref6.reset, update1 = ref6.update;
    var ref7 = (0,build/* useCountUp */.$i)({
        ref: ref21,
        start: 0,
        end: 5,
        decimals: 1,
        delay: 1000,
        duration: 5
    }), reset2 = ref7.reset, update2 = ref7.update;
    var ref8 = (0,build/* useCountUp */.$i)({
        ref: ref31,
        start: 0,
        end: 5,
        decimals: 1,
        delay: 1000,
        duration: 5
    }), reset3 = ref8.reset, update3 = ref8.update;
    var finishedLongPress = (0,react.useCallback)(function() {
        setLongPressFinished(true);
    // trigger after 5 seconds
    }, []);
    var longPressBtnBind = (0,index_module/* useLongPress */.TA)(finishedLongPress, {
        //long press events
        onStart: function() {
            return onStartPress();
        },
        onFinish: function() {
            return onFinishPress();
        },
        onCancel: function() {
            return onFinishPress();
        },
        threshold: 5000,
        captureEvent: true,
        cancelOnMovement: false,
        detect: index_module/* LongPressDetectEvents.BOTH */.sy.BOTH
    });
    (0,react.useEffect)(function() {
        //fill progress bar on button press
        if (press) {
            var timer = setInterval(function() {
                setProgress(function(prevProgress) {
                    return prevProgress >= 100 ? 100 : prevProgress + 2;
                });
            }, 100);
            return function() {
                clearInterval(timer);
            };
        }
    }, [
        press
    ]);
    (0,react.useEffect)(function() {
        if (inView) {
            resetNumbers();
            updateNumbers();
        }
    }, [
        inView
    ]);
    var updateNumbers = function() {
        update1(numbers.first.replace(/,/g, "."));
        update2(numbers.second.replace(/,/g, "."));
        update3(numbers.third.replace(/,/g, "."));
    };
    var resetNumbers = function() {
        reset1();
        reset2();
        reset3();
    };
    var onStartPress = function() {
        toggleAudio();
        setProgress(0);
        setPressed(true);
        setVideoPlay(true);
        setLongPressFinished(false);
        resetNumbers();
        updateNumbers();
        setTimeout(function() {
            if (navigator && navigator.vibrate) {
                navigator.vibrate([
                    100,
                    30,
                    100,
                    30,
                    100,
                    30,
                    1000,
                    500,
                    1000,
                    500,
                    1000, 
                ]);
            }
        }, 50);
    };
    var onFinishPress = function() {
        setVideoPlay(false);
        toggleAudio();
        if (!longPressFinished) {
            resetNumbers();
        }
        setPressed(false);
        setProgress(0);
    };
    var toggleAudio = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var audio, err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(audioRef && audioRef.current)) return [
                            3,
                            6
                        ];
                        audio = audioRef.current;
                        if (!audio.paused) return [
                            3,
                            5
                        ];
                        playPromiseRef.current = audio.play();
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            playPromiseRef.current
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        err = _state.sent();
                        console.error(err);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            3,
                            6
                        ];
                    case 5:
                        if (playPromiseRef.current) {
                            playPromiseRef.current.then(function() {
                                audio.pause();
                            }).catch(function(err) {
                                console.error(err);
                            });
                        }
                        _state.label = 6;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function toggleAudio() {
            return _ref.apply(this, arguments);
        };
    }();
    var toggleAudioMute = function() {
        setMuted(!muted);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSectionWrapper, {
        ref: refInView,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("audio", {
                id: "myAudio",
                src: "/voice/2A-ENGINES.mp3",
                ref: audioRef,
                muted: muted
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCaption, {
                children: (data === null || data === void 0 ? void 0 : data.engineName) ? data.engineName : "Skyactive G 2.5L"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTitle, {
                children: (data === null || data === void 0 ? void 0 : data.engineDescription) ? data.engineDescription : "חווית נהיגה היא קודם כל מנוע איכותי"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledVideoWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PerformanceWrapper_VideoPlayer, {
                    url: data === null || data === void 0 ? void 0 : data.engineImage.imageUrl,
                    light: false,
                    label: "מנוע",
                    playingState: videoPlay,
                    loop: true,
                    imgAlt: "engine",
                    imgUrlDesktop: "/img/engine.png",
                    imgUrlMobile: "/img/engine.png",
                    onBufferEnd: function() {
                        if (videoPlay) {
                            setVideoPlay(false);
                            setVideoPlay(true);
                        }
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledInfo, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(performance_PerformanceNumber, {
                        reference: ref11,
                        text: "נפח (ליטרים)",
                        press: press,
                        number: "".concat(parseInt(numbers.first.replace(/,/g, ".")).toFixed(1), "L")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(performance_PerformanceNumber, {
                        reference: ref21,
                        text: "הספק (כ״ס)",
                        press: press,
                        number: parseInt(numbers.second.replace(/,/g, ".")).toFixed(1)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(performance_PerformanceNumber, {
                        reference: ref31,
                        text: "האצה 0-100 (שניות)",
                        press: press,
                        number: parseInt(numbers.third.replace(/,/g, ".")).toFixed(1)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ActionWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgWrapperButton, {
                        onClick: function() {
                            return setModalOpen(true);
                        },
                        disableRipple: true,
                        "aria-label": "more information",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoIcon, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgWrapperButton, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, longPressBtnBind()), {
                        disableRipple: true,
                        "aria-label": "start ignation",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButtonDiv, {
                                onClick: function() {
                                    return (0,analytics/* trackEngineModelPageClicks */.XL)();
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IgnationIcon, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                                variant: "determinate",
                                value: press ? progress : 0,
                                thickness: 6
                            })
                        ]
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgWrapperButton, {
                        onClick: function() {
                            return toggleAudioMute();
                        },
                        disableRipple: true,
                        "aria-label": "".concat(muted ? "unmute" : "mute"),
                        children: muted ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VolumeMuteIcon, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(VolumeIcon, {})
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var performance_PerformanceWrapper = (PerformanceWrapper);

;// CONCATENATED MODULE: ./components/carModelPage/sections/drivingExperience/DrivingExperienceSection.tsx

function DrivingExperienceSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  background: ",
        ";\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  ",
        " {\n    padding-top: 40px;\n  }\n"
    ]);
    DrivingExperienceSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var PerformanceModal = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5074).then(__webpack_require__.bind(__webpack_require__, 25074));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(25074)
            ];
        }
    },
    ssr: false
});
var FeaturesPopup = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9025).then(__webpack_require__.bind(__webpack_require__, 9025));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9025)
            ];
        }
    },
    ssr: false
});
var DrivingExperienceSection_StyledSectionWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "DrivingExperienceSection__StyledSectionWrapper",
    componentId: "sc-a73c5e4b-0"
})(DrivingExperienceSection_templateObject(), function(p) {
    return p.theme.colors.lightGrey;
}, function(p) {
    return p.theme.breakpoints.down("sm");
});
var DrivingExperienceSection = function(param) {
    var drivingExpirience = param.drivingExpirience, modelName = param.modelName, modelImge = param.modelImge;
    var ref;
    var ref1 = (0,react.useState)(false), modalOpen = ref1[0], setModalOpen = ref1[1];
    var ref2 = (0,react.useState)(false), featuresOpen = ref2[0], setFeaturesOpen = ref2[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DrivingExperienceSection_StyledSectionWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(performance_PerformanceWrapper, {
                drivingExpirience: drivingExpirience,
                setModalOpen: setModalOpen
            }),
            (drivingExpirience === null || drivingExpirience === void 0 ? void 0 : drivingExpirience.displayComponents) && (drivingExpirience === null || drivingExpirience === void 0 ? void 0 : (ref = drivingExpirience.displayComponents) === null || ref === void 0 ? void 0 : ref.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(features_FeaturesWrapper, {
                data: drivingExpirience,
                openFeaturesModel: function() {
                    return setFeaturesOpen(true);
                }
            }),
            modalOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(PerformanceModal, {
                modalOpen: modalOpen,
                setModalOpen: setModalOpen,
                modelName: modelName,
                data: drivingExpirience,
                modelImge: modelImge
            }),
            featuresOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturesPopup, {
                open: featuresOpen,
                onClose: function() {
                    return setFeaturesOpen(false);
                },
                modelName: modelName,
                data: drivingExpirience.moreInfoComponents
            })
        ]
    });
};
/* harmony default export */ var drivingExperience_DrivingExperienceSection = (DrivingExperienceSection);

// EXTERNAL MODULE: ./components/carModelPage/reusable/VideoModelFullScreen.tsx
var VideoModelFullScreen = __webpack_require__(15642);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 152 modules
var motion = __webpack_require__(21325);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/value/use-transform.mjs + 4 modules
var use_transform = __webpack_require__(23526);
;// CONCATENATED MODULE: ./components/carModelPage/reusable/ModelTextSection.tsx

function ModelTextSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 600px;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  background-color: ",
        ";\n  justify-content: center;\n  align-items: center;\n  padding: 20px 20px 50px 20px;\n  position: relative;\n"
    ]);
    ModelTextSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ModelTextSection_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  color: ",
        ";\n  max-width: 500px;\n  font-family: MazdaType, OENaPro, sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 24px;\n  line-height: 140%;\n  transition: all 0.5s ease-in-out;\n  background-size: 100% !important;\n  background-clip: text !important;\n  -webkit-background-clip: text !important;\n  color: ",
        ";\n  transform-origin: 0%;\n  ",
        " {\n    font-size: 28px;\n  }\n  ",
        " {\n    white-space: pre-wrap;\n  }\n"
    ]);
    ModelTextSection_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var ModelTextSection_StyledSectionWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ModelTextSection__StyledSectionWrapper",
    componentId: "sc-5f37d49e-0"
})(ModelTextSection_templateObject(), function(p) {
    return p.theme.colors.black;
});
var ModelTextSection_StyledText = (0,styled_components_browser_esm/* default */.ZP)(motion/* motion.h2 */.E.h2).withConfig({
    displayName: "ModelTextSection__StyledText",
    componentId: "sc-5f37d49e-1"
})(ModelTextSection_templateObject1(), function(p) {
    return p.theme.colors.darkGrey;
}, function(p) {
    return p.theme.colors.transparent;
}, function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return p.theme.breakpoints.down("sm");
});
function useBackroundChange(value) {
    // value,
    // Map x from these values:[0, 1],
    // Into these values:
    //  [-distance, distance]
    return (0,use_transform/* useTransform */.H)(value, [
        0,
        0.5
    ], [
        "linear-gradient(4.83deg, rgba(255, 255, 255, 0) 67.38%, #FFFFFF 293.68%)",
        "linear-gradient(82.94deg, rgba(255, 255, 255, 0) -219.49%, #FFFFFF 0.17%)", 
    ]);
}
var ModelTextSection = function(param) {
    var text = param.text;
    var ref = (0,react.useRef)(null);
    var scrollYProgress = (0,use_scroll/* useScroll */.v)({
        target: ref,
        offset: [
            "end",
            "start"
        ]
    }).scrollYProgress;
    // const [hookedYPostion, setHookedYPosition] = useState("0%")
    // useEffect(() => {
    //   scrollYProgress.onChange((v) => setHookedYPosition(`${v * 100}%`))
    // }, [scrollYProgress])
    var background = useBackroundChange(scrollYProgress);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModelTextSection_StyledSectionWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            ref: ref,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModelTextSection_StyledText, {
                style: {
                    background: background
                },
                children: text
            })
        })
    });
};
/* harmony default export */ var reusable_ModelTextSection = (ModelTextSection);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
;// CONCATENATED MODULE: ./reusable/icons/RoundSliderIcon.tsx






var RoundSliderIcon_SvgComponent = function(_param) {
    var _color = _param.color, color = _color === void 0 ? colors/* default.coffeeBrown */.Z.coffeeBrown : _color, props = (0,_object_without_properties/* default */.Z)(_param, [
        "color"
    ]);
    var w = 61;
    var h = 50;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 ".concat(w, " ").concat(h),
        width: w,
        height: h,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                filter: "url(#filter0_b_3751_71854)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        x: "0.5",
                        width: "60",
                        height: "50",
                        rx: "25",
                        fill: "black",
                        fillOpacity: "0.2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M26.5 20.5L22 25L26.5 29.5",
                        stroke: "white",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M34.5 29.5L39 25L34.5 20.5",
                        stroke: "white",
                        strokeWidth: "2",
                        strokeLinecap: "square"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        x: "1.5",
                        y: "1",
                        width: "58",
                        height: "48",
                        rx: "24",
                        stroke: "white",
                        strokeWidth: "2"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                    id: "filter0_b_3751_71854",
                    x: "-10.5",
                    y: "-11",
                    width: "82",
                    height: "72",
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                            in: "BackgroundImageFix",
                            stdDeviation: "5.5"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feComposite", {
                            in2: "SourceAlpha",
                            operator: "in",
                            result: "effect1_backgroundBlur_3751_71854"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                            mode: "normal",
                            in: "SourceGraphic",
                            in2: "effect1_backgroundBlur_3751_71854",
                            result: "shape"
                        })
                    ]
                })
            })
        ]
    }));
};
/* harmony default export */ var RoundSliderIcon = (RoundSliderIcon_SvgComponent);

// EXTERNAL MODULE: ./node_modules/react-range/lib/index.js
var lib = __webpack_require__(94398);
;// CONCATENATED MODULE: ./components/carModelPage/sections/exterior/comparisonSlider/utils.ts
var aspectRatioRegex = new RegExp(/(\d+)(:|x)(\d+)/);
function calculateAspectRatio(ratio) {
    var asNumber = Number(ratio);
    var asString = String(ratio);
    var isNumber = !isNaN(asNumber);
    if (isNumber) {
        return 1 / asNumber * 100;
    } else {
        var match = asString.match(aspectRatioRegex);
        if (!match) throw Error('Please use a valid aspect ratio delimeter, either "x" or ":"');
        var width = Number(match[1]);
        var height = Number(match[3]);
        return height / width * 100;
    }
}
function isFunction(functionToCheck) {
    return functionToCheck && ({}).toString.call(functionToCheck) === "[object Function]";
}

;// CONCATENATED MODULE: ./components/carModelPage/sections/exterior/comparisonSlider/ComparisonSlider.tsx



function ComparisonSlider_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  position: absolute;\n  direction: ltr;\n"
    ]);
    ComparisonSlider_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ComparisonSlider_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: transparent;\n  z-index: 10;\n"
    ]);
    ComparisonSlider_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ComparisonSlider_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    ComparisonSlider_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ComparisonSlider_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  > * {\n    height: 100%;\n  }\n  > *:not(style) + * {\n    height: unset;\n  }\n"
    ]);
    ComparisonSlider_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ComparisonSlider_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 0px;\n  position: relative;\n"
    ]);
    ComparisonSlider_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ComparisonSlider_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  pointer-events: all;\n\n  // This causes the thumb to be located further down the\n  // page. This does not reflect the current state of the Figma\n  // since there is drift between the figma and how the client\n  // wants the site to look.\n  flex: 3 1 0%;\n\n  :last-child {\n    flex: 1 1 0%;\n  }\n"
    ]);
    ComparisonSlider_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function ComparisonSlider_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 16px;\n  height: 16px;\n  background: ",
        ";\n  border-radius: 100%;\n  border: 1px solid transparent;\n  &:focus {\n    outline: none;\n    box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.25);\n    border-color: rgba(0, 0, 0, 1);\n  }\n"
    ]);
    ComparisonSlider_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function ComparisonSlider_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  &:focus {\n    outline: none;\n  }\n  transform: translate(0, 20px);\n"
    ]);
    ComparisonSlider_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}






var PinnedDiv = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ComparisonSlider__PinnedDiv",
    componentId: "sc-1d4019b1-0"
})(ComparisonSlider_templateObject());
var Track = (0,styled_components_browser_esm/* default */.ZP)(PinnedDiv).withConfig({
    displayName: "ComparisonSlider__Track",
    componentId: "sc-1d4019b1-1"
})(ComparisonSlider_templateObject1());
var RangeWrap = (0,styled_components_browser_esm/* default */.ZP)(PinnedDiv).withConfig({
    displayName: "ComparisonSlider__RangeWrap",
    componentId: "sc-1d4019b1-2"
})(ComparisonSlider_templateObject2());
var Element = (0,styled_components_browser_esm/* default */.ZP)(PinnedDiv).withConfig({
    displayName: "ComparisonSlider__Element",
    componentId: "sc-1d4019b1-3"
})(ComparisonSlider_templateObject3());
var AspectWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ComparisonSlider__AspectWrap",
    componentId: "sc-1d4019b1-4"
})(ComparisonSlider_templateObject4());
var HandleDecoration = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ComparisonSlider__HandleDecoration",
    componentId: "sc-1d4019b1-5"
})(ComparisonSlider_templateObject5());
var Handle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ComparisonSlider__Handle",
    componentId: "sc-1d4019b1-6"
})(ComparisonSlider_templateObject6(), function(p) {
    return p.theme.colors.white;
});
var HandleCanvasWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ComparisonSlider__HandleCanvasWrap",
    componentId: "sc-1d4019b1-7"
})(ComparisonSlider_templateObject7());
var HandleWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ComparisonSlider__HandleWrap",
    componentId: "sc-1d4019b1-8"
})(_templateObject8());
var DefaultHandle = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Handle, (0,_object_spread/* default */.Z)({}, props));
};
var ComparisonSlider = function(param) {
    var itemOne = param.itemOne, itemTwo = param.itemTwo, aspectRatio = param.aspectRatio, _height = param.height, height = _height === void 0 ? null : _height, defaultValue = param.defaultValue, value = param.value, _handle = param.handle, handle = _handle === void 0 ? DefaultHandle : _handle, _handleBefore = param.handleBefore, handleBefore = _handleBefore === void 0 ? null : _handleBefore, _handleAfter = param.handleAfter, handleAfter = _handleAfter === void 0 ? null : _handleAfter, _orientation = param.orientation, orientation = _orientation === void 0 ? "horizontal" : _orientation, _onValueChange = param.onValueChange, onValueChange = _onValueChange === void 0 ? function() {} : _onValueChange, _onlyHandleDraggable = param.onlyHandleDraggable, onlyHandleDraggable = _onlyHandleDraggable === void 0 ? false : _onlyHandleDraggable;
    var ref = (0,react.useState)(false), focused = ref[0], setFocused = ref[1];
    var ref1 = (0,react.useState)(defaultValue), localValue = ref1[0], setLocalValue = ref1[1];
    var ref2 = (0,react.useState)(""), location = ref2[0], setLocation = ref2[1];
    (0,react.useEffect)(function() {
        // only on client side
        if (false) {}
        // Populate location of current page
        setLocation(window.location.pathname);
        var handleCanvasWrapElement = document.getElementById("handleCanvasWrap");
        var disableBackSwipe = function(e) {
            (0,analytics/* trackImageSliderModelPage */.cG)();
            e.preventDefault();
        };
        if (handleCanvasWrapElement) {
            handleCanvasWrapElement.addEventListener("touchstart", disableBackSwipe);
        }
        return function() {
            if (handleCanvasWrapElement) {
                handleCanvasWrapElement.removeEventListener("touchstart", disableBackSwipe);
            }
        };
    }, []);
    var isControlled = typeof defaultValue === "undefined" && typeof value !== "undefined";
    var isHorizontal = orientation === "horizontal";
    var sliderValue = isControlled ? value : localValue;
    var clipPath = isHorizontal ? "polygon(".concat(sliderValue, "% 0, 100% 0%, 100% 100%, ").concat(sliderValue, "% 100%)") : "polygon(0% 100%, 0% ".concat(100 - sliderValue, "%, 100% ").concat(100 - sliderValue, "%, 100% 100%)");
    var padding = height ? height : "".concat(calculateAspectRatio(aspectRatio), "%");
    var handleChange = function(newValue) {
        if (isControlled) {
            onValueChange(newValue);
        } else {
            setLocalValue(newValue);
        }
    };
    var ItemOne = itemOne && isFunction(itemOne) ? itemOne({
        value: sliderValue
    }) : itemOne;
    var ItemTwo = itemTwo && isFunction(itemTwo) ? itemTwo({
        value: sliderValue
    }) : itemTwo;
    var baseSlides = [
        /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
            children: ItemOne
        }, "one"),
        /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
            children: ItemTwo
        }, "two"), 
    ];
    var direction = isHorizontal ? lib.Direction.Right : lib.Direction.Up;
    var slides = isHorizontal ? baseSlides : baseSlides.reverse();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AspectWrap, {
        style: {
            paddingBottom: "".concat(padding)
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                children: slides.map(function(content, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Element, {
                        style: {
                            clipPath: index === 1 ? clipPath : ""
                        },
                        children: content
                    }, index);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RangeWrap, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Range, {
                    step: 1,
                    min: 0,
                    max: 100,
                    values: [
                        sliderValue
                    ],
                    onChange: function(values) {
                        return handleChange(values[0]);
                    },
                    direction: direction,
                    renderTrack: function(param) {
                        var props = param.props, children = param.children;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Track, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            className: ""
                        }, props), {
                            style: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props.style), {
                                pointerEvents: onlyHandleDraggable ? "none" : "all"
                            }),
                            children: children
                        }));
                    },
                    renderThumb: function(params) {
                        var props = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, params.props), {
                            isFocused: focused
                        });
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(HandleCanvasWrap, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            id: "handleCanvasWrap"
                        }, params.props), {
                            style: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, params.props.style), {
                                flexDirection: isHorizontal ? "column" : "row",
                                height: isHorizontal ? "100%" : "auto",
                                width: isHorizontal ? "auto" : "100%"
                            }),
                            onFocus: function() {
                                return setFocused(true);
                            },
                            onBlur: function() {
                                return setFocused(false);
                            },
                            role: "presentation",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HandleDecoration, {
                                    children: handleBefore
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HandleWrap, {
                                    style: {
                                        pointerEvents: "all"
                                    },
                                    onClick: function() {
                                        if ((location === null || location === void 0 ? void 0 : location.indexOf("model")) > 0) {
                                            (0,analytics/* trackImageSliderModelPage */.cG)();
                                        }
                                    },
                                    children: handle(props)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HandleDecoration, {
                                    children: handleAfter
                                })
                            ]
                        }));
                    }
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/carModelPage/sections/exterior/comparisonSlider/ModelComparisonSlider.tsx

function ModelComparisonSlider_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: hidden;\n  width: 100vw;\n"
    ]);
    ModelComparisonSlider_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ModelComparisonSlider_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  position: relative;\n  background-color: ",
        ";\n"
    ]);
    ModelComparisonSlider_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ModelComparisonSlider_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  bottom: 0px;\n  left: 0;\n  background: ",
        ";\n  width: 100%;\n  height: 100%;\n"
    ]);
    ModelComparisonSlider_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ModelComparisonSlider_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  text-align: center;\n  position: absolute;\n  bottom: 0;\n  color: ",
        ";\n  margin-bottom: 120px;\n  ",
        " {\n    font-size: 28px;\n  }\n"
    ]);
    ModelComparisonSlider_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ModelComparisonSlider_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 2px;\n  height: 100%;\n  background-color: ",
        ";\n"
    ]);
    ModelComparisonSlider_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}







var ModelComparisonSlider_StyledSectionWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ModelComparisonSlider__StyledSectionWrapper",
    componentId: "sc-ee4c9199-0"
})(ModelComparisonSlider_templateObject());
var ModelComparisonSlider_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ModelComparisonSlider__StyledWrapper",
    componentId: "sc-ee4c9199-1"
})(ModelComparisonSlider_templateObject1(), function(p) {
    return p.theme.colors.darkGrey;
});
var StyledGradientOverlay = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ModelComparisonSlider__StyledGradientOverlay",
    componentId: "sc-ee4c9199-2"
})(ModelComparisonSlider_templateObject2(), function(p) {
    return p.$dark ? "linear-gradient(0deg, #000000 0%, rgba(0, 0, 0, 0) 25.42%)" : "linear-gradient(0deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 28.33%)";
});
var ModelComparisonSlider_StyledText = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
    variant: "h2"
}).withConfig({
    displayName: "ModelComparisonSlider__StyledText",
    componentId: "sc-ee4c9199-3"
})(ModelComparisonSlider_templateObject3(), function(p) {
    return p.$dark ? p.theme.colors.white : p.theme.colors.black;
}, function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledDivider = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ModelComparisonSlider__StyledDivider",
    componentId: "sc-ee4c9199-4"
})(ModelComparisonSlider_templateObject4(), function(p) {
    return p.theme.colors.white;
});
var ModelComparisonSlider = function(param) {
    var data = param.data;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var isDesktop = (0,MediaQueries/* useIsDesktop */.Ce)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModelComparisonSlider_StyledSectionWrapper, {
        role: "region",
        "aria-label": "גלריית תמונות",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ComparisonSlider, {
            defaultValue: 70,
            itemOne: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModelComparisonSlider_StyledWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage/* default */.Z, {
                        image: {
                            imageUrl: isDesktop ? data === null || data === void 0 ? void 0 : (ref = data.frontCurtain) === null || ref === void 0 ? void 0 : ref.desktopImageUrl : data.frontCurtain.mobileImageUrl,
                            alt: data === null || data === void 0 ? void 0 : (ref1 = data.frontCurtain) === null || ref1 === void 0 ? void 0 : ref1.alt
                        }
                    }),
                    (data === null || data === void 0 ? void 0 : (ref2 = data.backCurtain) === null || ref2 === void 0 ? void 0 : ref2.name) && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledGradientOverlay, {
                        $dark: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ModelComparisonSlider_StyledText, {
                        $dark: true,
                        children: data === null || data === void 0 ? void 0 : (ref3 = data.frontCurtain) === null || ref3 === void 0 ? void 0 : ref3.name
                    })
                ]
            }),
            itemTwo: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModelComparisonSlider_StyledWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage/* default */.Z, {
                        image: {
                            imageUrl: isDesktop ? data === null || data === void 0 ? void 0 : (ref4 = data.backCurtain) === null || ref4 === void 0 ? void 0 : ref4.desktopImageUrl : data.backCurtain.mobileImageUrl,
                            alt: data === null || data === void 0 ? void 0 : (ref5 = data.backCurtain) === null || ref5 === void 0 ? void 0 : ref5.alt
                        }
                    }),
                    (data === null || data === void 0 ? void 0 : (ref6 = data.backCurtain) === null || ref6 === void 0 ? void 0 : ref6.name) && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledGradientOverlay, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ModelComparisonSlider_StyledText, {
                        children: data === null || data === void 0 ? void 0 : (ref7 = data.backCurtain) === null || ref7 === void 0 ? void 0 : ref7.name
                    })
                ]
            }),
            handleAfter: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDivider, {}),
            handleBefore: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDivider, {}),
            aspectRatio: null,
            height: isDesktop ? "100vh" : "90vh",
            orientation: "horizontal",
            onlyHandleDraggable: true,
            handle: function() {
                {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundSliderIcon, {});
                }
            }
        })
    });
};
/* harmony default export */ var comparisonSlider_ModelComparisonSlider = (ModelComparisonSlider);

// EXTERNAL MODULE: ./common/BreadCrumbs.tsx + 2 modules
var BreadCrumbs = __webpack_require__(15738);
// EXTERNAL MODULE: ./reusable/colors/ColorCircleAnimation.tsx
var ColorCircleAnimation = __webpack_require__(86437);
// EXTERNAL MODULE: ./components/carModelPage/sections/exterior/enterence/ColorsCarousel.tsx
var ColorsCarousel = __webpack_require__(40739);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Box/Box.js + 14 modules
var Box = __webpack_require__(19393);
// EXTERNAL MODULE: ./reusable/icons/MoreInfoWhite.tsx
var MoreInfoWhite = __webpack_require__(72820);
;// CONCATENATED MODULE: ./components/carModelPage/sections/exterior/enterence/ModelInfo.tsx

function ModelInfo_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 190px;\n  display: flex;\n  flex-direction: column;\n  margin: 0px auto auto;\n  width: 270px;\n  justify-content: center;\n  align-items: center;\n  ",
        " {\n    margin-bottom: 0px;\n  }\n"
    ]);
    ModelInfo_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ModelInfo_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  color: ",
        ";\n"
    ]);
    ModelInfo_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ModelInfo_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: MazdaType, OENaPro, sans-serif;\n  font-size: 24px;\n  text-align: center;\n"
    ]);
    ModelInfo_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ModelInfo_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-width: 270px;\n  justify-content: ",
        ";\n  display: flex;\n  flex-direction: row;\n  margin-bottom: 10px;\n"
    ]);
    ModelInfo_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ModelInfo_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 1px;\n  height: 62px;\n  background: ",
        ";\n  transform: rotate(29.19deg);\n"
    ]);
    ModelInfo_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ModelInfo_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  color: ",
        ";\n  text-align: center;\n  margin: 0 auto;\n"
    ]);
    ModelInfo_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function ModelInfo_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n\n  margin-top: 4px;\n  height: 23px;\n  color: ",
        ";\n  font-size: 14px;\n  font-weight: normal;\n"
    ]);
    ModelInfo_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function ModelInfo_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    ModelInfo_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function ModelInfo_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0%,\n	100% {\n		transform: translateY(0);\n	}\n	8%,\n	24%,\n	40%,\n	56% {\n		transform: translateY(-2.5px);\n	}\n	16%,\n	32%,\n	48% {\n		transform: translateY(2.5px);\n	}\n	64% {\n		transform: translateY(2px);\n	}\n	72% {\n		transform: translateY(-2px);\n	}\n  80%{\n    transform: translateY(0);\n  }\n"
    ]);
    ModelInfo_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  // add loop down animation to svg path with id arrow\n  svg path#arrow {\n    animation: ",
        " 5s ease 0s infinite normal forwards;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}








var StyledFooterDiv = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ModelInfo__StyledFooterDiv",
    componentId: "sc-65a41933-0"
})(ModelInfo_templateObject(), function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledPriceTitle = (0,styled_components_browser_esm/* default */.ZP)(shared/* TypographyCenter */.kc).attrs({
    variant: "body1"
}).withConfig({
    displayName: "ModelInfo__StyledPriceTitle",
    componentId: "sc-65a41933-1"
})(ModelInfo_templateObject1(), function(p) {
    return p.theme.colors.onyx;
});
var StyledPrice = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
    variant: "body1"
}).withConfig({
    displayName: "ModelInfo__StyledPrice",
    componentId: "sc-65a41933-2"
})(ModelInfo_templateObject2());
var StyledPriceWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ModelInfo__StyledPriceWrapper",
    componentId: "sc-65a41933-3"
})(ModelInfo_templateObject3(), function(p) {
    return p.$justify;
});
var StyledPriceLine = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ModelInfo__StyledPriceLine",
    componentId: "sc-65a41933-4"
})(ModelInfo_templateObject4(), function(p) {
    return p.theme.colors.nonExistentLightGray;
});
var StyledLicenseFee = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
    variant: "body2"
}).withConfig({
    displayName: "ModelInfo__StyledLicenseFee",
    componentId: "sc-65a41933-5"
})(ModelInfo_templateObject5(), function(p) {
    return p.theme.colors.black;
});
var StyledPurchase = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
    variant: "body2"
}).withConfig({
    displayName: "ModelInfo__StyledPurchase",
    componentId: "sc-65a41933-6"
})(ModelInfo_templateObject6(), function(p) {
    return p.theme.colors.mazdaRed;
});
var StyledDiv = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ModelInfo__StyledDiv",
    componentId: "sc-65a41933-7"
})(ModelInfo_templateObject7(), function(p) {
    return p.$marginTop && "margin-top: ".concat(p.$marginTop, "px;");
}, function(p) {
    return p.$marginBottom && "margin-bottom: ".concat(p.$marginBottom, "px;");
}, function(p) {
    return p.$cursor && "cursor: ".concat(p.$cursor);
});
var arrowDown = (0,styled_components_browser_esm/* keyframes */.F4)(ModelInfo_templateObject8());
var StyledArrowDownWrap = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    displayName: "ModelInfo__StyledArrowDownWrap",
    componentId: "sc-65a41933-8"
})(_templateObject9(), arrowDown);
var ModelInfo = function(param) {
    var carData = param.carData, openCalculator = param.openCalculator, onScrollDownClick = param.onScrollDownClick;
    var carId = carData.id;
    var detailData = (0,store/* useTypedSelector */.ix)(function(state) {
        return state === null || state === void 0 ? void 0 : state.detailing;
    });
    var detailing = detailData.detailing, color = detailData.color;
    var shopUrl = (0,buildShopLink/* buildShopLink */.u)(detailing, color, carId);
    var onArrowDownClick = function(e) {
        e.preventDefault();
        // scroll 170px down
        window === null || window === void 0 ? void 0 : window.scrollTo(0, 171);
        onScrollDownClick();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFooterDiv, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPriceWrapper, {
                $justify: (carData === null || carData === void 0 ? void 0 : carData.mountlyPayment) ? "space-between" : "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDiv, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPriceTitle, {
                                children: "החל מ-"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPrice, {
                                children: [
                                    "₪",
                                    carData.price.toLocaleString()
                                ]
                            })
                        ]
                    }),
                    !!(carData === null || carData === void 0 ? void 0 : carData.mountlyPayment) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPriceLine, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDiv, {
                                onClick: function() {
                                    return openCalculator();
                                },
                                $cursor: "pointer",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPriceTitle, {
                                        children: "החזר חודשי החל מ-"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPrice, {
                                        children: [
                                            "₪",
                                            carData.mountlyPayment ? carData.mountlyPayment.toLocaleString() : 0
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDiv, {
                $marginBottom: 10,
                children: [
                    (carData === null || carData === void 0 ? void 0 : carData.licenceFee) > 0 && (carData === null || carData === void 0 ? void 0 : carData.isInShop) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLicenseFee, {
                        children: [
                            "בתוספת אגרת רישוי של ₪",
                            carData.licenceFee.toLocaleString(),
                            " כולל מע״מ"
                        ]
                    }),
                    carData.isInShop && /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                        href: shopUrl,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPurchase, {
                            children: "ניתן להזמנה מיידית אונליין"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledArrowDownWrap, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                    onClick: onArrowDownClick,
                    onKeyDown: onArrowDownClick,
                    "aria-label": "מעבר לאיזור הבא בעמוד",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MoreInfoWhite/* default */.Z, {})
                })
            })
        ]
    });
};
/* harmony default export */ var enterence_ModelInfo = (ModelInfo);

// EXTERNAL MODULE: ./components/carModelPage/sections/exterior/enterence/ThreeSixtyViewer.tsx
var ThreeSixtyViewer = __webpack_require__(42903);
;// CONCATENATED MODULE: ./components/carModelPage/sections/exterior/enterence/EntrenchComponent.tsx

function EntrenchComponent_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 150vh;\n  width: 100%;\n"
    ]);
    EntrenchComponent_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function EntrenchComponent_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100vh;\n  width: 100%;\n  display: flex;\n  position: sticky;\n  top: 0px;\n"
    ]);
    EntrenchComponent_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function EntrenchComponent_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100%;\n  width: 100%;\n  position: relative;\n"
    ]);
    EntrenchComponent_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function EntrenchComponent_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: 3;\n  max-height: 100vh;\n  height: 100vh;\n  display: flex;\n  padding-top: 50px;\n  justify-content: start;\n  align-items: center;\n  position: relative;\n  scroll-snap-align: center;\n  perspective: 500px;\n  z-index: 3;\n  padding-bottom: 30px;\n  flex-direction: column;\n  padding-top: ",
        "px;\n  padding-bottom: 100px;\n  overflow: hidden;\n  ",
        " {\n    padding-top: ",
        "px;\n  }\n"
    ]);
    EntrenchComponent_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function EntrenchComponent_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 40px 0px 0px;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  transition: 2s;\n  transform: ",
        ";\n  opacity: ",
        ";\n  transition-delay: 0.3s;\n"
    ]);
    EntrenchComponent_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function EntrenchComponent_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  height: 155px;\n  width: 100%;\n"
    ]);
    EntrenchComponent_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function EntrenchComponent_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  width: 100%;\n  max-width: 100vw;\n"
    ]);
    EntrenchComponent_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function EntrenchComponent_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  top: 20px;\n  position: absolute;\n  width: 100%;\n  z-index: 10;\n  pointer-events: none;\n"
    ]);
    EntrenchComponent_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function EntrenchComponent_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: fit-content;\n  margin: 0px auto;\n"
    ]);
    EntrenchComponent_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}















var StyledBigWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "EntrenchComponent__StyledBigWrapper",
    componentId: "sc-a0efa6b2-0"
})(EntrenchComponent_templateObject());
var StyledMidWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "EntrenchComponent__StyledMidWrapper",
    componentId: "sc-a0efa6b2-1"
})(EntrenchComponent_templateObject1());
var StyledSmallWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "EntrenchComponent__StyledSmallWrapper",
    componentId: "sc-a0efa6b2-2"
})(EntrenchComponent_templateObject2());
var EntrenchComponent_StyledSectionWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "EntrenchComponent__StyledSectionWrapper",
    componentId: "sc-a0efa6b2-3"
})(EntrenchComponent_templateObject3(), shared/* HEADER_ANIME_M */.yv, function(p) {
    return p.theme.breakpoints.up("md");
}, shared/* HEADER_ANIME_D */.oe);
var StyledTopText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "EntrenchComponent__StyledTopText",
    componentId: "sc-a0efa6b2-4"
})(EntrenchComponent_templateObject4(), function(param) {
    var $inView = param.$inView;
    return $inView ? "translateY(0)" : "translateY(-20px)";
}, function(param) {
    var $inView = param.$inView;
    return $inView ? "1" : "0";
});
var StyledAnimationWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "EntrenchComponent__StyledAnimationWrapper",
    componentId: "sc-a0efa6b2-5"
})(EntrenchComponent_templateObject5());
var StyledMotionDiv = (0,styled_components_browser_esm/* default */.ZP)(motion/* motion.div */.E.div).withConfig({
    displayName: "EntrenchComponent__StyledMotionDiv",
    componentId: "sc-a0efa6b2-6"
})(EntrenchComponent_templateObject6());
var StyledColorCircleAnimation = (0,styled_components_browser_esm/* default */.ZP)(ColorCircleAnimation/* default */.Z).withConfig({
    displayName: "EntrenchComponent__StyledColorCircleAnimation",
    componentId: "sc-a0efa6b2-7"
})(EntrenchComponent_templateObject7());
var StyledRotationIconWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "EntrenchComponent__StyledRotationIconWrap",
    componentId: "sc-a0efa6b2-8"
})(EntrenchComponent_templateObject8());
var EntrenchComponent = function(param) {
    var outsideData = param.outsideData, generalInfo = param.generalInfo, openCalculator = param.openCalculator;
    var ref;
    var ref1 = (0,react_intersection_observer_modern/* useInView */.YD)({
        triggerOnce: true
    }), inViewRef = ref1.ref, inView = ref1.inView;
    // selected color:
    var ref2 = (0,react.useState)(0), selectedColorIndex = ref2[0], setSelectedColorIndex = ref2[1];
    var ref3 = (0,react.useState)(""), colorCode = ref3[0], setColorCode = ref3[1];
    // at the middle enter the color swiper
    var ref4 = (0,react.useState)(false), colorChange = ref4[0], setColorChange = ref4[1];
    var ref5 = (0,react.useRef)(null);
    var colorRef = (0,react.useRef)(null);
    var colorSectionRef = (0,react.useRef)(null);
    // Value being driven by scrolling (e.g. height)
    var thresholdY = 170 // set the scroll position where you want the state change
    ;
    var scrollY = (0,use_scroll/* useScroll */.v)().scrollY;
    var selectedColorCode = (0,store/* useTypedSelector */.ix)(function(state) {
        return state.color;
    }).selectedColorCode;
    var ref6 = (0,react.useState)(false), isPastThreshold = ref6[0], setIsPastThreshold = ref6[1];
    (0,react.useEffect)(function() {
        return scrollY.onChange(function(latest) {
            return setIsPastThreshold(latest > thresholdY);
        });
    }, []);
    var handleColorChange = function(selectedColorIndex) {
        setColorChange(true);
        var length = outsideData.colors.length;
        setTimeout(function() {
            if (selectedColorIndex === length) setSelectedColorIndex(0);
            else setSelectedColorIndex(selectedColorIndex);
        }, 100);
        colorRef.current = setTimeout(function() {
            return setColorChange(false);
        }, 1800);
    };
    (0,react.useEffect)(function() {
        // Clear the interval when the component unmounts
        return function() {
            // clearTimeout(timerRef.current)
            clearTimeout(colorRef.current);
        };
    }, []);
    (0,react.useEffect)(function() {
        if (selectedColorCode) {
            var index = outsideData.colors.findIndex(function(color) {
                return color.code === selectedColorCode;
            });
            setSelectedColorIndex(index);
            setColorCode(selectedColorCode);
        }
    }, [
        selectedColorCode,
        outsideData
    ]);
    var imagesList = (0,react.useMemo)(function() {
        var ref;
        return (ref = outsideData === null || outsideData === void 0 ? void 0 : outsideData.colors[selectedColorIndex]) === null || ref === void 0 ? void 0 : ref.images.map(function(i) {
            return i.imageUrl;
        });
    }, [
        selectedColorIndex,
        outsideData === null || outsideData === void 0 ? void 0 : outsideData.colors
    ]);
    var dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(function() {
        var ref, ref1;
        setColorCode((ref = outsideData === null || outsideData === void 0 ? void 0 : outsideData.colors[selectedColorIndex]) === null || ref === void 0 ? void 0 : ref.code);
        dispatch((0,detailingSlice/* setColor */.vk)((ref1 = outsideData === null || outsideData === void 0 ? void 0 : outsideData.colors[selectedColorIndex]) === null || ref1 === void 0 ? void 0 : ref1.code));
    }, [
        selectedColorIndex,
        outsideData,
        dispatch
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: inViewRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBigWrapper, {
            ref: ref5,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMidWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSmallWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(EntrenchComponent_StyledSectionWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbs/* default */.Z, {
                                modelName: generalInfo.name,
                                id: generalInfo.id
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTopText, {
                                $inView: inView,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "h1",
                                        children: generalInfo.name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "h3",
                                        role: "presentation",
                                        children: generalInfo.secondaryTitle
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ThreeSixtyViewer/* default */.Z, {
                                alt: "צבע ".concat(colorCode),
                                imageList: imagesList,
                                enable: isPastThreshold
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledAnimationWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMotionDiv, {
                                        initial: {
                                            opacity: 1,
                                            scale: 1,
                                            originY: 0,
                                            visibility: "visible"
                                        },
                                        animate: {
                                            opacity: isPastThreshold ? 0 : 1,
                                            scale: isPastThreshold ? 0.5 : 1,
                                            translateY: isPastThreshold ? -100 : 0,
                                            visibility: isPastThreshold ? "hidden" : "visible"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(enterence_ModelInfo, {
                                            carData: generalInfo,
                                            openCalculator: openCalculator,
                                            onScrollDownClick: function() {
                                                setTimeout(function() {
                                                    var // focus on the  focusable element
                                                    ref;
                                                    (ref = ref5.current// query selector for a button or a link or a focusable element
                                                    .querySelector("#three-sixty-viewer")) === null || ref === void 0 ? void 0 : ref.focus();
                                                }, 100);
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledMotionDiv, {
                                        ref: colorSectionRef,
                                        initial: {
                                            opacity: 0,
                                            y: 100,
                                            visibility: "hidden"
                                        },
                                        animate: {
                                            opacity: isPastThreshold ? 1 : 0,
                                            y: isPastThreshold ? 0 : 100,
                                            visibility: isPastThreshold ? "visible" : "hidden"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRotationIconWrap, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* StyledSvgIcon */.vV, {
                                                    src: "/icons/rotate-360.svg",
                                                    alt: "rotate",
                                                    w: 32,
                                                    h: 32,
                                                    role: "presentation",
                                                    "aria-hidden": "true"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorsCarousel/* default */.Z, {
                                                colorsData: outsideData === null || outsideData === void 0 ? void 0 : outsideData.colors,
                                                handleColorChange: handleColorChange,
                                                selectedColorIndex: selectedColorIndex,
                                                colorChange: colorChange
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledColorCircleAnimation, {
                                                animationFlag: colorChange,
                                                hex: ((ref = outsideData === null || outsideData === void 0 ? void 0 : outsideData.colors[selectedColorIndex]) === null || ref === void 0 ? void 0 : ref.hex) || "",
                                                animationTime: "1800"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        })
    });
};
/* harmony default export */ var enterence_EntrenchComponent = (EntrenchComponent);

;// CONCATENATED MODULE: ./components/carModelPage/sections/exterior/ExteriorSection.tsx

function ExteriorSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: max-content;\n  background-color: ",
        ";\n"
    ]);
    ExteriorSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var ExteriorSection_StyledWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ExteriorSection__StyledWrap",
    componentId: "sc-cb47f5c9-0"
})(ExteriorSection_templateObject(), function(p) {
    return p.theme.colors.lightGrey;
});
var ExteriorSection = function(param) {
    var data = param.data, setCalculatorPopupOpen = param.setCalculatorPopupOpen;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12;
    var router = (0,client_router.useRouter)();
    var openCalculator = function() {
        var ref, ref1, ref2;
        router.replace({
            pathname: router.asPath.split("?")[0],
            query: {
                engineId: data === null || data === void 0 ? void 0 : (ref = data.finishingLevels) === null || ref === void 0 ? void 0 : (ref1 = ref.engines) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.engineId
            }
        }, null, {
            shallow: true
        }).then(function() {
            return setCalculatorPopupOpen(true);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ExteriorSection_StyledWrap, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(enterence_EntrenchComponent, {
                outsideData: data === null || data === void 0 ? void 0 : data.outside,
                generalInfo: data === null || data === void 0 ? void 0 : data.generalInfo,
                openCalculator: openCalculator
            }),
            (data === null || data === void 0 ? void 0 : (ref = data.outside) === null || ref === void 0 ? void 0 : ref.video) && /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoModelFullScreen/* default */.Z, {
                src: data === null || data === void 0 ? void 0 : (ref1 = data.outside) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.video) === null || ref2 === void 0 ? void 0 : ref2.desktopImageUrl,
                imgDesktop: data === null || data === void 0 ? void 0 : (ref3 = data.outside) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.video) === null || ref4 === void 0 ? void 0 : ref4.desktopImageUrl,
                imgMobile: data === null || data === void 0 ? void 0 : (ref5 = data.outside) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.video) === null || ref6 === void 0 ? void 0 : ref6.mobileImageUrl,
                alt: data === null || data === void 0 ? void 0 : (ref7 = data.outside) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.video) === null || ref8 === void 0 ? void 0 : ref8.alt
            }),
            (data === null || data === void 0 ? void 0 : (ref9 = data.outside) === null || ref9 === void 0 ? void 0 : ref9.outsideDesignText) && /*#__PURE__*/ (0,jsx_runtime.jsx)(reusable_ModelTextSection, {
                text: data === null || data === void 0 ? void 0 : (ref10 = data.outside) === null || ref10 === void 0 ? void 0 : ref10.outsideDesignText
            }),
            (data === null || data === void 0 ? void 0 : (ref11 = data.outside) === null || ref11 === void 0 ? void 0 : ref11.frontCurtain) && (data === null || data === void 0 ? void 0 : (ref12 = data.outside) === null || ref12 === void 0 ? void 0 : ref12.backCurtain) && /*#__PURE__*/ (0,jsx_runtime.jsx)(comparisonSlider_ModelComparisonSlider, {
                data: data === null || data === void 0 ? void 0 : data.outside
            })
        ]
    });
};
/* harmony default export */ var exterior_ExteriorSection = (ExteriorSection);

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./common/bit/SingleButtonSelection.tsx
var SingleButtonSelection = __webpack_require__(74962);
;// CONCATENATED MODULE: ./reusable/chips/BigChipsOneRow.tsx

function BigChipsOneRow_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 100vw;\n  white-space: nowrap;\n  overflow-y: hidden;\n  -webkit-overflow-scrolling: touch;\n  margin-bottom: 10px;\n  ",
        " {\n    /* width: 320px; */\n    margin: 0 auto;\n    margin-bottom: 10px;\n  }\n"
    ]);
    BigChipsOneRow_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function BigChipsOneRow_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  justify-content: center;\n  background-color: ",
        ";\n  border-radius: 3px;\n  button {\n    width: auto;\n  }\n"
    ]);
    BigChipsOneRow_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function BigChipsOneRow_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  width: 100%;\n  height: 100%;\n  :focus {\n    outline: none;\n  }\n"
    ]);
    BigChipsOneRow_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function BigChipsOneRow_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 13px 16px;\n  border-radius: 3px;\n  min-width: 88px;\n  background-color: ",
        ";\n  p {\n    color: ",
        ";\n  }\n"
    ]);
    BigChipsOneRow_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function BigChipsOneRow_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  letter-spacing: 0.05em;\n"
    ]);
    BigChipsOneRow_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}




var BigChipsOneRow_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "BigChipsOneRow__StyledWrapper",
    componentId: "sc-af06dc93-0"
})(BigChipsOneRow_templateObject(), function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledSingleButtonSelection = (0,styled_components_browser_esm/* default */.ZP)(SingleButtonSelection/* default */.Z).withConfig({
    displayName: "BigChipsOneRow__StyledSingleButtonSelection",
    componentId: "sc-af06dc93-1"
})(BigChipsOneRow_templateObject1(), function(p) {
    return p.theme.colors.white;
});
var BigChipsOneRow_StyledButton = styled_components_browser_esm/* default.label.withConfig */.ZP.label.withConfig({
    displayName: "BigChipsOneRow__StyledButton",
    componentId: "sc-af06dc93-2"
})(BigChipsOneRow_templateObject2());
var StyleChipButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "BigChipsOneRow__StyleChipButton",
    componentId: "sc-af06dc93-3"
})(BigChipsOneRow_templateObject3(), function(p) {
    return p.$activeButton ? p.theme.colors.black : p.theme.colors.white;
}, function(p) {
    return p.$activeButton ? p.theme.colors.white : p.theme.colors.black;
});
var BigChipsOneRow_StyledText = (0,styled_components_browser_esm/* default */.ZP)(shared/* TypographyRtl */.UE).attrs({
    variant: "body2"
}).withConfig({
    displayName: "BigChipsOneRow__StyledText",
    componentId: "sc-af06dc93-4"
})(BigChipsOneRow_templateObject4());
var BigChipsOneRow = function(param) {
    var activeButton = param.activeButton, setActiveButton = param.setActiveButton, optionsList = param.optionsList, toggleId = param.toggleId, className = param.className, onSelect = param.onSelect;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BigChipsOneRow_StyledWrapper, {
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSingleButtonSelection, {
            id: toggleId,
            itemsPerRow: "auto",
            items: optionsList.map(function(item, index) {
                return {
                    value: index,
                    name: item
                };
            }),
            selectedValue: activeButton,
            onSelect: function(code) {
                if (onSelect) {
                    onSelect === null || onSelect === void 0 ? void 0 : onSelect();
                }
                setActiveButton(Number(code));
            },
            customButton: function(radioId, isSelected, item) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(BigChipsOneRow_StyledButton, {
                    htmlFor: radioId,
                    $activeButton: isSelected,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyleChipButton, {
                        $activeButton: isSelected,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BigChipsOneRow_StyledText, {
                            variant: "body2",
                            children: [
                                "מנוע ",
                                item.name
                            ]
                        })
                    })
                });
            }
        })
    });
};
/* harmony default export */ var chips_BigChipsOneRow = (BigChipsOneRow);

;// CONCATENATED MODULE: ./reusable/chips/MultibleChipsRow.tsx

function MultibleChipsRow_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    width: 540px;\n    margin: 0 auto;\n  }\n"
    ]);
    MultibleChipsRow_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function MultibleChipsRow_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  gap: 10px;\n  justify-content: center;\n  align-items: center;\n  flex-wrap: wrap;\n  button {\n    width: auto;\n  }\n"
    ]);
    MultibleChipsRow_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function MultibleChipsRow_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  width: 100%;\n  height: 100%;\n  :focus {\n    outline: none;\n  }\n"
    ]);
    MultibleChipsRow_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function MultibleChipsRow_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 6px 12px;\n  border-radius: 3px;\n  background-color: ",
        ";\n  &.icon {\n    background-color: ",
        ";\n    stroke: ",
        ";\n    fill: ",
        ";\n  }\n  p {\n    color: ",
        ";\n  }\n"
    ]);
    MultibleChipsRow_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}





var MultibleChipsRow_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "MultibleChipsRow__StyledWrapper",
    componentId: "sc-78135f94-0"
})(MultibleChipsRow_templateObject(), function(p) {
    return p.theme.breakpoints.up("md");
});
var MultibleChipsRow_StyledSingleButtonSelection = (0,styled_components_browser_esm/* default */.ZP)(SingleButtonSelection/* default */.Z).withConfig({
    displayName: "MultibleChipsRow__StyledSingleButtonSelection",
    componentId: "sc-78135f94-1"
})(MultibleChipsRow_templateObject1());
var MultibleChipsRow_StyledButton = styled_components_browser_esm/* default.label.withConfig */.ZP.label.withConfig({
    displayName: "MultibleChipsRow__StyledButton",
    componentId: "sc-78135f94-2"
})(MultibleChipsRow_templateObject2());
var MultibleChipsRow_StyleChipButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "MultibleChipsRow__StyleChipButton",
    componentId: "sc-78135f94-3"
})(MultibleChipsRow_templateObject3(), function(p) {
    return p.$activeButton ? p.theme.colors.black : p.theme.colors.white;
}, function(p) {
    return p.$activeButton ? p.theme.colors.white : p.theme.colors.disable;
}, function(p) {
    return p.theme.colors.black;
}, function(p) {
    return p.theme.colors.black;
}, function(p) {
    return p.$activeButton ? p.theme.colors.white : p.theme.colors.black;
});
var MultibleChipsRow = function(param) {
    var activeButton = param.activeButton, setActiveButton = param.setActiveButton, optionsList = param.optionsList, toggleId = param.toggleId, className = param.className, icons = param.icons, _isSelectAll = param.isSelectAll, isSelectAll = _isSelectAll === void 0 ? false : _isSelectAll;
    var ref = (0,react.useState)(false), selectAll = ref[0], setSelectAll = ref[1];
    (0,react.useEffect)(function() {
        setSelectAll(isSelectAll);
    }, [
        isSelectAll
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MultibleChipsRow_StyledWrapper, {
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MultibleChipsRow_StyledSingleButtonSelection, {
            id: toggleId,
            itemsPerRow: "auto",
            items: optionsList.map(function(item, index) {
                return {
                    value: index,
                    name: item,
                    icon: icons && item === "icon" ? icons[index] : undefined
                };
            }),
            selectedValue: activeButton,
            onSelect: function(code) {
                setActiveButton(Number(code));
            },
            customButton: function(radioId, isSelected, item) {
                var IconComponent = item.icon;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(MultibleChipsRow_StyledButton, {
                    htmlFor: radioId,
                    $activeButton: isSelected,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MultibleChipsRow_StyleChipButton, {
                        $activeButton: selectAll ? true : isSelected,
                        className: "".concat(item.icon ? "icon" : ""),
                        children: item.icon ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconComponent, {}) // use a react component instead of a string
                         : /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* TypographyRtl */.UE, {
                            variant: "body2",
                            children: item.name
                        }) // default string in case there's no icon (the default is string)
                    })
                });
            }
        })
    });
};
/* harmony default export */ var chips_MultibleChipsRow = (MultibleChipsRow);

;// CONCATENATED MODULE: ./components/carModelPage/sections/finishingLevels/BulletsList.tsx

function BulletsList_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 16px;\n  color: ",
        ";\n"
    ]);
    BulletsList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function BulletsList_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n"
    ]);
    BulletsList_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function BulletsList_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 10px;\n  &:last-child {\n    margin-bottom: 0;\n  }\n"
    ]);
    BulletsList_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var BulletsList_StyledText = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
    variant: "body2"
}).withConfig({
    displayName: "BulletsList__StyledText",
    componentId: "sc-6a47a1a8-0"
})(BulletsList_templateObject(), function(p) {
    return p.theme.colors.black;
});
var StyledList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    displayName: "BulletsList__StyledList",
    componentId: "sc-6a47a1a8-1"
})(BulletsList_templateObject1());
var StyledLi = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    displayName: "BulletsList__StyledLi",
    componentId: "sc-6a47a1a8-2"
})(BulletsList_templateObject2());
var BulletsList = function(param) {
    var textList = param.textList;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledList, {
        children: textList.map(function(text, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLi, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(shared/* StyledRow */.N0, {
                    $fullWidth: true,
                    $gap: "4px",
                    $notCenter: true,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* StyledSvgIcon */.vV, {
                            src: "/icons/fi_circle_bullet.svg",
                            alt: "bullet-icon",
                            w: 16,
                            h: 16
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BulletsList_StyledText, {
                            children: text
                        })
                    ]
                })
            }, index);
        })
    });
};
/* harmony default export */ var finishingLevels_BulletsList = (BulletsList);

// EXTERNAL MODULE: ./reusable/popups/InformationPopUp.tsx
var InformationPopUp = __webpack_require__(61593);
;// CONCATENATED MODULE: ./components/carModelPage/sections/finishingLevels/FinishingLevelsPopup.tsx

function FinishingLevelsPopup_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n"
    ]);
    FinishingLevelsPopup_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function FinishingLevelsPopup_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  justify-content: center;\n"
    ]);
    FinishingLevelsPopup_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var FinishingLevelsPopup_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FinishingLevelsPopup__StyledWrapper",
    componentId: "sc-bc1e7770-0"
})(FinishingLevelsPopup_templateObject());
var FinishingLevelsPopup_StyledImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FinishingLevelsPopup__StyledImageWrapper",
    componentId: "sc-bc1e7770-1"
})(FinishingLevelsPopup_templateObject1());
var FinishingLevelsPopup = function(param) {
    var open = param.open, onClose = param.onClose, modelName = param.modelName, data = param.data;
    var ref, ref1, ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(InformationPopUp/* default */.Z, {
        open: open,
        onClose: onClose,
        title: "".concat(modelName),
        subtitle: "מפרט מלא",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FinishingLevelsPopup_StyledWrapper, {
            children: [
                (data === null || data === void 0 ? void 0 : (ref = data.image) === null || ref === void 0 ? void 0 : ref.imageUrl) && /*#__PURE__*/ (0,jsx_runtime.jsx)(FinishingLevelsPopup_StyledImageWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: data === null || data === void 0 ? void 0 : (ref1 = data.image) === null || ref1 === void 0 ? void 0 : ref1.imageUrl,
                        alt: data === null || data === void 0 ? void 0 : (ref2 = data.image) === null || ref2 === void 0 ? void 0 : ref2.alt,
                        width: 320,
                        height: 180,
                        lazyBoundary: "800px"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* TypographyRtl */.UE, {
                    variant: "h2",
                    children: data.name
                }),
                data.categories.map(function(category, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* TypographyRtl */.UE, {
                                variant: "body1",
                                $mb: "10px",
                                children: category.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(finishingLevels_BulletsList, {
                                textList: category.items.map(function(item) {
                                    return "".concat(item.name, " ").concat(item.description);
                                })
                            })
                        ]
                    }, "category-".concat(index));
                })
            ]
        })
    });
};
/* harmony default export */ var finishingLevels_FinishingLevelsPopup = (FinishingLevelsPopup);

;// CONCATENATED MODULE: ./components/carModelPage/sections/finishingLevels/FinishingLevelsSection.tsx

function FinishingLevelsSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-height: 90vh;\n  height: 100%;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  background-color: ",
        ";\n  justify-content: center;\n"
    ]);
    FinishingLevelsSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function FinishingLevelsSection_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 12px;\n  color: ",
        ";\n  text-align: center;\n  margin: 0 auto;\n"
    ]);
    FinishingLevelsSection_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function FinishingLevelsSection_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 20px;\n  padding-bottom: 80px;\n  ",
        " {\n    flex-direction: row;\n    align-items: stretch;\n  }\n"
    ]);
    FinishingLevelsSection_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function FinishingLevelsSection_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 300px;\n  max-width: 300px;\n  display: flex;\n  flex-direction: column;\n  padding: 10px;\n  border: 1px solid ",
        ";\n  border-radius: 3px;\n  min-height: 220px;\n"
    ]);
    FinishingLevelsSection_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function FinishingLevelsSection_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: ",
        ";\n  align-items: ",
        ";\n"
    ]);
    FinishingLevelsSection_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function FinishingLevelsSection_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 10px;\n  margin: 0 auto;\n"
    ]);
    FinishingLevelsSection_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function FinishingLevelsSection_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  justify-content: center;\n"
    ]);
    FinishingLevelsSection_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}














var FinishingLevelsSection_StyledSectionWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FinishingLevelsSection__StyledSectionWrapper",
    componentId: "sc-3037dfbc-0"
})(FinishingLevelsSection_templateObject(), function(p) {
    return p.theme.colors.lightGrey;
});
var FinishingLevelsSection_StyledLicenseFee = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
    variant: "body2"
}).withConfig({
    displayName: "FinishingLevelsSection__StyledLicenseFee",
    componentId: "sc-3037dfbc-1"
})(FinishingLevelsSection_templateObject1(), function(p) {
    return p.theme.colors.disable;
});
var StyledCubicWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FinishingLevelsSection__StyledCubicWrapper",
    componentId: "sc-3037dfbc-2"
})(FinishingLevelsSection_templateObject2(), function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledFramedDiv = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FinishingLevelsSection__StyledFramedDiv",
    componentId: "sc-3037dfbc-3"
})(FinishingLevelsSection_templateObject3(), function(p) {
    return p.theme.colors.platinum;
});
var StyledGrow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FinishingLevelsSection__StyledGrow",
    componentId: "sc-3037dfbc-4"
})(FinishingLevelsSection_templateObject4(), function(p) {
    return p.$start ? "flex-start" : "center";
}, function(p) {
    return p.$start ? "flex-start" : "center";
});
var FinishingLevelsSection_StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    displayName: "FinishingLevelsSection__StyledButton",
    componentId: "sc-3037dfbc-5"
})(FinishingLevelsSection_templateObject5());
var FinishingLevelsSection_StyledImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FinishingLevelsSection__StyledImageWrapper",
    componentId: "sc-3037dfbc-6"
})(FinishingLevelsSection_templateObject6());
var FinishingLevelsSection = function(param) {
    var data = param.data, modelName = param.modelName, setCalculatorPopupOpen = param.setCalculatorPopupOpen;
    var isDesktop = (0,MediaQueries/* useIsDesktop */.Ce)();
    var ref = (0,react.useState)(false), popUpOpen = ref[0], setPopUpOpen = ref[1];
    var ref1 = (0,react.useState)(0), selectedEngineIndex = ref1[0], setSelectedEngineIndex = ref1[1];
    var ref2 = (0,react.useState)(0), selectedFinishingLevelsIndex = ref2[0], setSelectedFinishingLevelsIndex = ref2[1];
    var dispatch = (0,es/* useDispatch */.I0)();
    var enginesOptions = (0,react.useMemo)(function() {
        return data === null || data === void 0 ? void 0 : data.engines.map(function(item) {
            return item.engineName;
        });
    }, [
        data === null || data === void 0 ? void 0 : data.engines
    ]);
    var finishingLevelsOptions = (0,react.useMemo)(function() {
        return data === null || data === void 0 ? void 0 : data.engines[selectedEngineIndex].finishingLevels.map(function(item) {
            return item.name;
        });
    }, [
        selectedEngineIndex,
        data === null || data === void 0 ? void 0 : data.engines
    ]);
    var selectedData = (0,react.useMemo)(function() {
        var selectedEngine = data === null || data === void 0 ? void 0 : data.engines[selectedEngineIndex].finishingLevels[selectedFinishingLevelsIndex];
        dispatch((0,detailingSlice/* setDetail */.nO)(selectedEngine === null || selectedEngine === void 0 ? void 0 : selectedEngine.code));
        return selectedEngine;
    }, [
        selectedEngineIndex,
        selectedFinishingLevelsIndex,
        data === null || data === void 0 ? void 0 : data.engines
    ]);
    (0,react.useEffect)(function() {
        setSelectedFinishingLevelsIndex(0);
    }, [
        selectedEngineIndex
    ]);
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FinishingLevelsSection_StyledSectionWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* TypographyCenter */.kc, {
                        variant: "h2",
                        $mb: "20px",
                        children: "רמות גימור"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "srOnly",
                        children: "הצג נתונים על כל דגם , על פי המאפיינים הבאים לבחירתך"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(shared/* StyledCol */.N6, {
                        $fullWidth: true,
                        $gap: "4px",
                        $pr: "16px",
                        $pl: "16px",
                        children: [
                            (enginesOptions === null || enginesOptions === void 0 ? void 0 : enginesOptions.length) > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(chips_BigChipsOneRow, {
                                activeButton: selectedEngineIndex,
                                setActiveButton: setSelectedEngineIndex,
                                onSelect: function() {
                                    return setSelectedFinishingLevelsIndex(0);
                                },
                                optionsList: enginesOptions,
                                toggleId: "engine-selection"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chips_MultibleChipsRow, {
                                activeButton: selectedFinishingLevelsIndex,
                                setActiveButton: setSelectedFinishingLevelsIndex,
                                optionsList: finishingLevelsOptions,
                                toggleId: "finishing-levels-selection"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FinishingLevelsSection_StyledImageWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: selectedData.image.imageUrl,
                            alt: selectedData.image.alt,
                            width: isDesktop ? 544 : 320,
                            height: isDesktop ? 306 : 180,
                            lazyBoundary: "800px"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCubicWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFramedDiv, {
                                tabIndex: 0,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledGrow, {
                                        $start: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(finishingLevels_BulletsList, {
                                            textList: selectedData.mainFeatures
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FinishingLevelsSection_StyledButton, {
                                        variant: "contained",
                                        onClick: function() {
                                            return setPopUpOpen(true);
                                        },
                                        children: "למפרט המלא"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFramedDiv, {
                                tabIndex: 0,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledGrow, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* TypographyCenter */.kc, {
                                                variant: "body1",
                                                $fontSize: "24px",
                                                $fontWeight: "400",
                                                children: "₪".concat(selectedData.price.toLocaleString())
                                            }),
                                            selectedData.licenceFee > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(FinishingLevelsSection_StyledLicenseFee, {
                                                children: [
                                                    "בתוספת אגרת רישוי בסך ₪",
                                                    selectedData.licenceFee.toLocaleString(),
                                                    " כולל מע״מ"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FinishingLevelsSection_StyledButton, {
                                        onClick: function() {
                                            if (router.isReady) {
                                                var ref, ref1;
                                                router.replace({
                                                    pathname: router.asPath.split("?")[0],
                                                    query: {
                                                        finishingLevel: selectedData === null || selectedData === void 0 ? void 0 : selectedData.name,
                                                        engineId: data === null || data === void 0 ? void 0 : (ref = data.engines) === null || ref === void 0 ? void 0 : (ref1 = ref[selectedEngineIndex]) === null || ref1 === void 0 ? void 0 : ref1.engineId
                                                    },
                                                    hash: window.location.hash
                                                }, null, {
                                                    shallow: true
                                                }).then(function() {
                                                    return setCalculatorPopupOpen(true);
                                                });
                                            }
                                        },
                                        variant: "contained",
                                        children: "למחשבון מימון"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(finishingLevels_FinishingLevelsPopup, {
                open: popUpOpen,
                onClose: function() {
                    return setPopUpOpen(false);
                },
                modelName: modelName,
                data: selectedData
            })
        ]
    });
};
/* harmony default export */ var finishingLevels_FinishingLevelsSection = (FinishingLevelsSection);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Tabs/Tabs.js + 7 modules
var Tabs = __webpack_require__(57821);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Tab/Tab.js
var Tab = __webpack_require__(41423);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
;// CONCATENATED MODULE: ./components/carModelPage/sections/illustrateSize/ImageWithButtons/IllustrateIcons.tsx




var IconBaby = function(_param) {
    var props = (0,_extends/* default */.Z)({}, _param);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "24",
        height: "24",
        viewBox: "0 0 25 25",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            id: "u:baby-carriage",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                id: "Vector",
                d: "M19.25 16.5C18.6567 16.5 18.0766 16.6759 17.5833 17.0056C17.0899 17.3352 16.7054 17.8038 16.4784 18.3519C16.2513 18.9001 16.1919 19.5033 16.3076 20.0853C16.4234 20.6672 16.7091 21.2018 17.1287 21.6213C17.5482 22.0409 18.0828 22.3266 18.6647 22.4424C19.2467 22.5581 19.8499 22.4987 20.3981 22.2716C20.9462 22.0446 21.4148 21.6601 21.7444 21.1667C22.0741 20.6734 22.25 20.0933 22.25 19.5C22.25 18.7044 21.9339 17.9413 21.3713 17.3787C20.8087 16.8161 20.0456 16.5 19.25 16.5ZM19.25 20.5C19.0522 20.5 18.8589 20.4414 18.6944 20.3315C18.53 20.2216 18.4018 20.0654 18.3261 19.8827C18.2504 19.7 18.2306 19.4989 18.2692 19.3049C18.3078 19.1109 18.403 18.9327 18.5429 18.7929C18.6827 18.653 18.8609 18.5578 19.0549 18.5192C19.2489 18.4806 19.45 18.5004 19.6327 18.5761C19.8154 18.6518 19.9716 18.78 20.0815 18.9444C20.1914 19.1089 20.25 19.3022 20.25 19.5C20.25 19.7652 20.1446 20.0196 19.9571 20.2071C19.7696 20.3946 19.5152 20.5 19.25 20.5ZM9.25 16.5C8.65666 16.5 8.07664 16.6759 7.58329 17.0056C7.08994 17.3352 6.70542 17.8038 6.47836 18.3519C6.2513 18.9001 6.19189 19.5033 6.30764 20.0853C6.4234 20.6672 6.70912 21.2018 7.12868 21.6213C7.54824 22.0409 8.08279 22.3266 8.66473 22.4424C9.24667 22.5581 9.84987 22.4987 10.3981 22.2716C10.9462 22.0446 11.4148 21.6601 11.7444 21.1667C12.0741 20.6734 12.25 20.0933 12.25 19.5C12.25 18.7044 11.9339 17.9413 11.3713 17.3787C10.8087 16.8161 10.0456 16.5 9.25 16.5ZM9.25 20.5C9.05222 20.5 8.85888 20.4414 8.69443 20.3315C8.52998 20.2216 8.40181 20.0654 8.32612 19.8827C8.25043 19.7 8.23063 19.4989 8.26921 19.3049C8.3078 19.1109 8.40304 18.9327 8.54289 18.7929C8.68275 18.653 8.86093 18.5578 9.05491 18.5192C9.24889 18.4806 9.44996 18.5004 9.63268 18.5761C9.81541 18.6518 9.97159 18.78 10.0815 18.9444C10.1914 19.1089 10.25 19.3022 10.25 19.5C10.25 19.7652 10.1446 20.0196 9.95711 20.2071C9.76957 20.3946 9.51522 20.5 9.25 20.5ZM22.25 9C22.2474 7.27691 21.5617 5.62514 20.3433 4.40673C19.1249 3.18831 17.4731 2.50264 15.75 2.5H15.25C14.9848 2.5 14.7304 2.60536 14.5429 2.79289C14.3554 2.98043 14.25 3.23478 14.25 3.5V8.5H7.77L6.52 5.15C6.44849 4.9586 6.32006 4.7937 6.152 4.67749C5.98395 4.56128 5.78432 4.49934 5.58 4.5H3.25C2.98478 4.5 2.73043 4.60536 2.54289 4.79289C2.35536 4.98043 2.25 5.23478 2.25 5.5C2.25 5.76522 2.35536 6.01957 2.54289 6.20711C2.73043 6.39464 2.98478 6.5 3.25 6.5H4.89L6.14 9.87L6.65 11.24V11.33C7.11587 12.5671 7.95115 13.6309 9.04245 14.3769C10.1337 15.1229 11.4282 15.515 12.75 15.5H15.75C16.604 15.5013 17.4498 15.3341 18.239 15.0079C19.0282 14.6817 19.7453 14.203 20.3491 13.5991C20.953 12.9953 21.4317 12.2782 21.7579 11.489C22.0841 10.6998 22.2513 9.85396 22.25 9ZM18.93 12.18C18.5135 12.5993 18.018 12.9319 17.4722 13.1585C16.9264 13.385 16.341 13.5011 15.75 13.5H12.75C11.8561 13.5027 10.9819 13.2374 10.2404 12.7383C9.49883 12.2392 8.92395 11.5292 8.59 10.7C8.58566 10.6802 8.58566 10.6598 8.59 10.64L8.51 10.5H19.99C19.772 11.1347 19.409 11.7099 18.93 12.18ZM16.25 8.5V4.5C17.2744 4.60684 18.2309 5.0626 18.9591 5.79087C19.6874 6.51913 20.1432 7.47563 20.25 8.5H16.25Z",
                strokeWidth: "0.5"
            })
        })
    }));
};
var IconBag = function(_param) {
    var props = (0,_extends/* default */.Z)({}, _param);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "24",
        height: "24",
        viewBox: "0 0 25 25",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            id: "u:bag",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                id: "Vector",
                d: "M19.25 6.5H16.25V5.5C16.25 4.96957 16.0393 4.46086 15.6642 4.08579C15.2891 3.71071 14.7804 3.5 14.25 3.5H10.25C9.71957 3.5 9.21086 3.71071 8.83579 4.08579C8.46071 4.46086 8.25 4.96957 8.25 5.5V6.5H5.25C4.45435 6.5 3.69129 6.81607 3.12868 7.37868C2.56607 7.94129 2.25 8.70435 2.25 9.5V18.5C2.25 19.2956 2.56607 20.0587 3.12868 20.6213C3.69129 21.1839 4.45435 21.5 5.25 21.5H19.25C20.0456 21.5 20.8087 21.1839 21.3713 20.6213C21.9339 20.0587 22.25 19.2956 22.25 18.5V9.5C22.25 8.70435 21.9339 7.94129 21.3713 7.37868C20.8087 6.81607 20.0456 6.5 19.25 6.5ZM10.25 5.5H14.25V6.5H10.25V5.5ZM20.25 18.5C20.25 18.7652 20.1446 19.0196 19.9571 19.2071C19.7696 19.3946 19.5152 19.5 19.25 19.5H5.25C4.98478 19.5 4.73043 19.3946 4.54289 19.2071C4.35536 19.0196 4.25 18.7652 4.25 18.5V12.89L8.93 14.5C9.03618 14.5144 9.14382 14.5144 9.25 14.5H15.25C15.3584 14.498 15.4661 14.4812 15.57 14.45L20.25 12.89V18.5ZM20.25 10.78L15.09 12.5H9.41L4.25 10.78V9.5C4.25 9.23478 4.35536 8.98043 4.54289 8.79289C4.73043 8.60536 4.98478 8.5 5.25 8.5H19.25C19.5152 8.5 19.7696 8.60536 19.9571 8.79289C20.1446 8.98043 20.25 9.23478 20.25 9.5V10.78Z",
                strokeWidth: "0.5"
            })
        })
    }));
};
var IconTrolly = function(_param) {
    var props = (0,_extends/* default */.Z)({}, _param);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "24",
        height: "24",
        viewBox: "0 0 22 22",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            id: "fi_10858654",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    id: "Vector",
                    d: "M12.8144 4.33306H13.5572C15.115 4.33306 16.3438 5.70503 16.3438 7.34911V16.6098C16.3438 18.1135 15.3147 19.3855 13.9525 19.5957C13.9776 19.6966 13.9908 19.8025 13.9908 19.9115C13.9908 20.5644 13.5018 21.1303 12.8523 21.1303C12.2029 21.1303 11.7138 20.5644 11.7138 19.9115C11.7138 19.8136 11.7249 19.7179 11.7458 19.6259H9.7552C9.77569 19.7176 9.7864 19.8133 9.7864 19.9115C9.7864 20.5644 9.29731 21.1303 8.64786 21.1303C7.99841 21.1303 7.50932 20.5644 7.50932 19.9115C7.50932 19.8025 7.5225 19.6967 7.5476 19.5959C6.18149 19.3862 5.15641 18.1141 5.15641 16.6098L5.15641 7.34963L5.15641 7.34881C5.16176 5.70604 6.39002 4.33358 7.94794 4.33358H8.6808V2.59508C8.39119 2.44301 8.20427 2.1263 8.20427 1.77958C8.20427 1.29995 8.5692 0.869141 9.05986 0.869141H12.4453C12.9358 0.869141 13.3009 1.2993 13.3009 1.77958C13.3009 2.13336 13.1082 2.45039 12.8144 2.60152V4.33306ZM11.9173 2.69002H9.57295V4.33358H11.9173V2.69002ZM12.6109 19.9115C12.6109 20.0881 12.7387 20.1971 12.8523 20.1971C12.9674 20.1971 13.0937 20.0916 13.0937 19.9115C13.0937 19.7314 12.9674 19.6259 12.8523 19.6259C12.7387 19.6259 12.6109 19.7349 12.6109 19.9115ZM8.65282 20.1971C8.7645 20.1971 8.89425 20.0899 8.89425 19.9115C8.89425 19.7314 8.7679 19.6259 8.65282 19.6259C8.53774 19.6259 8.41139 19.7314 8.41139 19.9115C8.41139 20.0916 8.53775 20.1971 8.65282 20.1971ZM6.05849 16.6098C6.05849 17.7807 6.92453 18.6927 7.94794 18.6927H13.5572C14.5806 18.6927 15.4466 17.7807 15.4466 16.6098V7.34963C15.4466 6.17877 14.5806 5.26677 13.5572 5.26677H7.94794C6.92453 5.26677 6.05849 6.17877 6.05849 7.34963V16.6098Z",
                    strokeWidth: "0.5"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    id: "Vector_2",
                    d: "M13.5553 8.67383C13.7904 8.67383 14.0234 8.85311 14.0234 9.12228V18.7346C14.0234 19.0038 13.7904 19.1831 13.5553 19.1831C13.3201 19.1831 13.0871 19.0038 13.0871 18.7346V9.12228C13.0871 8.84463 13.3242 8.67383 13.5553 8.67383Z",
                    strokeWidth: "0.5"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    id: "Vector_3",
                    d: "M8.12362 8.67383C8.35877 8.67383 8.5918 8.85311 8.5918 9.12228V18.7346C8.5918 19.0038 8.35878 19.1831 8.12362 19.1831C7.88846 19.1831 7.65543 19.0038 7.65543 18.7346V9.12228C7.65543 8.84463 7.89257 8.67383 8.12362 8.67383Z",
                    strokeWidth: "0.5"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    id: "Vector_4",
                    d: "M10.8394 8.67383C11.0746 8.67383 11.3076 8.85311 11.3076 9.12228V18.7346C11.3076 19.0038 11.0746 19.1831 10.8394 19.1831C10.6043 19.1831 10.3713 19.0038 10.3713 18.7346V9.12228C10.3713 8.84463 10.6084 8.67383 10.8394 8.67383Z",
                    strokeWidth: "0.5"
                })
            ]
        })
    }));
};
var IconSuitcase = function(_param) {
    var props = (0,_extends/* default */.Z)({}, _param);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "24",
        height: "24",
        viewBox: "0 0 25 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            id: "fi_8451103",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                id: "Group 325",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                    id: "Group 324",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                            id: "Rectangle 4112",
                            x: "2.64062",
                            y: "7.67188",
                            width: "19.1523",
                            height: "12.4492",
                            rx: "1",
                            strokeWidth: "2"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            id: "Rectangle 4113",
                            d: "M7.74219 20.1211L7.74219 3.92383C7.74219 3.37154 8.1899 2.92383 8.74219 2.92383L15.6904 2.92383C16.2427 2.92383 16.6904 3.37154 16.6904 3.92383L16.6904 20.1211L7.74219 20.1211Z",
                            strokeWidth: "2"
                        })
                    ]
                })
            })
        })
    }));
};
var IconChild = function(_param) {
    var props = (0,_extends/* default */.Z)({}, _param);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 22 25",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.009 3.79183L20.01 3.79251C20.557 4.14708 20.6664 4.9111 20.2407 5.409C19.1457 6.65589 17.3299 8.29981 14.8172 9.19752L14.3195 9.37532V9.90379V9.90382V9.90385V9.90388V9.9039V9.90393V9.90396V9.90399V9.90401V9.90404V9.90407V9.9041V9.90412V9.90415V9.90418V9.90421V9.90423V9.90426V9.90429V9.90432V9.90434V9.90437V9.9044V9.90443V9.90445V9.90448V9.90451V9.90454V9.90456V9.90459V9.90462V9.90465V9.90467V9.9047V9.90473V9.90476V9.90478V9.90481V9.90484V9.90487V9.90489V9.90492V9.90495V9.90498V9.905V9.90503V9.90506V9.90509V9.90511V9.90514V9.90517V9.90519V9.90522V9.90525V9.90528V9.9053V9.90533V9.90536V9.90539V9.90541V9.90544V9.90547V9.9055V9.90552V9.90555V9.90558V9.90561V9.90563V9.90566V9.90569V9.90572V9.90574V9.90577V9.9058V9.90583V9.90585V9.90588V9.90591V9.90594V9.90596V9.90599V9.90602V9.90605V9.90607V9.9061V9.90613V9.90616V9.90618V9.90621V9.90624V9.90627V9.90629V9.90632V9.90635V9.90638V9.9064V9.90643V9.90646V9.90649V9.90651V9.90654V9.90657V9.9066V9.90662V9.90665V9.90668V9.90671V9.90673V9.90676V9.90679V9.90682V9.90684V9.90687V9.9069V9.90693V9.90695V9.90698V9.90701V9.90704V9.90706V9.90709V9.90712V9.90715V9.90717V9.9072V9.90723V9.90725V9.90728V9.90731V9.90734V9.90736V9.90739V9.90742V9.90745V9.90747V9.9075V9.90753V9.90756V9.90758V9.90761V9.90764V9.90767V9.90769V9.90772V9.90775V9.90778V9.9078V9.90783V9.90786V9.90789V9.90791V9.90794V9.90797V9.908V9.90802V9.90805V9.90808V9.90811V9.90813V9.90816V9.90819V9.90822V9.90824V9.90827V9.9083V9.90833V9.90835V9.90838V9.90841V9.90844V9.90846V9.90849V9.90852V9.90855V9.90857V9.9086V9.90863V9.90866V9.90868V9.90871V9.90874V9.90877V9.90879V9.90882V9.90885V9.90888V9.9089V9.90893V9.90896V9.90899V9.90901V9.90904V9.90907V9.90909V9.90912V9.90915V9.90918V9.9092V9.90923V9.90926V9.90929V9.90931V9.90934V9.90937V9.9094V9.90942V9.90945V9.90948V9.90951V9.90953V9.90956V9.90959V9.90962V9.90964V9.90967V9.9097V9.90973V9.90975V9.90978V9.90981V9.90984V9.90986V9.90989V9.90992V9.90995V9.90997V9.91V9.91003V9.91006V9.91008V9.91011V9.91014V9.91017V9.91019V9.91022V9.91025V9.91028V9.9103V9.91033V9.91036V9.91039V9.91041V9.91044V9.91047V9.9105V9.91052V9.91055V9.91058V9.91061V9.91063V9.91066V9.91069V9.91072V9.91074V9.91077V9.9108V9.91083V9.91085V9.91088V9.91091V9.91093V9.91096V9.91099V9.91102V9.91105V9.91107V9.9111V9.91113V9.91115V9.91118V9.91121V9.91124V9.91126V9.91129V9.91132V9.91135V9.91137V9.9114V9.91143V9.91146V9.91148V9.91151V9.91154V9.91157V9.91159V9.91162V9.91165V9.91168V9.9117V9.91173V9.91176V9.91179V9.91181V9.91184V9.91187V9.9119V9.91192V9.91195V9.91198V9.91201V9.91203V9.91206V9.91209V9.91212V9.91214V9.91217V9.9122V9.91223V9.91225V9.91228V9.91231V9.91234V9.91236V9.91239V9.91242V9.91245V9.91247V9.9125V9.91253V9.91256V9.91258V9.91261V9.91264V9.91267V9.91269V9.91272V9.91275V9.91278V9.9128V9.91283V9.91286V9.91289V9.91291V9.91294V9.91297V9.91299V9.91302V9.91305V9.91308V9.91311V9.91313V9.91316V9.91319V9.91321V9.91324V9.91327V9.9133V9.91332V9.91335V9.91338V9.91341V9.91343V9.91346V9.91349V9.91352V9.91354V9.91357V9.9136V9.91363V9.91365V9.91368V9.91371V9.91374V9.91376V9.91379V9.91382V9.91385V9.91387V9.9139V9.91393V9.91396V9.91398V9.91401V9.91404V9.91407V9.91409V9.91412V9.91415V9.91418V9.9142V9.91423V9.91426V9.91429V9.91431V9.91434V9.91437V9.9144V9.91442V9.91445V9.91448V9.91451V9.91453V9.91456V9.91459V9.91462V9.91464V9.91467V9.9147V9.91473V9.91475V9.91478V9.91481V9.91483V9.91486V9.91489V9.91492V9.91495V9.91497V9.915V9.91503V9.91505V9.91508V9.91511V9.91514V9.91516V9.91519V9.91522V9.91525V9.91527V9.9153V9.91533V9.91536V9.91538V9.91541V9.91544V9.91547V9.91549V9.91552V9.91555V9.91558V9.9156V9.91563V9.91566V9.91569V9.91571V9.91574V9.91577V9.9158V9.91582V9.91585V9.91588V9.91591V9.91593V9.91596V9.91599V9.91602V9.91604V9.91607V9.9161V9.91613V9.91615V9.91618V9.91621V9.91624V9.91626V9.91629V9.91632V9.91635V9.91637V9.9164V9.91643V9.91646V9.91648V9.91651V9.91654V9.91657V9.91659V9.91662V9.91665V9.91668V9.9167V9.91673V9.91676V9.91679V9.91681V9.91684V9.91687V9.91689V9.91692V9.91695V9.91698V9.917V9.91703V9.91706V9.91709V9.91711V9.91714V9.91717V9.9172V9.91722V9.91725V9.91728V9.91731V9.91733V9.91736V9.91739V9.91742V9.91744V9.91747V9.9175V9.91753V9.91755V9.91758V9.91761V9.91764V9.91766V9.91769V9.91772V9.91775V9.91777V9.9178V9.91783V9.91786V22.8272C14.3195 23.3365 13.9053 23.7507 13.3961 23.7507C12.8869 23.7507 12.4727 23.3365 12.4727 22.8272V17.5913V16.8413H11.7227H10.2883H9.53829V17.5913V22.8225C9.53829 23.3318 9.12408 23.746 8.61485 23.746C8.10563 23.746 7.69141 23.3318 7.69141 22.8225V9.91317V9.89911V9.37063L7.19375 9.19283C4.67898 8.29438 2.86231 6.64851 1.76759 5.40124L1.76759 5.40124L1.76639 5.39987C1.33479 4.91054 1.43666 4.14815 1.98804 3.78707C2.44182 3.49354 3.04583 3.58267 3.39868 4.00499L3.39868 4.00499L3.40018 4.00678C4.58897 5.4206 6.90148 7.55894 10.2164 7.85703L10.2499 7.86004H10.2836H11.7086H11.7423L11.7758 7.85703C15.0907 7.55894 17.4032 5.4206 18.592 4.00678C18.9464 3.5855 19.5521 3.49458 20.009 3.79183Z",
                stroke: "inherit",
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.1992 3.45312C13.1992 4.66988 12.2128 5.65625 10.9961 5.65625C9.77934 5.65625 8.79297 4.66988 8.79297 3.45312C8.79297 2.23637 9.77934 1.25 10.9961 1.25C12.2128 1.25 13.1992 2.23637 13.1992 3.45312Z",
                stroke: "inherit",
                strokeWidth: "1.5"
            })
        ]
    }));
};
var IconSit = function(_param) {
    var props = (0,_extends/* default */.Z)({}, _param);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 25",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "mask0_11931_14847",
                style: {
                    maskType: "luminance"
                },
                maskUnits: "userSpaceOnUse",
                x: "0",
                y: "-1",
                width: "24",
                height: "27",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M24 -0.00195312H0V25.002H24V-0.00195312Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                mask: "url(#mask0_11931_14847)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M19.115 9.76472C19.2655 8.80753 19.4342 7.89441 19.5992 7.0567C20.3741 3.11733 17.7566 0.959672 12.0566 0.99436C6.35699 0.959672 3.73902 3.11733 4.51438 7.0567C5.02714 9.66253 5.57652 13.0005 5.49875 16.1191",
                        strokeWidth: "1.3",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M18.8857 11.1931C18.6959 12.7861 18.5782 14.4446 18.6125 16.0488",
                        strokeWidth: "1.3",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M16.6001 18.4902C16.8096 17.6356 17.0913 16.4074 17.1251 15.8424C17.201 14.5775 16.9193 11.8178 16.6779 9.78668C16.5316 8.55406 16.1055 7.39084 15.4479 6.40529",
                        strokeWidth: "1.3",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M8.66699 6.40919C8.00934 7.39474 7.58324 8.55796 7.43652 9.79058C7.19559 11.8217 6.91391 14.5814 6.98934 15.8463C7.02402 16.423 7.31699 17.6908 7.52793 18.5469",
                        strokeWidth: "1.3",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M18.7695 21.0487C18.6744 22.1705 18.0336 23.4319 17.1378 24.4721C17.0487 24.5757 16.9212 24.6348 16.7881 24.6348H10.977",
                        strokeWidth: "1.3",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M9.33594 24.6348H7.32594C7.19239 24.6348 7.06536 24.5757 6.97625 24.4721C6.10672 23.4632 5.47812 22.2457 5.35442 21.1494",
                        strokeWidth: "1.3",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M15.4205 4.06312C15.6206 4.75635 15.7259 5.45616 15.6934 6.1301C15.6859 6.28525 15.5652 6.40817 15.4161 6.40817C13.1769 6.40822 10.9377 6.40822 8.69857 6.40817C8.54942 6.40817 8.42871 6.28525 8.42121 6.1301C8.38873 5.45616 8.49401 4.75635 8.69417 4.06312C8.95165 3.17089 9.73864 2.55879 10.6328 2.55879H13.4818C14.376 2.55879 15.163 3.17089 15.4205 4.06312Z",
                        strokeWidth: "1.3",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M3.4793 16.304L3.90019 16.0507C4.56577 15.6502 5.4144 15.8405 5.86294 16.4909L6.99919 18.1386C7.19766 18.4264 7.51707 18.5971 7.85724 18.5971H16.144C16.4842 18.5971 16.8036 18.4264 17.002 18.1386L18.1383 16.4909C18.5868 15.8405 19.4355 15.6502 20.1011 16.0507L20.5219 16.304C20.9661 16.5714 21.1182 17.1632 20.8616 17.6259L19.3991 20.2637C18.8946 21.1738 17.9624 21.7344 16.9536 21.7344H7.04766C6.03887 21.7344 5.10671 21.1738 4.6021 20.2637L3.1396 17.6259C2.88301 17.1632 3.03507 16.5714 3.4793 16.304Z",
                        strokeWidth: "1.3",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M11.5574 16.0645H12.5553C13.6585 16.0645 14.5527 15.1328 14.5527 13.9835V13.8C14.5527 13.381 14.2267 13.0413 13.8245 13.0413H10.2882C9.886 13.0413 9.55994 13.381 9.55994 13.8V13.9835C9.55994 15.1328 10.4543 16.0645 11.5574 16.0645Z",
                        strokeWidth: "1.3",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            })
        ]
    }));
};
var IconBooster = function(_param) {
    var props = (0,_extends/* default */.Z)({}, _param);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 25",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "mask0_11931_14832",
                style: {
                    maskType: "luminance"
                },
                maskUnits: "userSpaceOnUse",
                x: "0",
                y: "0",
                width: "24",
                height: "25",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M24 0.5H0V24.5H24V0.5Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                mask: "url(#mask0_11931_14832)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M19.5992 10.8145C20.3741 7.03324 17.7566 4.96222 12.0566 4.99552C6.35698 4.96222 3.73902 7.03324 4.51437 10.8145",
                        strokeWidth: "1.3",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M16.0438 13.2812C16.4534 11.2824 15.0698 10.1876 12.0566 10.2052C9.04373 10.1876 7.65981 11.2824 8.06968 13.2812",
                        strokeWidth: "1.3",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M18.7695 16.5657C18.6744 17.6425 18.0336 18.8533 17.1378 19.8517C17.0487 19.9511 16.9212 20.0078 16.7881 20.0078H10.977",
                        strokeWidth: "1.3",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M9.33594 20.0078H7.32594C7.19239 20.0078 7.06536 19.9511 6.97625 19.8517C6.10672 18.8833 5.47812 17.7147 5.35442 16.6623",
                        strokeWidth: "1.3",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M3.4793 12.0103L3.90019 11.7672C4.56577 11.3827 5.4144 11.5655 5.86294 12.1897L6.99919 13.7713C7.19766 14.0475 7.51707 14.2113 7.85724 14.2113H16.144C16.4842 14.2113 16.8036 14.0475 17.002 13.7713L18.1383 12.1897C18.5868 11.5655 19.4355 11.3827 20.1011 11.7672L20.5219 12.0103C20.9661 12.2669 21.1182 12.835 20.8616 13.2792L19.3991 15.8111C18.8946 16.6846 17.9624 17.2227 16.9536 17.2227H7.04766C6.03887 17.2227 5.10671 16.6846 4.6021 15.8111L3.1396 13.2792C2.88301 12.835 3.03507 12.2669 3.4793 12.0103Z",
                        strokeWidth: "1.3",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            })
        ]
    }));
};
var IconCarTop = function(_param) {
    var props = (0,_extends/* default */.Z)({}, _param);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 14 25",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.4397 7.36822L11.4397 7.3683L11.2433 9.78175C11.2433 9.78182 11.2433 9.78188 11.2433 9.78195C11.2294 9.95302 11.1326 10.0977 10.9986 10.1893C10.867 10.2794 10.7047 10.3177 10.5435 10.2995C10.5432 10.2995 10.5429 10.2995 10.5426 10.2994L10.5423 10.2994C10.4646 10.291 8.49156 10.0781 7.00001 10.0781C5.50762 10.0781 3.53608 10.2909 3.45775 10.2994L3.45678 10.2995L3.45553 10.2996L3.42909 10.051C3.41261 10.0529 3.39631 10.0538 3.38002 10.0538C3.29396 10.0538 3.20991 10.029 3.14253 9.98295L11.4397 7.36822ZM11.4397 7.36822C11.4502 7.23918 11.4116 7.11442 11.336 7.01266M11.4397 7.36822L3.00144 10.1893C2.86742 10.0978 2.77061 9.95304 2.75676 9.78195C2.75675 9.78193 2.75675 9.78191 2.75675 9.78189C2.75675 9.78184 2.75674 9.7818 2.75674 9.78175L2.56028 7.3683L2.56028 7.36822C2.54981 7.23913 2.58845 7.11433 2.66407 7.01253M2.66407 7.01253L2.86475 7.16161L2.66398 7.01266C2.66401 7.01262 2.66404 7.01258 2.66407 7.01253ZM2.66407 7.01253C2.74627 6.90181 3.93649 5.38281 7.00001 5.38281C10.0647 5.38281 11.2546 6.90292 11.336 7.01266M11.336 7.01266L11.1353 7.16162L11.3359 7.01253C11.336 7.01258 11.336 7.01262 11.336 7.01266ZM7.00001 6.50964C8.92068 6.50964 9.86242 7.21439 10.1747 7.51128L10.044 9.11648C9.30382 9.04856 8.05904 8.95125 7.00001 8.95125C5.94098 8.95125 4.6962 9.04856 3.95599 9.11648L3.82529 7.51161C4.13876 7.21363 5.08032 6.50964 7.00001 6.50964Z",
                fill: "#101010",
                strokeWidth: "0.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.9715 19.9428C11.1714 19.8537 11.3224 19.6623 11.3224 19.4276V16.3249C11.3224 15.9747 11.0062 15.752 10.6974 15.752H3.33203L3.05818 19.9429M10.9715 19.9428L10.8699 19.7147L10.9717 19.9427C10.9717 19.9427 10.9716 19.9428 10.9715 19.9428ZM10.9715 19.9428C10.8868 19.9806 9.4474 20.6039 7.01483 20.6039C4.58197 20.6039 3.14262 19.9805 3.05818 19.9429M3.05818 19.9429L3.15972 19.7145L3.05802 19.9428C3.05807 19.9428 3.05813 19.9429 3.05818 19.9429ZM10.0724 16.8979V19.0362C9.55565 19.1979 8.49381 19.458 7.01483 19.458C5.5356 19.458 4.4735 19.1977 3.95703 19.0362V16.8979H10.0724Z",
                fill: "#101010",
                strokeWidth: "0.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.052 14.6943C12.1025 16.2498 12.1597 18.0126 12.1597 21.1318C12.1597 21.1754 12.152 21.2188 12.1371 21.2598C12.1002 21.3616 11.1843 23.75 6.99993 23.75C2.81561 23.75 1.89971 21.3616 1.86272 21.2598C1.84789 21.2188 1.8402 21.1754 1.8402 21.1318C1.8402 18.0126 1.89733 16.2498 1.94787 14.6943M12.052 14.6943L12.3019 14.6863L12.3019 14.6862M12.052 14.6943L12.3019 14.6862M12.052 14.6943L12.0515 14.6789C12.0096 13.3821 11.9733 12.2586 11.9806 10.6312C11.9825 10.2134 12.0172 9.68609 12.0603 9.11659L12.2667 9.30867L12.2667 9.30872L12.2993 9.27375C12.2993 9.27372 12.2993 9.27368 12.2993 9.27365L1.58467 7.73929M12.3019 14.6862C12.3524 16.243 12.4097 18.0087 12.4097 21.1318C12.4097 21.2047 12.3968 21.2768 12.3722 21.3448L12.3721 21.3451C12.343 21.4252 12.0827 22.0913 11.2807 22.7377C10.4751 23.387 9.14313 24 6.99993 24C4.85673 24 3.52476 23.387 2.71919 22.7377C1.91719 22.0913 1.65684 21.4252 1.62775 21.3451L1.62762 21.3448C1.60305 21.2768 1.5902 21.2047 1.5902 21.1318C1.5902 18.0088 1.64742 16.243 1.698 14.6863L1.94787 14.6943M12.3019 14.6862L12.3014 14.6717C12.2595 13.3749 12.2233 12.2552 12.2306 10.6323C12.2322 10.2715 12.259 9.82466 12.2949 9.33343C12.4104 9.42885 12.5519 9.47626 12.6925 9.47626C12.8592 9.47626 13.027 9.40946 13.1502 9.2768C13.3854 9.02409 13.3706 8.62879 13.1183 8.39382L13.1183 8.3938L12.4152 7.73929C12.4798 6.81239 12.5244 5.85131 12.4599 5.07578L12.4599 5.07572C12.2916 3.05726 10.0211 1 6.99993 1C3.97877 1 1.7083 3.05726 1.53998 5.07572L1.53998 5.07578C1.4755 5.85131 1.52006 6.81239 1.58467 7.73929M1.94787 14.6943L1.698 14.6862M1.94787 14.6943L1.94837 14.6788C1.99027 13.3821 2.02658 12.2586 2.01928 10.6312C2.01741 10.2134 1.98263 9.68609 1.93953 9.11659L1.7332 9.30867C1.73318 9.30868 1.73316 9.3087 1.73314 9.30872C1.72394 9.31728 1.71455 9.32552 1.70497 9.33343M1.698 14.6862L1.05193 8.57678C0.900323 8.71796 0.891717 8.95526 1.03289 9.10669C1.10668 9.18616 1.20702 9.22626 1.30737 9.22626C1.39892 9.22626 1.49065 9.19293 1.5628 9.12573M1.698 14.6862L1.69848 14.6715C1.74038 13.3748 1.77656 12.2551 1.76928 10.6323C1.76766 10.2715 1.74086 9.82466 1.70497 9.33343M1.698 14.6862L0.849841 9.27696M1.70497 9.33343C1.70353 9.31361 1.70206 9.29371 1.70059 9.27375L1.5628 9.12573M1.70497 9.33343C1.58946 9.42885 1.44796 9.47626 1.30737 9.47626C1.1407 9.47626 0.973005 9.40951 0.849841 9.27696M1.5628 9.12573L1.70058 9.27365C1.69431 9.18882 1.68779 9.10273 1.6811 9.0156L1.5628 9.12573ZM1.58467 7.73929L0.881591 8.3938L0.881567 8.39382C0.629172 8.62884 0.614451 9.02425 0.849841 9.27696M1.58467 7.73929L0.849692 9.2768C0.849742 9.27686 0.849791 9.27691 0.849841 9.27696M11.0993 8.57138L11.0993 8.57144L11.0987 8.57916C11.0398 9.3335 10.9832 10.0592 10.9806 10.6268V10.6268C10.9733 12.2761 11.01 13.4108 11.0524 14.7186L11.0527 14.7268V14.7268C11.1021 16.2525 11.158 17.9774 11.1596 20.9963C11.071 21.1643 10.8178 21.5632 10.2587 21.9374C9.63751 22.3533 8.62204 22.75 6.99993 22.75C5.37359 22.75 4.35856 22.355 3.73877 21.9403C3.1797 21.5663 2.92842 21.167 2.84023 20.9975C2.84184 17.978 2.89773 16.253 2.94718 14.7271L2.94719 14.7268L2.94745 14.7186C2.98983 13.4108 3.02661 12.2761 3.01928 10.6268L3.01928 10.6268C3.01667 10.0592 2.96005 9.33341 2.90119 8.57903L2.9006 8.57144L2.9006 8.57138C2.80901 7.40062 2.70865 6.10537 2.78569 5.17953C2.8324 4.61943 3.22507 3.88689 3.9532 3.28835C4.67413 2.69571 5.70732 2.25 6.99993 2.25C8.29255 2.25 9.32573 2.69571 10.0467 3.28835C10.7748 3.88688 11.1674 4.61939 11.2142 5.17949C11.2912 6.10533 11.1909 7.4006 11.0993 8.57138Z",
                fill: "inherit",
                strokeWidth: "0.5"
            })
        ]
    }));
};
var IconCarSide = function(_param) {
    var props = (0,_extends/* default */.Z)({}, _param);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 25"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M19 10H18.68L17.43 6.88001C17.2068 6.32527 16.8228 5.8499 16.3275 5.51492C15.8321 5.17993 15.248 5.00063 14.65 5.00001H8.65C7.95529 4.99802 7.28142 5.2372 6.74342 5.67673C6.20541 6.11625 5.83662 6.72886 5.7 7.41001L5.18 10H5C4.20435 10 3.44129 10.3161 2.87868 10.8787C2.31607 11.4413 2 12.2044 2 13V16C2 16.2652 2.10536 16.5196 2.29289 16.7071C2.48043 16.8947 2.73478 17 3 17H4C4 17.7957 4.31607 18.5587 4.87868 19.1213C5.44129 19.6839 6.20435 20 7 20C7.79565 20 8.55871 19.6839 9.12132 19.1213C9.68393 18.5587 10 17.7957 10 17H14C14 17.7957 14.3161 18.5587 14.8787 19.1213C15.4413 19.6839 16.2044 20 17 20C17.7956 20 18.5587 19.6839 19.1213 19.1213C19.6839 18.5587 20 17.7957 20 17H21C21.2652 17 21.5196 16.8947 21.7071 16.7071C21.8946 16.5196 22 16.2652 22 16V13C22 12.2044 21.6839 11.4413 21.1213 10.8787C20.5587 10.3161 19.7956 10 19 10ZM13 7.00001H14.65C14.8486 7.00181 15.0421 7.06269 15.206 7.17488C15.3698 7.28708 15.4965 7.44552 15.57 7.63001L16.52 10H13V7.00001ZM7.66 7.80001C7.70675 7.57074 7.83242 7.36511 8.01514 7.21894C8.19786 7.07277 8.42605 6.99529 8.66 7.00001H11V10H7.22L7.66 7.80001ZM7 18C6.80222 18 6.60888 17.9414 6.44443 17.8315C6.27998 17.7216 6.15181 17.5654 6.07612 17.3827C6.00043 17.2 5.98063 16.9989 6.01921 16.8049C6.0578 16.6109 6.15304 16.4328 6.29289 16.2929C6.43275 16.1531 6.61093 16.0578 6.80491 16.0192C6.99889 15.9806 7.19996 16.0004 7.38268 16.0761C7.56541 16.1518 7.72159 16.28 7.83147 16.4444C7.94135 16.6089 8 16.8022 8 17C8 17.2652 7.89464 17.5196 7.70711 17.7071C7.51957 17.8947 7.26522 18 7 18ZM17 18C16.8022 18 16.6089 17.9414 16.4444 17.8315C16.28 17.7216 16.1518 17.5654 16.0761 17.3827C16.0004 17.2 15.9806 16.9989 16.0192 16.8049C16.0578 16.6109 16.153 16.4328 16.2929 16.2929C16.4327 16.1531 16.6109 16.0578 16.8049 16.0192C16.9989 15.9806 17.2 16.0004 17.3827 16.0761C17.5654 16.1518 17.7216 16.28 17.8315 16.4444C17.9414 16.6089 18 16.8022 18 17C18 17.2652 17.8946 17.5196 17.7071 17.7071C17.5196 17.8947 17.2652 18 17 18ZM20 15H19.22C18.9388 14.6907 18.5961 14.4435 18.2138 14.2743C17.8315 14.1052 17.418 14.0178 17 14.0178C16.582 14.0178 16.1685 14.1052 15.7862 14.2743C15.4039 14.4435 15.0612 14.6907 14.78 15H9.22C8.93882 14.6907 8.59609 14.4435 8.21378 14.2743C7.83148 14.1052 7.41805 14.0178 7 14.0178C6.58195 14.0178 6.16852 14.1052 5.78622 14.2743C5.40391 14.4435 5.06118 14.6907 4.78 15H4V13C4 12.7348 4.10536 12.4804 4.29289 12.2929C4.48043 12.1054 4.73478 12 5 12H19C19.2652 12 19.5196 12.1054 19.7071 12.2929C19.8946 12.4804 20 12.7348 20 13V15Z"
        })
    }));
};

;// CONCATENATED MODULE: ./components/carModelPage/sections/illustrateSize/ImageWithButtons/ImageWithButtons.tsx


function ImageWithButtons_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  h2 {\n    font-weight: normal;\n    width: 100%;\n    text-align: center;\n    ",
        " {\n      padding: 26px 8px 32px;\n      text-align: start;\n      margin: 0;\n    }\n  }\n  img {\n    object-fit: cover;\n  }\n  .buttons-wrapper {\n    margin: 16px 20px;\n    ",
        " {\n      margin: 30px 8px 16px;\n    }\n    .icon-buttons > div {\n      gap: 16px;\n      ",
        " {\n        justify-content: start;\n      }\n      > button > label > div {\n        padding: 10px 14px;\n        &:not(.icon) {\n          background-color: ",
        ";\n\n          p {\n            color: ",
        ";\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    ImageWithButtons_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var ImageWithButtons_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ImageWithButtons__StyledWrapper",
    componentId: "sc-9bb03c04-0"
})(ImageWithButtons_templateObject(), function(p) {
    return p.theme.breakpoints.down("sm");
}, function(p) {
    return p.theme.breakpoints.down("sm");
}, function(p) {
    return p.theme.breakpoints.down("sm");
}, function(p) {
    return p.theme.colors.white;
}, function(p) {
    return p.theme.colors.black;
});
var icons1 = [
    IconCarTop,
    IconCarSide
];
var icons3 = [
    IconBaby,
    IconBag,
    IconTrolly,
    IconSuitcase
];
var icons2 = [
    IconChild,
    IconSit,
    IconBooster
];
var icons = [
    icons1,
    icons2,
    icons3
];
var ImageWithButtons = function(param) {
    var item = param.item, index = param.index;
    var isDesktop = (0,MediaQueries/* useIsDesktop */.Ce)();
    var defaultImage = item === null || item === void 0 ? void 0 : item.defaultImage;
    var allImage = item === null || item === void 0 ? void 0 : item.allImage;
    var ref = (0,react.useState)("בחר הכול"), btnText = ref[0], setBtnText = ref[1];
    var ref1 = (0,react.useState)(defaultImage), currImage = ref1[0], setCurrImage = ref1[1];
    var ref2 = (0,react.useState)(false), showAll = ref2[0], setShowAll = ref2[1];
    var iconsIndexList = (0,react.useMemo)(function() {
        var indexes = item === null || item === void 0 ? void 0 : item.imageList.map(function() {
            return "icon";
        });
        if (index !== 0) return (0,_to_consumable_array/* default */.Z)(indexes).concat([
            btnText
        ]);
        return indexes;
    }, [
        item === null || item === void 0 ? void 0 : item.imageList,
        btnText
    ]);
    var ref3 = (0,react.useState)(item === null || item === void 0 ? void 0 : item.imageList.length), currIndex = ref3[0], setCurrIndex = ref3[1];
    (0,react.useEffect)(function() {
        if (index === 0) setCurrIndex(0);
        return function() {
            var ref;
            setCurrIndex(item === null || item === void 0 ? void 0 : (ref = item.imageList) === null || ref === void 0 ? void 0 : ref.length);
        };
    }, []);
    (0,react.useEffect)(function() {
        switch(true){
            case (item === null || item === void 0 ? void 0 : item.imageList[currIndex]) !== undefined:
                setCurrImage(item === null || item === void 0 ? void 0 : item.imageList[currIndex]);
                setBtnText("בחר הכול");
                setShowAll(true);
                break;
            case (item === null || item === void 0 ? void 0 : item.imageList[0]) !== undefined && defaultImage === null:
                setCurrIndex(0);
                break;
            case currIndex === (item === null || item === void 0 ? void 0 : item.imageList.length) && showAll:
                var ref;
                setCurrIndex((item === null || item === void 0 ? void 0 : (ref = item.imageList) === null || ref === void 0 ? void 0 : ref.length) + 1);
                setCurrImage(allImage);
                setBtnText("נקה הכול");
                setShowAll(false);
                break;
            case currIndex === (item === null || item === void 0 ? void 0 : item.imageList.length) && !showAll:
                var ref1;
                setCurrIndex((item === null || item === void 0 ? void 0 : (ref1 = item.imageList) === null || ref1 === void 0 ? void 0 : ref1.length) + 1);
                setCurrImage(defaultImage);
                setBtnText("בחר הכול");
                setShowAll(true);
                break;
        }
    }, [
        currIndex
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ImageWithButtons_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: item === null || item === void 0 ? void 0 : item.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: currImage === null || currImage === void 0 ? void 0 : currImage.imageUrl,
                width: isDesktop ? 513 : 360,
                height: isDesktop ? 402 : 270,
                alt: currImage === null || currImage === void 0 ? void 0 : currImage.alt,
                lazyBoundary: "800px",
                objectFit: "contain"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "buttons-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chips_MultibleChipsRow, {
                    activeButton: currIndex,
                    setActiveButton: setCurrIndex,
                    isSelectAll: !showAll,
                    optionsList: iconsIndexList,
                    icons: icons[index],
                    toggleId: "tab-selection",
                    className: "icon-buttons"
                })
            })
        ]
    });
};
/* harmony default export */ var ImageWithButtons_ImageWithButtons = (ImageWithButtons);

;// CONCATENATED MODULE: ./components/carModelPage/reusable/TabsComponent/TabPanel.tsx




function TabPanel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  .tabpanel {\n    color: ",
        ";\n    padding: 0;\n  }\n"
    ]);
    TabPanel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




// TODO: set css with resposive breakpoints
var StyledTabWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "TabPanel__StyledTabWrapper",
    componentId: "sc-d88fbfe-0"
})(TabPanel_templateObject(), function(p) {
    return p.theme.colors.lightGrey;
});
var TabPanel = function(props) {
    var children = props.children, value = props.value, index = props.index, other = (0,_object_without_properties/* default */.Z)(props, [
        "children",
        "value",
        "index"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTabWrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        role: "tabpanel",
        hidden: value !== index,
        id: "simple-tabpanel-".concat(index),
        "aria-labelledby": "simple-tab-".concat(index)
    }, other), {
        children: value === index && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            p: 3,
            className: "tabpanel",
            children: children
        })
    }));
};
/* harmony default export */ var TabsComponent_TabPanel = (TabPanel);

;// CONCATENATED MODULE: ./components/carModelPage/reusable/TabsComponent/TabsComponent.tsx


function TabsComponent_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  color: ",
        ";\n"
    ]);
    TabsComponent_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TabsComponent_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-bottom: 1px solid ",
        ';\n  width: 100%;\n  [role="tablist"] {\n    justify-content: center;\n    button {\n      font-size: 18px;\n      ',
        " {\n        min-width: 120px;\n      }\n    }\n    ",
        " {\n      justify-content: flex-start;\n      button {\n        font-size: 16px;\n      }\n    }\n  }\n"
    ]);
    TabsComponent_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var StyledTabsWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "TabsComponent__StyledTabsWrapper",
    componentId: "sc-fea74792-0"
})(TabsComponent_templateObject(), function(p) {
    return p.theme.colors.lightGrey;
});
var StyledTabs = (0,styled_components_browser_esm/* default */.ZP)(Tabs/* default */.Z).withConfig({
    displayName: "TabsComponent__StyledTabs",
    componentId: "sc-fea74792-1"
})(TabsComponent_templateObject1(), function(p) {
    return p.theme.colors.lightGrey;
}, function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return p.theme.breakpoints.down("sm");
});
function a11yProps(index) {
    return {
        id: "simple-tab-".concat(index),
        "aria-controls": "simple-tabpanel-".concat(index)
    };
}
var TabsComponent = function(param) {
    var data = param.data;
    var ref = (0,react.useState)(0), currTab = ref[0], setCurrTab = ref[1];
    var handleChange = function(event, newValue) {
        setCurrTab(newValue);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTabsWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTabs, {
                value: currTab,
                onChange: handleChange,
                "aria-label": "tabs",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* default */.Z, (0,_object_spread/* default */.Z)({
                        label: "חיצוני"
                    }, a11yProps(0))),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* default */.Z, (0,_object_spread/* default */.Z)({
                        label: "פנימי"
                    }, a11yProps(1))),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* default */.Z, (0,_object_spread/* default */.Z)({
                        label: "תא מטען"
                    }, a11yProps(2)))
                ]
            }),
            data && data.map(function(item, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsComponent_TabPanel, {
                    value: currTab,
                    index: index,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWithButtons_ImageWithButtons, {
                        item: item,
                        index: index
                    })
                }, index);
            })
        ]
    });
};
/* harmony default export */ var TabsComponent_TabsComponent = (TabsComponent);

;// CONCATENATED MODULE: ./components/carModelPage/sections/illustrateSize/IllustrateSizeSection.tsx

function IllustrateSizeSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  gap: 60px;\n  padding: 80px 0;\n  background-color: ",
        ";\n  ",
        " {\n    padding: 18px 0 32px;\n  }\n"
    ]);
    IllustrateSizeSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var IllustrateSizeSection_StyledSectionWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "IllustrateSizeSection__StyledSectionWrapper",
    componentId: "sc-94545460-0"
})(IllustrateSizeSection_templateObject(), function(p) {
    return p.theme.colors.black;
}, function(p) {
    return p.theme.breakpoints.down("sm");
});
var IllustrateSizeSection = function(param) {
    var illustrateSize = param.illustrateSize;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(IllustrateSizeSection_StyledSectionWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsComponent_TabsComponent, {
            data: illustrateSize
        })
    });
};
/* harmony default export */ var illustrateSize_IllustrateSizeSection = (IllustrateSizeSection);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Dialog/Dialog.js
var Dialog = __webpack_require__(52663);
// EXTERNAL MODULE: ./reusable/icons/CloseIcon.tsx
var CloseIcon = __webpack_require__(2423);
;// CONCATENATED MODULE: ./reusable/icons/TablerView360Icon.tsx






var TablerView360Icon_SvgComponent = function(_param) {
    var _color = _param.color, color = _color === void 0 ? colors/* default.white */.Z.white : _color, props = (0,_object_without_properties/* default */.Z)(_param, [
        "color"
    ]);
    var w = 32;
    var h = 32;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 ".concat(w, " ").concat(h),
        width: w,
        height: h,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z",
                stroke: color,
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.9974 28C18.9429 28 21.3307 22.6274 21.3307 16C21.3307 9.37258 18.9429 4 15.9974 4C13.0519 4 10.6641 9.37258 10.6641 16C10.6641 22.6274 13.0519 28 15.9974 28Z",
                stroke: color,
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4 16.0013C4 18.948 9.37333 21.3346 16 21.3346C22.6267 21.3346 28 18.948 28 16.0013C28 13.0546 22.6267 10.668 16 10.668C9.37333 10.668 4 13.0546 4 16.0013Z",
                stroke: color,
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    }));
};
/* harmony default export */ var TablerView360Icon = (TablerView360Icon_SvgComponent);

;// CONCATENATED MODULE: ./components/carModelPage/sections/interior/ImageViewerPanorama/ImageViewerPanorama.tsx

function ImageViewerPanorama_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100vh;\n  position: relative;\n  background: ",
        ";\n  img {\n    object-fit: contain;\n  }\n"
    ]);
    ImageViewerPanorama_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ImageViewerPanorama_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  z-index: 10;\n  margin-top: 65px;\n"
    ]);
    ImageViewerPanorama_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ImageViewerPanorama_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  text-align: center;\n  font-size: 20px;\n  font-weight: 400;\n  ",
        " {\n    font-size: 24px;\n  }\n"
    ]);
    ImageViewerPanorama_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ImageViewerPanorama_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  background: none;\n  border: 1px solid ",
        ";\n  margin-top: 50px;\n  &:hover {\n    background: none;\n    transform: none;\n  }\n"
    ]);
    ImageViewerPanorama_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ImageViewerPanorama_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  cursor: pointer;\n  right: 50px;\n  top: 50px;\n  z-index: 10000;\n  ",
        " {\n    right: 25px;\n    top: 25px;\n  }\n  svg {\n    path {\n      stroke: ",
        ";\n    }\n  }\n"
    ]);
    ImageViewerPanorama_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ImageViewerPanorama_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  bottom: 50px;\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  cursor: move;\n"
    ]);
    ImageViewerPanorama_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function ImageViewerPanorama_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .MuiDialog-paper {\n    background: ",
        ";\n  }\n"
    ]);
    ImageViewerPanorama_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}








var PhotoSphereComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4776), __webpack_require__.e(4601), __webpack_require__.e(2745)]).then(__webpack_require__.bind(__webpack_require__, 42745));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(42745)
            ];
        }
    },
    ssr: false
});
var ImageViewerPanorama_StyledImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ImageViewerPanorama__StyledImageWrapper",
    componentId: "sc-1f9b43ef-0"
})(ImageViewerPanorama_templateObject(), function(p) {
    return p.theme.colors.black;
});
var StyledInfoWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ImageViewerPanorama__StyledInfoWrapper",
    componentId: "sc-1f9b43ef-1"
})(ImageViewerPanorama_templateObject1());
var ImageViewerPanorama_StyledText = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
    variant: "h2"
}).withConfig({
    displayName: "ImageViewerPanorama__StyledText",
    componentId: "sc-1f9b43ef-2"
})(ImageViewerPanorama_templateObject2(), function(p) {
    return p.theme.colors.borderGrey;
}, function(p) {
    return p.theme.breakpoints.up("md");
});
var ImageViewerPanorama_StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    displayName: "ImageViewerPanorama__StyledButton",
    componentId: "sc-1f9b43ef-3"
})(ImageViewerPanorama_templateObject3(), function(p) {
    return p.theme.colors.borderGrey;
}, function(p) {
    return p.theme.colors.borderGrey;
});
var StyledSvg = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ImageViewerPanorama__StyledSvg",
    componentId: "sc-1f9b43ef-4"
})(ImageViewerPanorama_templateObject4(), function(p) {
    return p.theme.breakpoints.down("sm");
}, function(p) {
    return p.theme.colors.white;
});
var StyledIconWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ImageViewerPanorama__StyledIconWrapper",
    componentId: "sc-1f9b43ef-5"
})(ImageViewerPanorama_templateObject5());
var StyledDialog = (0,styled_components_browser_esm/* default */.ZP)(Dialog/* default */.Z).withConfig({
    displayName: "ImageViewerPanorama__StyledDialog",
    componentId: "sc-1f9b43ef-6"
})(ImageViewerPanorama_templateObject6(), function(p) {
    return p.theme.colors.black;
});
// "https://www.mazda.co.il/Uploads//ecom/2%20IPM4/Interior/Dynamic/Mazda2_DJLT_DHN9LAA_42S_D1H_INT_Sphere_TransparentPNG.png"
var ImageViewer = function(param) {
    var data = param.data;
    var ref, ref1, ref2;
    var ref3 = (0,react.useState)(false), open = ref3[0], setOpen = ref3[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ImageViewerPanorama_StyledImageWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: data === null || data === void 0 ? void 0 : (ref = data.poster) === null || ref === void 0 ? void 0 : ref.desktopImageUrl,
                        alt: data === null || data === void 0 ? void 0 : (ref1 = data.poster) === null || ref1 === void 0 ? void 0 : ref1.alt,
                        layout: "fill",
                        role: "presentation",
                        "aria-hidden": "true",
                        lazyBoundary: "800px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledInfoWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageViewerPanorama_StyledText, {
                                children: data === null || data === void 0 ? void 0 : data.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageViewerPanorama_StyledButton, {
                                onClick: function() {
                                    setOpen(true);
                                },
                                "aria-label": "מוזמנים להיכנס - חלונית תצוגה בתלת מימד של הדגם",
                                children: "מוזמנים להיכנס"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDialog, {
                fullScreen: true,
                open: open,
                onClose: function() {
                    return setOpen(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PhotoSphereComponent, {
                    src: data === null || data === void 0 ? void 0 : (ref2 = data.panorama) === null || ref2 === void 0 ? void 0 : ref2.desktopImageUrl,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSvg, {
                            onClick: function() {
                                return setOpen(false);
                            },
                            role: "button",
                            tabIndex: 0,
                            "aria-label": "סגירה",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon/* default */.Z, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIconWrapper, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TablerView360Icon, {})
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var ImageViewerPanorama = (ImageViewer);

// EXTERNAL MODULE: ./reusable/icons/VideoPlayIcon.tsx
var VideoPlayIcon = __webpack_require__(87749);
// EXTERNAL MODULE: ./reusable/icons/VideoStopIcon.tsx
var VideoStopIcon = __webpack_require__(5089);
;// CONCATENATED MODULE: ./components/carModelPage/reusable/VideoModal.tsx


function VideoModal_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: ",
        ";\n  width: 100%;\n  position: relative;\n"
    ]);
    VideoModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function VideoModal_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  bottom: 0;\n  padding: 0;\n  right: 0;\n  width: 80px;\n  margin-bottom: 20px;\n  margin-right: 5px;\n  ",
        " {\n    margin-bottom: 40px;\n    margin-right: 40px;\n  }\n"
    ]);
    VideoModal_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var VideoModal_VideoPlayer = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 25991));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(25991)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            children: "..."
        });
    }
});
var isUrlIsVideo = function(url) {
    var videoExtensions = [
        "mp4",
        "webm",
        "ogg"
    ];
    var urlExtension = url.split(".").pop();
    return videoExtensions.includes(urlExtension);
};
var VideoModal_StyledVideoWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "VideoModal__StyledVideoWrapper",
    componentId: "sc-b42ca8a7-0"
})(VideoModal_templateObject(), function(p) {
    return p.$height;
});
var StyledIconButton = (0,styled_components_browser_esm/* default */.ZP)(IconButton/* default */.Z).withConfig({
    displayName: "VideoModal__StyledIconButton",
    componentId: "sc-b42ca8a7-1"
})(VideoModal_templateObject1(), function(p) {
    return p.theme.breakpoints.up("md");
});
var VideoModal = function(param) {
    var src = param.src, imgDesktop = param.imgDesktop, imgMobile = param.imgMobile, alt = param.alt, height = param.height;
    var ref = (0,react.useState)(false), playing = ref[0], setPlaying = ref[1];
    var videoRef = (0,react.useRef)(null);
    var observer = (0,react.useMemo)(function() {
        if (false) {}
        return new IntersectionObserver(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 1), entry = _param[0];
            return setPlaying(entry.isIntersecting);
        });
    }, []);
    (0,react.useEffect)(function() {
        observer === null || observer === void 0 ? void 0 : observer.observe(videoRef.current);
        return function() {
            observer === null || observer === void 0 ? void 0 : observer.disconnect();
        };
    }, [
        videoRef,
        observer
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(VideoModal_StyledVideoWrapper, {
        $height: height,
        ref: videoRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoModal_VideoPlayer, {
                url: src,
                light: false,
                label: "mazda",
                playingState: playing,
                loop: true,
                imgAlt: alt,
                imgUrlDesktop: imgDesktop,
                imgUrlMobile: imgMobile
            }),
            isUrlIsVideo(src) && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: playing ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIconButton, {
                    onClick: function() {
                        setPlaying(false);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoStopIcon/* default */.Z, {})
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIconButton, {
                    onClick: function() {
                        return setPlaying(true);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoPlayIcon/* default */.Z, {})
                })
            })
        ]
    });
};
/* harmony default export */ var reusable_VideoModal = (VideoModal);

;// CONCATENATED MODULE: ./components/carModelPage/sections/interior/InsideHighLights.tsx

function InsideHighLights_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100%;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  background-color: ",
        ";\n  justify-content: center;\n  gap: 60px;\n  padding: 80px 0px 52px;\n"
    ]);
    InsideHighLights_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function InsideHighLights_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 20px;\n  ",
        " {\n    gap: 60px;\n  }\n"
    ]);
    InsideHighLights_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function InsideHighLights_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 20px;\n  max-width: 650px;\n  margin: 0 auto;\n  padding: 0 16px;\n"
    ]);
    InsideHighLights_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function InsideHighLights_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  word-break: bread-word;\n  color: ",
        ";\n  text-align: center;\n"
    ]);
    InsideHighLights_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}






var InsideHighLights_StyledSectionWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "InsideHighLights__StyledSectionWrapper",
    componentId: "sc-71ddad33-0"
})(InsideHighLights_templateObject(), function(p) {
    return p.theme.colors.black;
});
var StyledVideoCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "InsideHighLights__StyledVideoCard",
    componentId: "sc-71ddad33-1"
})(InsideHighLights_templateObject1(), function(p) {
    return p.theme.breakpoints.up("md");
});
var InsideHighLights_StyledTextWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "InsideHighLights__StyledTextWrapper",
    componentId: "sc-71ddad33-2"
})(InsideHighLights_templateObject2());
var StyledDescription = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
    variant: "body1"
}).withConfig({
    displayName: "InsideHighLights__StyledDescription",
    componentId: "sc-71ddad33-3"
})(InsideHighLights_templateObject3(), function(p) {
    return p.theme.colors.white;
});
var InsideHighLights = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(InsideHighLights_StyledSectionWrapper, {
        children: data === null || data === void 0 ? void 0 : data.map(function(item, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledVideoCard, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(InsideHighLights_StyledTextWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* TypographyCenter */.kc, {
                                variant: "h2",
                                $color: colors/* default.white */.Z.white,
                                children: item.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDescription, {
                                children: item.description
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(reusable_VideoModal, {
                        src: item.videoUrl,
                        imgDesktop: item.imageUrl,
                        imgMobile: item.imageUrl,
                        alt: item.alt,
                        height: "440px"
                    })
                ]
            }, "InsideHighLights-".concat(index));
        })
    });
};
/* harmony default export */ var interior_InsideHighLights = (InsideHighLights);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Avatar/Avatar.js + 1 modules
var Avatar = __webpack_require__(67265);
;// CONCATENATED MODULE: ./components/carModelPage/sections/interior/Quiz/TabPanelQuiz.tsx





var TabPanelQuiz_a11yProps = function(index) {
    return {
        id: "simple-tab-".concat(index),
        "aria-controls": "simple-tabpanel-".concat(index)
    };
};
var TabPanelQuiz = function(props) {
    var children = props.children, value = props.value, index = props.index, other = (0,_object_without_properties/* default */.Z)(props, [
        "children",
        "value",
        "index"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        role: "tabpanel",
        hidden: value !== index,
        id: "simple-tabpanel-".concat(index),
        className: "tabpanel-simple",
        "aria-labelledby": "simple-tab-".concat(index)
    }, other), {
        children: value === index && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            children: children
        })
    }));
};

;// CONCATENATED MODULE: ./components/carModelPage/sections/interior/Quiz/QuizGame.tsx



function QuizGame_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  h2 {\n    color: ",
        ";\n    ",
        " {\n      text-align: right;\n    }\n  }\n  text-align: center;\n  margin-bottom: 64px;\n  width: 100%;\n  ",
        " {\n    width: 50%;\n  }\n  transform: ",
        ";\n  opacity: ",
        ";\n\n  transition: all 0.9s 0.9s cubic-bezier(0.19, 0.88, 0.53, 1.12);\n  transition-delay: 0.3s;\n"
    ]);
    QuizGame_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function QuizGame_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 18px;\n  font-weight: 300;\n  color: rgb(213, 213, 213) !important;\n  color: ",
        ";\n  ",
        " {\n    text-align: right;\n    display: block;\n  }\n"
    ]);
    QuizGame_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function QuizGame_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 16px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: relative;\n  width: 613px;\n  height: 310px;\n  img {\n    width: 100%;\n    height: 180px;\n  }\n  ",
        " {\n    width: 100%;\n    height: 180px;\n    img {\n      width: 100%;\n      height: 180px;\n    }\n  }\n"
    ]);
    QuizGame_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function QuizGame_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: relative;\n  .MuiTabs-indicator {\n    display: none;\n  }\n  .MuiTab-root {\n    background: ",
        ";\n  }\n  .Mui-selected {\n    background: ",
        ";\n  }\n  .MuiTabs-root {\n    position: absolute;\n    z-index: 10;\n    background: ",
        ";\n    border-radius: 3px;\n    min-height: 45px;\n    height: 45px;\n    bottom: -20px;\n    button {\n      min-width: 52px;\n      width: 52px;\n      min-height: 45px;\n      height: 45px;\n      border-radius: 3px;\n    }\n  }\n  .MuiTab-textColorInherit {\n    opacity: 1;\n  }\n  ",
        " {\n    .tabpanel-simple {\n      width: 100%;\n    }\n  }\n"
    ]);
    QuizGame_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function QuizGame_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  max-width: 350px;\n  margin: 36px auto 0;\n"
    ]);
    QuizGame_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function QuizGame_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  text-align: center;\n  ",
        " {\n    text-align: right;\n  }\n"
    ]);
    QuizGame_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}










var StyledQuizWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "QuizGame__StyledQuizWrapper",
    componentId: "sc-efe94791-0"
})(QuizGame_templateObject(), function(p) {
    return p.theme.colors.lightGrey;
}, function(p) {
    return p.theme.breakpoints.down("sm");
}, function(p) {
    return p.theme.breakpoints.up("md");
}, function(param) {
    var $inView = param.$inView;
    return !$inView ? "translateY(20px)" : "translateX(0)";
}, function(param) {
    var $inView = param.$inView;
    return $inView ? "1" : "0";
});
var QuizGame_StyledCaption = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
    variant: "h2"
}).withConfig({
    displayName: "QuizGame__StyledCaption",
    componentId: "sc-efe94791-1"
})(QuizGame_templateObject1(), function(p) {
    return p.theme.colors.borderGrey;
}, function(p) {
    return p.theme.breakpoints.down("sm");
});
var QuizGame_StyledImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "QuizGame__StyledImageWrapper",
    componentId: "sc-efe94791-2"
})(QuizGame_templateObject2(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledState = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "QuizGame__StyledState",
    componentId: "sc-efe94791-3"
})(QuizGame_templateObject3(), function(p) {
    return p.theme.colors.disable;
}, function(p) {
    return p.theme.colors.lightGrey;
}, function(p) {
    return p.theme.colors.disable;
}, function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledBody = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
    variant: "body1"
}).withConfig({
    displayName: "QuizGame__StyledBody",
    componentId: "sc-efe94791-4"
})(QuizGame_templateObject4(), function(p) {
    return p.theme.colors.lightGrey;
});
var StyledHeader = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
    variant: "h2"
}).withConfig({
    displayName: "QuizGame__StyledHeader",
    componentId: "sc-efe94791-5"
})(QuizGame_templateObject5(), function(p) {
    return p.theme.colors.white;
}, function(p) {
    return p.theme.breakpoints.down("sm");
});
var QuizGame = function(param) {
    var quizData = param.quizData;
    var ref = (0,react_intersection_observer_modern/* useInView */.YD)({
        triggerOnce: true
    }), ref1 = ref.ref, inView = ref.inView;
    var ref2 = (0,react.useState)(0), active = ref2[0], setActive = ref2[1];
    var isDesktop = (0,MediaQueries/* useIsDesktop */.Ce)();
    var handleChange = function(event, newValue) {
        setActive(newValue);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledQuizWrapper, {
        ref: ref1,
        $inView: inView,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(QuizGame_StyledCaption, {
                children: (quizData === null || quizData === void 0 ? void 0 : quizData.title) || ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeader, {
                children: (quizData === null || quizData === void 0 ? void 0 : quizData.subTitle) || ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledState, {
                children: quizData.states.map(function(state, index) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(TabPanelQuiz, {
                        value: active,
                        index: index,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(QuizGame_StyledImageWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: state === null || state === void 0 ? void 0 : state.imageDesktopUrl,
                                        alt: (state === null || state === void 0 ? void 0 : state.alt) || "",
                                        height: isDesktop && "310px",
                                        width: isDesktop && "613px",
                                        layout: "fill",
                                        objectFit: "cover",
                                        lazyBoundary: "800px"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* default */.Z, {
                                        value: active,
                                        onChange: handleChange,
                                        selectionFollowsFocus: true,
                                        "aria-label": "גלריית תמונות",
                                        children: quizData.states.map(function(state, index) {
                                            /*#__PURE__*/ return (0,react.createElement)(Tab/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, TabPanelQuiz_a11yProps(index)), {
                                                label: "",
                                                key: "states-".concat(index),
                                                "aria-label": state === null || state === void 0 ? void 0 : state.description,
                                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                                    component: function() {
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)((image_default()), {
                                                            alt: (state === null || state === void 0 ? void 0 : state.alt) || "",
                                                            src: index === active ? state === null || state === void 0 ? void 0 : state.activeIcon : state === null || state === void 0 ? void 0 : state.inactiveIcon,
                                                            width: 24,
                                                            height: 24,
                                                            objectFit: "contain",
                                                            lazyBoundary: "800px"
                                                        });
                                                    },
                                                    variant: "square"
                                                })
                                            }));
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBody, {
                                children: state === null || state === void 0 ? void 0 : state.description
                            })
                        ]
                    }, "TabPanelQuiz-".concat(index));
                })
            })
        ]
    });
};
/* harmony default export */ var Quiz_QuizGame = (QuizGame);

;// CONCATENATED MODULE: ./components/carModelPage/sections/interior/Quiz/Quizzes.tsx

function Quizzes_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-right: 16px;\n  padding-left: 16px;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  padding-top: 80px;\n  padding-bottom: 50px;\n  position: relative;\n  background-color: ",
        ";\n  align-items: center;\n  ",
        " {\n    flex-direction: column;\n  }\n"
    ]);
    Quizzes_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var StyledQuiz = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Quizzes__StyledQuiz",
    componentId: "sc-65292d7a-0"
})(Quizzes_templateObject(), function(p) {
    return p.theme.colors.black;
}, function(p) {
    return p.theme.breakpoints.down("sm");
});
var Quizzes = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledQuiz, {
        children: data === null || data === void 0 ? void 0 : data.quizItems.map(function(item, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                children: item.title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Quiz_QuizGame, {
                    quizData: item
                })
            }, "quiz".concat(index));
        })
    });
};
/* harmony default export */ var Quiz_Quizzes = (Quizzes);

;// CONCATENATED MODULE: ./components/carModelPage/sections/interior/InteriorSection.tsx

function InteriorSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  width: 100vw;\n  min-height: max-content;\n  height: max-content;\n"
    ]);
    InteriorSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function InteriorSection_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    padding-right: 0px;\n    padding-left: 0px;\n  }\n"
    ]);
    InteriorSection_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var StyledPageDiv = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "InteriorSection__StyledPageDiv",
    componentId: "sc-d99b9bd6-0"
})(InteriorSection_templateObject(), function(p) {
    return p.theme.colors.black;
});
var InteriorSection_StyledVideoWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "InteriorSection__StyledVideoWrapper",
    componentId: "sc-d99b9bd6-1"
})(InteriorSection_templateObject1(), function(p) {
    return p.theme.breakpoints.up("md");
});
var InteriorSection = function(param) {
    var insideData = param.insideData;
    var ref, ref1, ref2, ref3, ref4, ref5;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPageDiv, {
        children: [
            (insideData === null || insideData === void 0 ? void 0 : insideData.highLights) && /*#__PURE__*/ (0,jsx_runtime.jsx)(interior_InsideHighLights, {
                data: insideData === null || insideData === void 0 ? void 0 : insideData.highLights
            }),
            (insideData === null || insideData === void 0 ? void 0 : insideData.frameText) && /*#__PURE__*/ (0,jsx_runtime.jsx)(reusable_ModelTextSection, {
                text: insideData.frameText
            }),
            (insideData === null || insideData === void 0 ? void 0 : insideData.video) && /*#__PURE__*/ (0,jsx_runtime.jsx)(InteriorSection_StyledVideoWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoModelFullScreen/* default */.Z, {
                    src: insideData === null || insideData === void 0 ? void 0 : (ref = insideData.video) === null || ref === void 0 ? void 0 : ref.desktopImageUrl,
                    imgDesktop: insideData === null || insideData === void 0 ? void 0 : (ref1 = insideData.video) === null || ref1 === void 0 ? void 0 : ref1.desktopImageUrl,
                    imgMobile: insideData === null || insideData === void 0 ? void 0 : (ref2 = insideData.video) === null || ref2 === void 0 ? void 0 : ref2.mobileImageUrl,
                    alt: insideData === null || insideData === void 0 ? void 0 : (ref3 = insideData.video) === null || ref3 === void 0 ? void 0 : ref3.alt
                })
            }),
            (insideData === null || insideData === void 0 ? void 0 : insideData.quiz) && !!(insideData === null || insideData === void 0 ? void 0 : (ref4 = insideData.quiz) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.quizItems) === null || ref5 === void 0 ? void 0 : ref5.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Quiz_Quizzes, {
                data: insideData === null || insideData === void 0 ? void 0 : insideData.quiz
            }),
            (insideData === null || insideData === void 0 ? void 0 : insideData.panorama) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageViewerPanorama, {
                data: insideData === null || insideData === void 0 ? void 0 : insideData.panorama
            })
        ]
    });
};
/* harmony default export */ var interior_InteriorSection = (InteriorSection);

// EXTERNAL MODULE: ./common/bit/TruncateText.tsx
var TruncateText = __webpack_require__(48868);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./reusable/wrappers/BodyText.tsx
var BodyText = __webpack_require__(97294);
;// CONCATENATED MODULE: ./components/carModelPage/sections/review/ReviewsSection.tsx

function ReviewsSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  padding-top: 56px;\n  padding-bottom: ",
        ";\n  ",
        " {\n    padding-top: ",
        ";\n    padding-bottom: ",
        ";\n  }\n  background: ",
        ";\n  transform: ",
        ";\n  opacity: ",
        ";\n\n  transition: all 0.9s 0.9s cubic-bezier(0.19, 0.88, 0.53, 1.12);\n  transition-delay: 0.3s;\n"
    ]);
    ReviewsSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ReviewsSection_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  transition: 1s;\n  :hover,\n  :focus {\n    transform: scale(1.2);\n  }\n"
    ]);
    ReviewsSection_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ReviewsSection_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  margin-top: 30px;\n\n  .swiper-slide {\n    width: max-content;\n    height: auto;\n    ",
        " {\n      &:first-child {\n        padding-right: 16px;\n      }\n    }\n\n    ",
        " {\n      width: 280px !important;\n    }\n  }\n"
    ]);
    ReviewsSection_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ReviewsSection_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  height: 400px;\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);\n  border-radius: 3px;\n  margin-bottom: 10px;\n  position: relative;\n  ",
        " {\n    width: 100%;\n  }\n"
    ]);
    ReviewsSection_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ReviewsSection_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 40px 0px;\n  text-align: center;\n  width: 100%;\n  ",
        " {\n    padding: 80px 20px;\n  }\n  h3 {\n    width: 220px;\n  }\n"
    ]);
    ReviewsSection_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ReviewsSection_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between !important;\n  padding-left: 20px;\n  padding-right: 20px;\n  p {\n    font-size: 16px;\n    color: ",
        ";\n  }\n"
    ]);
    ReviewsSection_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function ReviewsSection_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 20px;\n  ",
        " {\n    h3 {\n      width: 230px;\n      letter-spacing: 0px;\n    }\n  }\n"
    ]);
    ReviewsSection_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function ReviewsSection_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 24px;\n  height: 24px;\n"
    ]);
    ReviewsSection_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function ReviewsSection_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 100%;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 20px 0px;\n  position: absolute;\n  bottom: 10px;\n"
    ]);
    ReviewsSection_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function ReviewsSection_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n"
    ]);
    ReviewsSection_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  bottom: 10px;\n  right: 10px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  color: ",
        ";\n  font-size: 20px;\n  font-weight: 300;\n  line-height: 130%;\n  color: ",
        ";\n  letter-spacing: 0.03em;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}











var StyledPageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ReviewsSection__StyledPageWrapper",
    componentId: "sc-588c11c5-0"
})(ReviewsSection_templateObject(), function(p) {
    return p.$padding ? "".concat(p.$padding) : "60px";
}, function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return p.$paddingTop ? p.$paddingTop : "112px";
}, function(p) {
    return p.$padding ? "".concat(p.$padding) : "100px";
}, function(p) {
    return p.$background && p.$background;
}, function(param) {
    var $inView = param.$inView;
    return !$inView ? "translateY(20px)" : "translateX(0)";
}, function(param) {
    var $inView = param.$inView;
    return $inView ? "1" : "0";
});
var StyledImage = (0,styled_components_browser_esm/* default */.ZP)((image_default())).withConfig({
    displayName: "ReviewsSection__StyledImage",
    componentId: "sc-588c11c5-1"
})(ReviewsSection_templateObject1());
var ReviewsSection_StyledSwiper = (0,styled_components_browser_esm/* default */.ZP)(swiper_react/* Swiper */.tq).withConfig({
    displayName: "ReviewsSection__StyledSwiper",
    componentId: "sc-588c11c5-2"
})(ReviewsSection_templateObject2(), function(p) {
    return p.theme.breakpoints.down("sm");
}, function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledSliderWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ReviewsSection__StyledSliderWrapper",
    componentId: "sc-588c11c5-3"
})(ReviewsSection_templateObject3(), function(p) {
    return p.theme.colors.white;
}, function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledSwiperWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ReviewsSection__StyledSwiperWrapper",
    componentId: "sc-588c11c5-4"
})(ReviewsSection_templateObject4(), function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledSubtitleWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ReviewsSection__StyledSubtitleWrapper",
    componentId: "sc-588c11c5-5"
})(ReviewsSection_templateObject5(), function(p) {
    return p.theme.colors.onyx;
});
var StyledBottomText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ReviewsSection__StyledBottomText",
    componentId: "sc-588c11c5-6"
})(ReviewsSection_templateObject6(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var ReviewsSection_StyledIconWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ReviewsSection__StyledIconWrapper",
    componentId: "sc-588c11c5-7"
})(ReviewsSection_templateObject7());
var StyledLinkWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ReviewsSection__StyledLinkWrapper",
    componentId: "sc-588c11c5-8"
})(ReviewsSection_templateObject8());
var ReviewsSection_StyledImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ReviewsSection__StyledImageWrapper",
    componentId: "sc-588c11c5-9"
})(ReviewsSection_templateObject9());
var StyledLogoWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ReviewsSection__StyledLogoWrapper",
    componentId: "sc-588c11c5-10"
})(_templateObject10());
var StyledArticlePage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ReviewsSection__StyledArticlePage",
    componentId: "sc-588c11c5-11"
})(_templateObject11());
var StyledTruncateText = (0,styled_components_browser_esm/* default */.ZP)(TruncateText/* default */.Z).withConfig({
    displayName: "ReviewsSection__StyledTruncateText",
    componentId: "sc-588c11c5-12"
})(_templateObject12(), function(p) {
    return p.theme.colors.disable;
}, function(p) {
    return p.theme.colors.black;
});
var ReviewsSection = function(param) {
    var carData = param.carData;
    var ref;
    var ref1 = (0,react_intersection_observer_modern/* useInView */.YD)({
        triggerOnce: true
    }), ref2 = ref1.ref, inView = ref1.inView;
    var isDesktop = (0,MediaQueries/* useIsDesktop */.Ce)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPageWrapper, {
        $inView: inView,
        ref: ref2,
        $padding: "0",
        $paddingTop: "0",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledArticlePage, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSwiperWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledHeaderH2 */.x0, {
                        children: "סיקור הדגם בתקשורת"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewsSection_StyledSwiper, {
                        slidesPerView: isDesktop ? "auto" : 1.2,
                        spaceBetween: 16,
                        slidesPerGroup: 1,
                        loop: false,
                        modules: [
                            swiper_esm/* Pagination */.tl,
                            swiper_esm/* Navigation */.W_
                        ],
                        centerInsufficientSlides: true,
                        centeredSlidesBounds: true,
                        centeredSlides: false,
                        slidesOffsetAfter: !isDesktop && 16,
                        children: carData === null || carData === void 0 ? void 0 : (ref = carData.articles) === null || ref === void 0 ? void 0 : ref.map(function(item, index) {
                            var ref, ref1;
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSliderWrapper, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReviewsSection_StyledImageWrapper, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImage, {
                                                    width: "300px",
                                                    height: "220px",
                                                    src: item === null || item === void 0 ? void 0 : (ref = item.image) === null || ref === void 0 ? void 0 : ref.imageUrl,
                                                    alt: "כתבה מעיתון ".concat(item === null || item === void 0 ? void 0 : item.name),
                                                    objectFit: "cover"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLogoWrapper, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        width: "70px",
                                                        height: "27px",
                                                        src: item === null || item === void 0 ? void 0 : (ref1 = item.originImage) === null || ref1 === void 0 ? void 0 : ref1.imageUrl,
                                                        alt: "img",
                                                        objectFit: "cover",
                                                        lazyBoundary: "800px"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSubtitleWrapper, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledBody */.vc, {
                                                    children: item === null || item === void 0 ? void 0 : item.auther
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledBody */.vc, {
                                                    children: moment_default()(item === null || item === void 0 ? void 0 : item.datePublished).format("d.M.yyyy")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledBottomText, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTruncateText, {
                                                    line: 2,
                                                    element: "span",
                                                    truncateText: "…",
                                                    text: item.name
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLinkWrapper, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewsSection_StyledIconWrapper, {}),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledLink */.Fg, {
                                                            $color: "#101010",
                                                            href: item === null || item === void 0 ? void 0 : item.linkUrl,
                                                            target: "_blank",
                                                            children: "לכתבה המלאה"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewsSection_StyledIconWrapper, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* StyledSvgIcon */.vV, {
                                                                src: "/icons/exit-site.svg",
                                                                alt: "מעבר לאתר חיצוני",
                                                                w: 24,
                                                                h: 24
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }, "review-slide-".concat(index));
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var review_ReviewsSection = (ReviewsSection);

;// CONCATENATED MODULE: ./components/carModelPage/sections/safety/SafetyVideoCard.tsx

function SafetyVideoCard_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  position: relative;\n  overflow: hidden;\n  background-color: ",
        ";\n"
    ]);
    SafetyVideoCard_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SafetyVideoCard_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: ",
        ";\n  width: 100%;\n  position: absolute;\n  /* position: relative; */\n  overflow: hidden;\n  height: 100%;\n  width: 100%;\n  top: 0;\n  left: 0;\n  right: 0;\n  margin: 0px auto;\n  video {\n    clip-path: inset(1px 1px);\n  }\n"
    ]);
    SafetyVideoCard_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SafetyVideoCard_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 80px;\n"
    ]);
    SafetyVideoCard_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SafetyVideoCard_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  width: 250px;\n"
    ]);
    SafetyVideoCard_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function SafetyVideoCard_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 135px;\n  width: 250px;\n"
    ]);
    SafetyVideoCard_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function SafetyVideoCard_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  font-size: 16px;\n  color: ",
        ";\n"
    ]);
    SafetyVideoCard_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function SafetyVideoCard_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  flex-direction: column;\n  height: 100%;\n  justify-content: flex-end;\n  width: 100%;\n  margin: 0px auto;\n  & > * {\n    z-index: 120;\n  }\n"
    ]);
    SafetyVideoCard_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function SafetyVideoCard_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n"
    ]);
    SafetyVideoCard_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function SafetyVideoCard_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0px;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(\n    180deg,\n    #f5f5f5 0%,\n    rgba(245, 245, 245, 0) 23.77%,\n    rgba(245, 245, 245, 0) 44.21%,\n    #f5f5f5 77.43%\n  );\n"
    ]);
    SafetyVideoCard_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}








var SafetyVideoCard_VideoPlayer = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 25991));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(25991)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            children: "..."
        });
    }
});
var StyledCardWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SafetyVideoCard__StyledCardWrapper",
    componentId: "sc-9668f79-0"
})(SafetyVideoCard_templateObject(), function(p) {
    return p.theme.colors.lightGrey;
});
var SafetyVideoCard_StyledVideoWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SafetyVideoCard__StyledVideoWrapper",
    componentId: "sc-9668f79-1"
})(SafetyVideoCard_templateObject1(), function(p) {
    return p.$height;
});
var SafetyVideoCard_StyledIconButton = (0,styled_components_browser_esm/* default */.ZP)(IconButton/* default */.Z).withConfig({
    displayName: "SafetyVideoCard__StyledIconButton",
    componentId: "sc-9668f79-2"
})(SafetyVideoCard_templateObject2());
var SafetyVideoCard_StyledTitle = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).withConfig({
    displayName: "SafetyVideoCard__StyledTitle",
    componentId: "sc-9668f79-3"
})(SafetyVideoCard_templateObject3());
var StyledTruncateWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SafetyVideoCard__StyledTruncateWrapper",
    componentId: "sc-9668f79-4"
})(SafetyVideoCard_templateObject4());
var SafetyVideoCard_StyledTruncateText = (0,styled_components_browser_esm/* default */.ZP)(TruncateText/* default */.Z).withConfig({
    displayName: "SafetyVideoCard__StyledTruncateText",
    componentId: "sc-9668f79-5"
})(SafetyVideoCard_templateObject5(), function(p) {
    return p.theme.colors.disable;
});
var StyledBoxZIndex = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SafetyVideoCard__StyledBoxZIndex",
    componentId: "sc-9668f79-6"
})(SafetyVideoCard_templateObject6());
var StyledPlayRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SafetyVideoCard__StyledPlayRow",
    componentId: "sc-9668f79-7"
})(SafetyVideoCard_templateObject7());
var SafetyVideoCard_StyledGradientOverlay = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SafetyVideoCard__StyledGradientOverlay",
    componentId: "sc-9668f79-8"
})(SafetyVideoCard_templateObject8());
var SafetyVideoCard = function(param) {
    var item = param.item, _height = param.height, height = _height === void 0 ? "100%" : _height, isActive = param.isActive, isNext = param.isNext;
    var ref;
    var ref1 = (0,react.useState)(isActive), playing = ref1[0], setPlaying = ref1[1];
    var videoRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        setPlaying(isActive);
    }, [
        isActive
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCardWrapper, {
        className: isNext ? "active-safe" : null,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SafetyVideoCard_StyledVideoWrapper, {
                $height: height,
                ref: videoRef,
                children: [
                    (isNext || isActive) && /*#__PURE__*/ (0,jsx_runtime.jsx)(SafetyVideoCard_VideoPlayer, {
                        url: isNext || isActive ? item === null || item === void 0 ? void 0 : (ref = item.video) === null || ref === void 0 ? void 0 : ref.imageUrl : "",
                        light: false,
                        label: item.video.alt,
                        playingState: playing,
                        loop: true,
                        imgAlt: item.video.alt,
                        imgUrlDesktop: "/placeholder.jpeg",
                        imgUrlMobile: "/placeholder.jpeg",
                        cover: false
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SafetyVideoCard_StyledGradientOverlay, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledBoxZIndex, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPlayRow, {
                        children: playing ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SafetyVideoCard_StyledIconButton, {
                            onClick: function() {
                                setPlaying(false);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoStopIcon/* default */.Z, {})
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SafetyVideoCard_StyledIconButton, {
                            onClick: function() {
                                setPlaying(true);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoPlayIcon/* default */.Z, {})
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SafetyVideoCard_StyledTitle, {
                        variant: "h3",
                        children: item === null || item === void 0 ? void 0 : item.shortName
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTruncateWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SafetyVideoCard_StyledTruncateText, {
                            line: 2,
                            element: "span",
                            truncateText: "…",
                            text: item === null || item === void 0 ? void 0 : item.description
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var safety_SafetyVideoCard = (SafetyVideoCard);

;// CONCATENATED MODULE: ./components/carModelPage/sections/safety/SafetyDoubleSwiper.tsx

function SafetyDoubleSwiper_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n"
    ]);
    SafetyDoubleSwiper_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SafetyDoubleSwiper_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  width: 100%;\n  height: 60px;\n  background-color: ",
        ";\n  max-height: 200px;\n  box-sizing: border-box;\n  padding: 10px 0;\n  .swiper-slide {\n    width: auto !important;\n    cursor: pointer !important;\n    display: flex !important;\n    justify-content: center !important;\n  }\n  .swiper-wrapper {\n    display: flex !important;\n    justify-content: center !important;\n    align-items: center;\n  }\n  ",
        " {\n    .swiper-wrapper {\n      -webkit-transform: none !important;\n      transform: none !important;\n    }\n  }\n"
    ]);
    SafetyDoubleSwiper_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SafetyDoubleSwiper_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  /* todo change this */\n  height: calc(100vh - 100px);\n  .swiper-slide {\n    overflow: hidden;\n    margin-right: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding-top: 80px;\n    /* todo change this */\n\n    height: calc(100vh - 100px);\n    width: 100vw !important;\n    max-width: 100vw !important;\n  }\n"
    ]);
    SafetyDoubleSwiper_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SafetyDoubleSwiper_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 12px;\n  color: ",
        ";\n  ",
        " {\n    font-size: 16px;\n  }\n"
    ]);
    SafetyDoubleSwiper_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function SafetyDoubleSwiper_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    SafetyDoubleSwiper_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function SafetyDoubleSwiper_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  bottom: 0;\n  z-index: 100;\n  justify-content: center;\n  width: 100%;\n  align-items: flex-start;\n"
    ]);
    SafetyDoubleSwiper_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}










var SafetyDoubleSwiper_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SafetyDoubleSwiper__StyledWrapper",
    componentId: "sc-2e9d8688-0"
})(SafetyDoubleSwiper_templateObject());
var StyledMenuSwiper = (0,styled_components_browser_esm/* default */.ZP)(swiper_react/* Swiper */.tq).withConfig({
    displayName: "SafetyDoubleSwiper__StyledMenuSwiper",
    componentId: "sc-2e9d8688-1"
})(SafetyDoubleSwiper_templateObject1(), function(p) {
    return p.theme.colors.transparent;
}, function(p) {
    return p.theme.breakpoints.up("md");
});
var SafetyDoubleSwiper_StyledSwiper = (0,styled_components_browser_esm/* default */.ZP)(swiper_react/* Swiper */.tq).withConfig({
    displayName: "SafetyDoubleSwiper__StyledSwiper",
    componentId: "sc-2e9d8688-2"
})(SafetyDoubleSwiper_templateObject2());
var SafetyDoubleSwiper_StyledText = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
    variant: "body1"
}).withConfig({
    displayName: "SafetyDoubleSwiper__StyledText",
    componentId: "sc-2e9d8688-3"
})(SafetyDoubleSwiper_templateObject3(), function(p) {
    return p.$isActive ? p.theme.colors.black : p.theme.colors.darkGrey;
}, function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledBox = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    displayName: "SafetyDoubleSwiper__StyledBox",
    componentId: "sc-2e9d8688-4"
})(SafetyDoubleSwiper_templateObject4());
var SafetyDoubleSwiper_StyledSwiperControllerRow = (0,styled_components_browser_esm/* default */.ZP)(safety_SwiperControllerRow).withConfig({
    displayName: "SafetyDoubleSwiper__StyledSwiperControllerRow",
    componentId: "sc-2e9d8688-5"
})(SafetyDoubleSwiper_templateObject5());
var CategoriesSwiper = function(param) {
    var data = param.data;
    var ref = (0,react.useState)(), menuSwiper = ref[0], setMenuSwiper = ref[1];
    var ref1 = (0,react.useState)(), gallerySwiper = ref1[0], setGallerySwiper = ref1[1];
    var navigationPrevRef = (0,react.useRef)(null);
    var navigationNextRef = (0,react.useRef)(null);
    var ref2 = (0,react.useState)(0), activeIndex = ref2[0], setActiveIndex = ref2[1];
    var isDesktop = (0,MediaQueries/* useIsDesktop */.Ce)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SafetyDoubleSwiper_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SafetyDoubleSwiper_StyledSwiper, {
                modules: [
                    swiper_esm/* Navigation */.W_,
                    swiper_esm/* Controller */.Qr,
                    swiper_esm/* EffectFade */.xW,
                    swiper_esm/* A11y */.s5,
                    swiper_esm/* Keyboard */.N1
                ],
                onSwiper: setGallerySwiper,
                controller: {
                    control: menuSwiper
                },
                spaceBetween: 10,
                centeredSlides: true,
                slidesPerView: 1,
                effect: "fade",
                keyboard: {
                    enabled: true
                },
                a11y: {
                    slideRole: "tabpanel"
                },
                navigation: {
                    prevEl: navigationPrevRef.current,
                    nextEl: navigationNextRef.current
                },
                children: data.slice(0, 5).map(function(item, index) {
                    var ref;
                    return (item === null || item === void 0 ? void 0 : (ref = item.video) === null || ref === void 0 ? void 0 : ref.imageUrl) && /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                        id: "".concat(index, "-panel"),
                        "aria-labelledby": "".concat(index, "-tab"),
                        children: function(param) {
                            var isActive = param.isActive, isNext = param.isNext, isPrev = param.isPrev;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(safety_SafetyVideoCard, {
                                item: item,
                                isNext: isNext || isPrev,
                                isActive: isActive
                            });
                        }
                    }, "categoriesSwiper-contect-".concat(index));
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMenuSwiper, {
                modules: [
                    swiper_esm/* Navigation */.W_,
                    swiper_esm/* Controller */.Qr,
                    swiper_esm/* A11y */.s5
                ],
                onSwiper: setMenuSwiper,
                controller: {
                    control: gallerySwiper
                },
                spaceBetween: isDesktop ? 35 : 15,
                slidesPerView: "auto",
                touchRatio: 0.4,
                slideToClickedSlide: true,
                a11y: {
                    slideRole: "tab"
                },
                onBeforeInit: function(swiper) {
                    swiper.wrapperEl.setAttribute("role", "tablist");
                    swiper.wrapperEl.setAttribute("aria-orientation", "horizontal");
                },
                onSlideChange: function(swiper) {
                    swiper.slides.map(function(slide, index) {
                        if (index === swiper.activeIndex) {
                            slide.setAttribute("aria-selected", "true");
                        } else {
                            slide.setAttribute("aria-selected", "false");
                        }
                    });
                },
                children: data.slice(0, 5).map(function(item, index) {
                    var ref;
                    return (item === null || item === void 0 ? void 0 : (ref = item.video) === null || ref === void 0 ? void 0 : ref.imageUrl) && /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                        id: "".concat(index, "-tab"),
                        "aria-controls": "".concat(index, "-panel"),
                        "aria-selected": (menuSwiper === null || menuSwiper === void 0 ? void 0 : menuSwiper.activeIndex) == index ? true : false,
                        onClick: function() {
                            setActiveIndex(index);
                            gallerySwiper === null || gallerySwiper === void 0 ? void 0 : gallerySwiper.slideTo(index);
                            menuSwiper === null || menuSwiper === void 0 ? void 0 : menuSwiper.slideTo(index);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBox, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SafetyDoubleSwiper_StyledText, {
                                $isActive: index === activeIndex,
                                children: item.shortName
                            })
                        })
                    }, "categoriesSwiper-tabs-".concat(index));
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SafetyDoubleSwiper_StyledSwiperControllerRow, {
                prevRef: navigationPrevRef,
                nextRef: navigationNextRef,
                setActiveIndex: setActiveIndex,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* StyledSpacer */.KG, {
                    $w: 240,
                    $h: 150
                })
            })
        ]
    });
};
/* harmony default export */ var SafetyDoubleSwiper = (CategoriesSwiper);

;// CONCATENATED MODULE: ./components/carModelPage/sections/safety/SafetyParallaxTwo.tsx

function SafetyParallaxTwo_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: calc(100vh - 190px);\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  background-color: ",
        ";\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  overflow: hidden;\n  background: linear-gradient(\n    180deg,\n    #f5f5f5 0%,\n    rgba(245, 245, 245, 0) 23.77%,\n    rgba(245, 245, 245, 0) 44.21%,\n    #f5f5f5 77.43%\n  );\n"
    ]);
    SafetyParallaxTwo_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SafetyParallaxTwo_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: calc(100vh - 190px);\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  flex-grow: 1;\n  flex-shrink: 0;\n"
    ]);
    SafetyParallaxTwo_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SafetyParallaxTwo_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n  font-weight: 400;\n  font-size: 24px;\n  position: absolute;\n  text-align: center;\n  line-height: 140%;\n  padding: 0px 16px;\n  transition: all 0.5s ease-in-out;\n  background-size: 100% !important;\n  background-clip: text !important;\n  -webkit-background-clip: text !important;\n  color: ",
        ";\n  transform-origin: 0%;\n  width: 320px;\n"
    ]);
    SafetyParallaxTwo_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}





var StyledMiniSectionWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SafetyParallaxTwo__StyledMiniSectionWrapper",
    componentId: "sc-fc5dfae6-0"
})(SafetyParallaxTwo_templateObject(), function(p) {
    return p.theme.colors.lightGrey;
});
var SafetyParallaxTwo_StyledImageWrapper = (0,styled_components_browser_esm/* default */.ZP)(motion/* motion.div */.E.div).withConfig({
    displayName: "SafetyParallaxTwo__StyledImageWrapper",
    componentId: "sc-fc5dfae6-1"
})(SafetyParallaxTwo_templateObject1());
var StyledAbsoluteText = (0,styled_components_browser_esm/* default */.ZP)(motion/* motion.h2 */.E.h2).withConfig({
    displayName: "SafetyParallaxTwo__StyledAbsoluteText",
    componentId: "sc-fc5dfae6-2"
})(SafetyParallaxTwo_templateObject2(), function(p) {
    return p.theme.colors.transparent;
});
function SafetyParallaxTwo_useBackroundChange(value) {
    // value,
    // Map x from these values:[0, 1],
    // Into these values:
    //  [-distance, distance]
    return (0,use_transform/* useTransform */.H)(value, [
        0,
        0.5
    ], [
        "linear-gradient(4.83deg, #000000 -293.68%, rgba(255, 255, 255, 0) -67.38%)",
        "linear-gradient(82.94deg, #000000 -0.17%, rgba(255, 255, 255, 0) 219.49%)", 
    ]);
}
var SafetyParallaxTwo = function(param) {
    var text = param.text, y = param.y;
    var ref = (0,react.useRef)(null);
    var scrollYProgress = (0,use_scroll/* useScroll */.v)({
        target: ref,
        offset: [
            "end",
            "start"
        ]
    }).scrollYProgress;
    var background = SafetyParallaxTwo_useBackroundChange(scrollYProgress);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledMiniSectionWrapper, {
        ref: ref,
        children: [
            [
                1,
                2,
                3,
                4,
                5
            ].map(function(i) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(SafetyParallaxTwo_StyledImageWrapper, {
                    style: {
                        y: y
                    },
                    transition: {
                        type: "spring"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage/* default */.Z, {
                        image: {
                            imageUrl: "/img/road-stripes.png",
                            alt: "road-stripes"
                        },
                        cover: false,
                        imageSizes: [
                            "100vw",
                            "384px"
                        ],
                        role: "presentation",
                        "aria-hidden": "true"
                    })
                }, "paralex=".concat(i));
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledAbsoluteText, {
                style: {
                    background: background
                },
                children: text
            })
        ]
    });
};
/* harmony default export */ var safety_SafetyParallaxTwo = (SafetyParallaxTwo);

;// CONCATENATED MODULE: ./components/carModelPage/sections/safety/SafetySection.tsx

function SafetySection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-height: 100vh;\n  height: 100%;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  background-color: ",
        ";\n  justify-content: center;\n"
    ]);
    SafetySection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SafetySection_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: ",
        ";\n  padding: 20px;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  background-color: ",
        ";\n  justify-content: center;\n  margin-bottom: 80px;\n  padding-top: 0px;\n  justify-content: flex-start;\n"
    ]);
    SafetySection_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SafetySection_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0px auto;\n"
    ]);
    SafetySection_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}









var SafetyPopup = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7573).then(__webpack_require__.bind(__webpack_require__, 97573));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(97573)
            ];
        }
    },
    ssr: false
});
var SafetySection_StyledSectionWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SafetySection__StyledSectionWrapper",
    componentId: "sc-92f6ea4b-0"
})(SafetySection_templateObject(), function(p) {
    return p.theme.colors.lightGrey;
});
var SafetySection_StyledMiniSectionWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SafetySection__StyledMiniSectionWrapper",
    componentId: "sc-92f6ea4b-1"
})(SafetySection_templateObject1(), function(p) {
    return p.$h ? p.$h : "100vh";
}, function(p) {
    return p.theme.colors.lightGrey;
});
var SafetySection_StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    displayName: "SafetySection__StyledButton",
    componentId: "sc-92f6ea4b-2"
})(SafetySection_templateObject2());
function useParallax(value, distance) {
    return (0,use_transform/* useTransform */.H)(value, [
        0,
        1
    ], [
        distance,
        -distance
    ]);
}
var SafetySection = function(param) {
    var data = param.data;
    var ref = (0,react.useState)(false), popUpOpen = ref[0], setPopUpOpen = ref[1];
    var ref1 = (0,react.useRef)(null);
    var scrollYProgress = (0,use_scroll/* useScroll */.v)({
        target: ref1
    }).scrollYProgress;
    var y = useParallax(scrollYProgress, 1000);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SafetySection_StyledSectionWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                ref: ref1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(safety_SafetyParallaxTwo, {
                        text: data === null || data === void 0 ? void 0 : data.mainTitle,
                        y: y
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SafetyDoubleSwiper, {
                        data: data === null || data === void 0 ? void 0 : data.items
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SafetySection_StyledMiniSectionWrapper, {
                $h: "200px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* TypographyCenter */.kc, {
                        variant: "h2",
                        $mb: "34px",
                        $fontSize: "20px",
                        $fontWeight: "300",
                        children: "גלו עוד על אמצעי הבטיחות המוקפדים שלנו"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SafetySection_StyledButton, {
                        variant: "contained",
                        onClick: function() {
                            return setPopUpOpen(true);
                        },
                        children: "לכל אמצעי הבטיחות"
                    })
                ]
            }),
            popUpOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(SafetyPopup, {
                data: data === null || data === void 0 ? void 0 : data.items,
                open: popUpOpen,
                onClose: function() {
                    return setPopUpOpen(false);
                }
            })
        ]
    });
};
/* harmony default export */ var safety_SafetySection = (SafetySection);

;// CONCATENATED MODULE: ./reusable/icons/ButtonType1Icon.tsx

var ButtonType1Icon_SvgComponent = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "17",
        height: "20",
        viewBox: "0 0 17 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M11.8486 2.16666L11.9664 2.5H12.32H13.5C14.163 2.5 14.7989 2.76339 15.2678 3.23223C15.7366 3.70107 16 4.33696 16 5V17C16 17.663 15.7366 18.2989 15.2678 18.7678C14.7989 19.2366 14.163 19.5 13.5 19.5H3.5C2.83696 19.5 2.20107 19.2366 1.73223 18.7678C1.26339 18.2989 1 17.663 1 17V5C1 4.33696 1.26339 3.70107 1.73223 3.23223C2.20107 2.76339 2.83696 2.5 3.5 2.5H4.68H5.03356L5.15141 2.16666C5.32333 1.68037 5.64146 1.25916 6.06218 0.96078C6.48272 0.662526 6.98518 0.501587 7.50074 0.5H9.49926C10.0148 0.501587 10.5173 0.662526 10.9378 0.96078C11.3585 1.25916 11.6767 1.68037 11.8486 2.16666ZM10.5 4.5H11V4V3C11 2.60217 10.842 2.22064 10.5607 1.93934C10.2794 1.65804 9.89783 1.5 9.5 1.5H7.5C7.10218 1.5 6.72064 1.65804 6.43934 1.93934C6.15804 2.22064 6 2.60217 6 3V4V4.5H6.5H10.5ZM5 4V3.5H4.5H3.5C3.10217 3.5 2.72064 3.65804 2.43934 3.93934C2.15804 4.22064 2 4.60218 2 5V17C2 17.3978 2.15804 17.7794 2.43934 18.0607C2.72065 18.342 3.10218 18.5 3.5 18.5H13.5C13.8978 18.5 14.2794 18.342 14.5607 18.0607C14.842 17.7794 15 17.3978 15 17V5C15 4.60218 14.842 4.22064 14.5607 3.93934C14.2794 3.65804 13.8978 3.5 13.5 3.5H12.5H12V4V5C12 5.13261 11.9473 5.25978 11.8536 5.35355C11.7598 5.44732 11.6326 5.5 11.5 5.5H5.5C5.36739 5.5 5.24022 5.44732 5.14645 5.35355C5.05268 5.25978 5 5.13261 5 5V4ZM5.14645 12.6464C5.24022 12.5527 5.36739 12.5 5.5 12.5H9.5C9.63261 12.5 9.75978 12.5527 9.85355 12.6464C9.94732 12.7402 10 12.8674 10 13C10 13.1326 9.94732 13.2598 9.85355 13.3536C9.75978 13.4473 9.63261 13.5 9.5 13.5H5.5C5.36739 13.5 5.24022 13.4473 5.14645 13.3536C5.05268 13.2598 5 13.1326 5 13C5 12.8674 5.05268 12.7402 5.14645 12.6464ZM5.5 8.5H11.5C11.6326 8.5 11.7598 8.55268 11.8536 8.64645C11.9473 8.74022 12 8.86739 12 9C12 9.13261 11.9473 9.25978 11.8536 9.35355C11.7598 9.44732 11.6326 9.5 11.5 9.5H5.5C5.36739 9.5 5.24022 9.44732 5.14645 9.35355C5.05268 9.25978 5 9.13261 5 9C5 8.86739 5.05268 8.74022 5.14645 8.64645C5.24022 8.55268 5.36739 8.5 5.5 8.5Z",
            fill: "black",
            stroke: "#101010"
        })
    });
};
/* harmony default export */ var ButtonType1Icon = (ButtonType1Icon_SvgComponent);

;// CONCATENATED MODULE: ./reusable/icons/ButtonType2Icon.tsx

var ButtonType2Icon_SvgComponent = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "16",
        height: "20",
        viewBox: "0 0 16 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M14.5 2V1.5H14H4C3.33696 1.5 2.70107 1.76339 2.23223 2.23223C1.76339 2.70107 1.5 3.33696 1.5 4V12.56V13.4445L2.25785 12.9884C2.78429 12.6715 3.38657 12.5028 4.001 12.5H14H14.5V12V2ZM14.5 14V13.5H14H4C3.33696 13.5 2.70107 13.7634 2.23223 14.2322C1.76339 14.7011 1.5 15.337 1.5 16C1.5 16.663 1.76339 17.2989 2.23223 17.7678C2.70107 18.2366 3.33696 18.5 4 18.5H14H14.5V18V14ZM4 0.5H14C14.3978 0.5 14.7794 0.658035 15.0607 0.93934C15.342 1.22064 15.5 1.60218 15.5 2V18C15.5 18.3978 15.342 18.7794 15.0607 19.0607C14.7794 19.342 14.3978 19.5 14 19.5H4C3.07174 19.5 2.1815 19.1313 1.52513 18.4749C0.868749 17.8185 0.5 16.9283 0.5 16V4C0.5 3.07174 0.868749 2.1815 1.52513 1.52513C2.1815 0.868749 3.07174 0.5 4 0.5ZM10 5.5H6C5.86739 5.5 5.74022 5.44732 5.64645 5.35355C5.55268 5.25978 5.5 5.13261 5.5 5C5.5 4.86739 5.55268 4.74022 5.64645 4.64645C5.74022 4.55268 5.86739 4.5 6 4.5H10C10.1326 4.5 10.2598 4.55268 10.3536 4.64645C10.4473 4.74022 10.5 4.86739 10.5 5C10.5 5.13261 10.4473 5.25978 10.3536 5.35355C10.2598 5.44732 10.1326 5.5 10 5.5Z",
            fill: "black",
            stroke: "#101010"
        })
    });
};
/* harmony default export */ var ButtonType2Icon = (ButtonType2Icon_SvgComponent);

;// CONCATENATED MODULE: ./reusable/icons/ButtonType3Icon.tsx

var ButtonType3Icon_SvgComponent = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "17",
        height: "20",
        viewBox: "0 0 17 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M16.5 6.94C16.4896 6.84813 16.4695 6.75763 16.44 6.67V6.58C16.3919 6.47718 16.3278 6.38267 16.25 6.3L10.25 0.3C10.1673 0.222216 10.0728 0.158081 9.97 0.11H9.88C9.77841 0.0517412 9.66622 0.0143442 9.55 0H3.5C2.70435 0 1.94129 0.316071 1.37868 0.87868C0.816071 1.44129 0.5 2.20435 0.5 3V17C0.5 17.7956 0.816071 18.5587 1.37868 19.1213C1.94129 19.6839 2.70435 20 3.5 20H13.5C14.2956 20 15.0587 19.6839 15.6213 19.1213C16.1839 18.5587 16.5 17.7956 16.5 17V7C16.5 7 16.5 7 16.5 6.94ZM10.5 3.41L13.09 6H11.5C11.2348 6 10.9804 5.89464 10.7929 5.70711C10.6054 5.51957 10.5 5.26522 10.5 5V3.41ZM14.5 17C14.5 17.2652 14.3946 17.5196 14.2071 17.7071C14.0196 17.8946 13.7652 18 13.5 18H3.5C3.23478 18 2.98043 17.8946 2.79289 17.7071C2.60536 17.5196 2.5 17.2652 2.5 17V3C2.5 2.73478 2.60536 2.48043 2.79289 2.29289C2.98043 2.10536 3.23478 2 3.5 2H8.5V5C8.5 5.79565 8.81607 6.55871 9.37868 7.12132C9.94129 7.68393 10.7044 8 11.5 8H14.5V17Z",
            fill: "black"
        })
    });
};
/* harmony default export */ var ButtonType3Icon = (ButtonType3Icon_SvgComponent);

;// CONCATENATED MODULE: ./components/carModelPage/sections/specifications/DownloadButton.tsx

function DownloadButton_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 0 0 50%;\n  display: flex;\n  justify-content: center;\n  margin-bottom: 10px;\n  ",
        " {\n    width: 100%;\n  }\n\n  ",
        " {\n    :nth-child(n) {\n      justify-content: flex-end;\n    }\n\n    :nth-child(2n) {\n      justify-content: flex-start;\n    }\n  }\n"
    ]);
    DownloadButton_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function DownloadButton_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 280px;\n  height: 80px;\n  background: ",
        ";\n  border-radius: 3px;\n  display: flex;\n  cursor: pointer;\n  text-align: center;\n  align-items: center;\n  justify-content: center;\n  svg {\n    margin-left: 12px;\n  }\n  p {\n    text-align: center;\n  }\n  a {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  margin-right: 10px;\n  ",
        " {\n    &:first-child {\n      order: 1;\n      margin-top: 20px;\n    }\n    margin-right: 0px;\n    width: 100%;\n  }\n"
    ]);
    DownloadButton_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var DownloadButton_StyledDiv = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "DownloadButton__StyledDiv",
    componentId: "sc-e432cb2c-0"
})(DownloadButton_templateObject(), function(p) {
    return p.theme.breakpoints.down("sm");
}, function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledDivWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "DownloadButton__StyledDivWrapper",
    componentId: "sc-e432cb2c-1"
})(DownloadButton_templateObject1(), function(p) {
    return p.theme.colors.lightGrey;
}, function(p) {
    return p.theme.breakpoints.down("sm");
});
// remove multiple // from url link but not from https://
var removeSlash = function(url) {
    var regex = /([^:]\/)\/+/g;
    return url.replace(regex, "$1");
};
var DownloadButton = function(param) {
    var link = param.link, name = param.name, typeId = param.typeId;
    var SetbtnType = function() {
        if (typeId === 1) return /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonType1Icon, {});
        else if (typeId === 2) return /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonType2Icon, {});
        else if (typeId === 3) return /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonType3Icon, {});
        else return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    };
    var url = removeSlash(link);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DownloadButton_StyledDiv, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDivWrapper, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(NextLink/* default */.Z, {
                href: url,
                openInNewTab: true,
                children: [
                    SetbtnType(),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledBody2 */.ZN, {
                        children: name
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var specifications_DownloadButton = (DownloadButton);

// EXTERNAL MODULE: ./components/carModelPage/sections/specifications/PollutionTable.tsx
var PollutionTable = __webpack_require__(71231);
;// CONCATENATED MODULE: ./reusable/icons/BlueCircleIcon.tsx

var BlueCircleIcon_SvgComponent = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "10",
        height: "10",
        viewBox: "0 0 10 10",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: "image",
        "aria-label": "עיגול מלא",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M5.00245 9.374C7.42245 9.374 9.35845 7.438 9.35845 5.018C9.35845 2.598 7.42245 0.662 5.00245 0.662C2.58245 0.662 0.646449 2.598 0.646449 5.018C0.646449 7.438 2.58245 9.374 5.00245 9.374Z",
            fill: "#0089CF"
        })
    });
};
/* harmony default export */ var BlueCircleIcon = (BlueCircleIcon_SvgComponent);

;// CONCATENATED MODULE: ./reusable/icons/EmptyCircleIcon.tsx

var EmptyCircleIcon_SvgComponent = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "10",
        height: "10",
        viewBox: "0 0 10 10",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: "image",
        "aria-label": "עיגול ריק",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M5.00245 9.374C7.42245 9.374 9.35845 7.438 9.35845 5.018C9.35845 2.598 7.42245 0.662 5.00245 0.662C2.58245 0.662 0.646449 2.598 0.646449 5.018C0.646449 7.438 2.58245 9.374 5.00245 9.374ZM5.00245 8.912C2.83545 8.912 1.10845 7.185 1.10845 5.018C1.10845 2.851 2.83545 1.124 5.00245 1.124C7.16945 1.124 8.89645 2.851 8.89645 5.018C8.89645 7.185 7.16945 8.912 5.00245 8.912Z",
            fill: "#0089CF"
        })
    });
};
/* harmony default export */ var EmptyCircleIcon = (EmptyCircleIcon_SvgComponent);

;// CONCATENATED MODULE: ./reusable/icons/RedXIcon.tsx

var RedXIcon_SvgComponent = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "6",
        height: "8",
        viewBox: "0 0 6 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: "image",
        "aria-label": "X",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M0.287125 8H1.42013L2.34413 6.207C2.52013 5.855 2.70713 5.47 2.90512 5.03H2.98212C3.20213 5.47 3.40013 5.855 3.58713 6.207L4.52213 8H5.71013L3.65313 4.359L5.57812 0.85H4.45613L3.62013 2.544C3.44413 2.874 3.30113 3.193 3.10313 3.633H3.02613C2.80613 3.193 2.65213 2.874 2.47613 2.544L1.60713 0.85H0.419125L2.33313 4.304L0.287125 8Z",
            fill: "#910A2D"
        })
    });
};
/* harmony default export */ var RedXIcon = (RedXIcon_SvgComponent);

;// CONCATENATED MODULE: ./components/carModelPage/sections/specifications/SafetyOptionsTable.tsx

function SafetyOptionsTable_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  margin-top: 30px;\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-start;\n  flex-direction: column;\n\n  ",
        " {\n    width: 100%;\n    justify-content: center;\n  }\n"
    ]);
    SafetyOptionsTable_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SafetyOptionsTable_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 95%;\n  ",
        " {\n    width: 100%;\n  }\n"
    ]);
    SafetyOptionsTable_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SafetyOptionsTable_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: 16px;\n  color: ",
        ";\n  margin-right: 10px;\n"
    ]);
    SafetyOptionsTable_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SafetyOptionsTable_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n"
    ]);
    SafetyOptionsTable_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function SafetyOptionsTable_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  list-style-type: none;\n  display: flex;\n  flex-wrap: wrap;\n  padding: 0px;\n  border: 1px solid rgb(153, 153, 153);\n  border-top: unset;\n  margin-top: 0px;\n  border-left: unset;\n  text-align: right;\n"
    ]);
    SafetyOptionsTable_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function SafetyOptionsTable_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 50%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-start;\n  font-size: 11px;\n  padding: 5px;\n  border-left: 1px solid rgb(153, 153, 153);\n"
    ]);
    SafetyOptionsTable_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function SafetyOptionsTable_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: rgb(213, 213, 213);\n  padding: 10px;\n  border: 1px solid rgb(153, 153, 153);\n  width: 100%;\n"
    ]);
    SafetyOptionsTable_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}







var StyledCellDiv = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SafetyOptionsTable__StyledCellDiv",
    componentId: "sc-a31daaa2-0"
})(SafetyOptionsTable_templateObject(), function(p) {
    return p.$width ? "width: ".concat(p.$width, ";") : "width: 50%;";
}, function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledCellDivWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SafetyOptionsTable__StyledCellDivWrapper",
    componentId: "sc-a31daaa2-1"
})(SafetyOptionsTable_templateObject1(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledSpan = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "SafetyOptionsTable__StyledSpan",
    componentId: "sc-a31daaa2-2"
})(SafetyOptionsTable_templateObject2(), function(p) {
    return p.theme.colors.nonExistentBlue;
});
var StyledSpanText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "SafetyOptionsTable__StyledSpanText",
    componentId: "sc-a31daaa2-3"
})(SafetyOptionsTable_templateObject3());
var SafetyOptionsTable_StyledList = styled_components_browser_esm/* default.ol.withConfig */.ZP.ol.withConfig({
    displayName: "SafetyOptionsTable__StyledList",
    componentId: "sc-a31daaa2-4"
})(SafetyOptionsTable_templateObject4());
var StyledListItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    displayName: "SafetyOptionsTable__StyledListItem",
    componentId: "sc-a31daaa2-5"
})(SafetyOptionsTable_templateObject5());
var StyledHeaderWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SafetyOptionsTable__StyledHeaderWrapper",
    componentId: "sc-a31daaa2-6"
})(SafetyOptionsTable_templateObject6());
var SafetyIcons = [
    {
        key: 0,
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlueCircleIcon, {})
    },
    {
        key: 1,
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyCircleIcon, {})
    },
    {
        key: 2,
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(RedXIcon, {})
    }, 
];
var SafetyOptionsTable = function(param) {
    var names = param.names, items = param.items, width = param.width;
    var ref = (0,react.useState)(""), name = ref[0], setName = ref[1];
    (0,react.useEffect)(function() {
        converNames();
    }, []);
    var converNames = function() {
        var uniqueNames = names.filter(function(value, index, array) {
            return array.indexOf(value) === index;
        });
        if (uniqueNames.length === 1) setName(uniqueNames[0]);
        else {
            setName(uniqueNames.slice(0, -1).join(", ") + " ו- " + uniqueNames.slice(-1));
        }
    };
    var secondColumnStart = Math.ceil(items.length / 2);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCellDiv, {
        $width: width,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCellDivWrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeaderWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(shared/* TypographyCenter */.kc, {
                        $fontSize: "11px",
                        $fontWeight: "400",
                        children: [
                            "פירוט מערכות הבטיחות המותנקות ברכב ברמות גימור",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSpanText, {
                                children: name
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SafetyOptionsTable_StyledList, {
                    children: items.slice(0, secondColumnStart).map(function(item, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                            children: [
                                items[i + secondColumnStart] && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledListItem, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSpan, {
                                            children: SafetyIcons[items[i + secondColumnStart].optionType - 1] ? SafetyIcons[items[i + secondColumnStart].optionType - 1].icon : items[i + secondColumnStart].optionValue
                                        }),
                                        items[i + secondColumnStart].optionName
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledListItem, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSpan, {
                                            children: SafetyIcons[item.optionType - 1] ? SafetyIcons[item.optionType - 1].icon : item.optionValue
                                        }),
                                        items[i].optionName
                                    ]
                                }),
                                i === secondColumnStart - 1 && items.length % 2 !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledListItem, {})
                            ]
                        }, "SafetyOptionsTable-".concat(i));
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var specifications_SafetyOptionsTable = (SafetyOptionsTable);

// EXTERNAL MODULE: ./components/carModelPage/sections/specifications/SafetyTable.tsx
var SafetyTable = __webpack_require__(70554);
;// CONCATENATED MODULE: ./components/carModelPage/sections/specifications/RegulationPage.tsx

function RegulationPage_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 50px 20px;\n  background-color: ",
        ";\n  ",
        " {\n    padding: 50px;\n  }\n"
    ]);
    RegulationPage_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function RegulationPage_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 1000px;\n  text-align: center;\n  ",
        " {\n    table {\n      width: 100%;\n    }\n  }\n"
    ]);
    RegulationPage_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function RegulationPage_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n  margin-top: 10px;\n  ",
        " {\n    width: 320px;\n  }\n"
    ]);
    RegulationPage_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function RegulationPage_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 45px;\n  ",
        " {\n    margin-top: 25px;\n  }\n"
    ]);
    RegulationPage_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function RegulationPage_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  ",
        " {\n    flex-direction: column;\n  }\n"
    ]);
    RegulationPage_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function RegulationPage_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  text-align: right;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 50%;\n  align-items: flex-start;\n  ",
        " {\n    width: 100%;\n    margin-bottom: 20px;\n    img {\n      width: 100%;\n    }\n  }\n"
    ]);
    RegulationPage_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function RegulationPage_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100px;\n  object-fit: contain;\n  max-width: 100%;\n"
    ]);
    RegulationPage_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function RegulationPage_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  ",
        " {\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap: 0px;\n  }\n"
    ]);
    RegulationPage_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function RegulationPage_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  margin-top: 30px;\n"
    ]);
    RegulationPage_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function RegulationPage_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 100%;\n  align-items: flex-start;\n  flex-direction: row;\n  flex-wrap: wrap;\n  img {\n    height: 50px;\n  }\n"
    ]);
    RegulationPage_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function RegulationPage_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  ",
        " {\n    align-items: center;\n    justify-content: right;\n  }\n"
    ]);
    RegulationPage_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}









var StyledWhiteWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "RegulationPage__StyledWhiteWrapper",
    componentId: "sc-8b25d695-0"
})(RegulationPage_templateObject(), function(p) {
    return p.theme.colors.white;
}, function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledRegWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "RegulationPage__StyledRegWrapper",
    componentId: "sc-8b25d695-1"
})(RegulationPage_templateObject1(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var RegulationPage_StyledCaption = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
    variant: "caption"
}).withConfig({
    displayName: "RegulationPage__StyledCaption",
    componentId: "sc-8b25d695-2"
})(RegulationPage_templateObject2(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledRegulation = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "RegulationPage__StyledRegulation",
    componentId: "sc-8b25d695-3"
})(RegulationPage_templateObject3(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var RegulationPage_StyledDiv = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "RegulationPage__StyledDiv",
    componentId: "sc-8b25d695-4"
})(RegulationPage_templateObject4(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledPollution = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "RegulationPage__StyledPollution",
    componentId: "sc-8b25d695-5"
})(RegulationPage_templateObject5(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var RegulationPage_StyledImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    displayName: "RegulationPage__StyledImage",
    componentId: "sc-8b25d695-6"
})(RegulationPage_templateObject6());
var StyledButtonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "RegulationPage__StyledButtonWrapper",
    componentId: "sc-8b25d695-7"
})(RegulationPage_templateObject7(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledSafety = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "RegulationPage__StyledSafety",
    componentId: "sc-8b25d695-8"
})(RegulationPage_templateObject8());
var StyledSafetyWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "RegulationPage__StyledSafetyWrapper",
    componentId: "sc-8b25d695-9"
})(RegulationPage_templateObject9());
var RegulationPage_StyledImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "RegulationPage__StyledImageWrapper",
    componentId: "sc-8b25d695-10"
})(RegulationPage_templateObject10(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var RegulationPage = function(param) {
    var data = param.data, catalog = param.catalog;
    var isDesktop = (0,MediaQueries/* useIsDesktop */.Ce)();
    // todo we have problem here with the links that we get from backend
    // repeated forward-slashes (//) or backslashes \ are not valid in the href
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWhiteWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledRegWrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "srOnly",
                    component: "h2",
                    children: "קבצים בפורמט PDF"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButtonWrapper, {
                    children: catalog.map(function(item, index) {
                        return (item === null || item === void 0 ? void 0 : item.name) && /*#__PURE__*/ (0,jsx_runtime.jsx)(specifications_DownloadButton, {
                            link: item === null || item === void 0 ? void 0 : item.link,
                            name: item.name,
                            typeId: item === null || item === void 0 ? void 0 : item.typeId
                        }, index);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledHeaderH2 */.x0, {
                    $margin: isDesktop ? 30 : 55,
                    children: "אבזור בטיחות, זיהום אוויר וצריכת דלק"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(RegulationPage_StyledCaption, {
                    children: data === null || data === void 0 ? void 0 : data.regulationText
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRegulation, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(RegulationPage_StyledDiv, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPollution, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RegulationPage_StyledImage, {
                                        loading: "lazy",
                                        src: data === null || data === void 0 ? void 0 : data.pollutionMainImage,
                                        alt: data === null || data === void 0 ? void 0 : data.pollutionMainImageAlt
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PollutionTable/* default */.Z, {
                                        data: data
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPollution, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RegulationPage_StyledImage, {
                                        loading: "lazy",
                                        src: data === null || data === void 0 ? void 0 : data.safetyMainImage,
                                        alt: data === null || data === void 0 ? void 0 : data.safetyMainImageAlt
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SafetyTable/* default */.Z, {
                                        data: data
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSafety, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSafetyWrapper, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RegulationPage_StyledImageWrapper, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RegulationPage_StyledImage, {
                                                loading: "lazy",
                                                src: data === null || data === void 0 ? void 0 : data.legend,
                                                alt: data === null || data === void 0 ? void 0 : data.legendAlt
                                            })
                                        }),
                                        data === null || data === void 0 ? void 0 : data.safetyOptionsTable.map(function(table, i) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(specifications_SafetyOptionsTable, {
                                                names: table.finishingLevelNames,
                                                items: table.items
                                            }, i);
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var specifications_RegulationPage = (RegulationPage);

;// CONCATENATED MODULE: ./components/carModelPage/sections/specifications/SpecificationsSection.tsx


var SpecificationsSection = function(param) {
    var carData = param.carData;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(specifications_RegulationPage, {
        data: carData === null || carData === void 0 ? void 0 : carData.regulation,
        catalog: carData === null || carData === void 0 ? void 0 : carData.catalogs
    });
};
/* harmony default export */ var specifications_SpecificationsSection = (SpecificationsSection);

;// CONCATENATED MODULE: ./components/carModelPage/CarModelPage.tsx

function CarModelPage_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    CarModelPage_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CarModelPage_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  animation: ",
        " 0.5s ease-in-out forwards;\n  display: ",
        ";\n"
    ]);
    CarModelPage_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CarModelPage_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: ",
        ";\n  transform: ",
        ";\n  transition: ",
        ";\n  display: ",
        ";\n  ",
        " {\n    transform: ",
        ";\n  }\n"
    ]);
    CarModelPage_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
























var Finance = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3662), __webpack_require__.e(6034), __webpack_require__.e(5181), __webpack_require__.e(7620)]).then(__webpack_require__.bind(__webpack_require__, 75181));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(75181)
            ];
        }
    },
    ssr: false
});
var CarModelPage_StyledPageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CarModelPage__StyledPageWrapper",
    componentId: "sc-a72f1633-0"
})(CarModelPage_templateObject());
var StyledHeaderCarPage = (0,styled_components_browser_esm/* default */.ZP)(Header/* default */.Z).withConfig({
    displayName: "CarModelPage__StyledHeaderCarPage",
    componentId: "sc-a72f1633-1"
})(CarModelPage_templateObject1(), function(p) {
    return p.$exit && animation/* keyFrameFadeOut */.My;
}, function(p) {
    return p.$exit ? "none" : "flex";
});
var StyledCarModelNavBar = (0,styled_components_browser_esm/* default */.ZP)(CarModelNavBar/* default */.Z).withConfig({
    displayName: "CarModelPage__StyledCarModelNavBar",
    componentId: "sc-a72f1633-2"
})(CarModelPage_templateObject2(), function(p) {
    return p.$exit && "1251";
}, function(p) {
    return !p.$exit && p.$isPastThreshold && "translateY(50px)";
}, function(p) {
    return !p.$exit && p.$isPastThreshold && "all 225ms cubic-bezier(0, 0, 0.2, 1) 0ms";
}, function(p) {
    return p.$exit || p.$isPastThreshold ? "flex" : "none";
}, function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return !p.$exit && p.$isPastThreshold && "translateY(80px)";
});
var CarModelPage = function(param) {
    var data = param.data;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var ref9 = (0,react.useState)(false), popupOpen = ref9[0], setPopupOpen = ref9[1];
    var ref10 = (0,react.useState)(false), pageLoaded = ref10[0], setPageLoaded = ref10[1];
    var sumOfAllFinishingLevels = data === null || data === void 0 ? void 0 : (ref = data.finishingLevels) === null || ref === void 0 ? void 0 : (ref1 = ref.engines) === null || ref1 === void 0 ? void 0 : ref1.reduce(function(acc, curr) {
        return acc + curr.finishingLevels.length;
    }, 0);
    var isDesktop = (0,MediaQueries/* useIsDesktop */.Ce)();
    var scrollDirection = (0,useScrollDirection/* useScrollDirection */.C)();
    // Value being driven by scrolling (e.g. height)
    var thresholdY = 2 // set the scroll position where you want the state change
    ;
    var scrollY = (0,use_scroll/* useScroll */.v)().scrollY;
    var ref11 = (0,react.useState)(false), isPastThreshold = ref11[0], setIsPastThreshold = ref11[1];
    (0,react.useEffect)(function() {
        return scrollY.onChange(function(latest) {
            setIsPastThreshold(scrollDirection === "up" && latest <= 1000 ? false : latest > thresholdY);
        });
    }, []);
    // use effect to set page loaded to true after 1 second
    (0,react.useEffect)(function() {
        var timer = setTimeout(function() {
            setPageLoaded(true);
        }, 1000);
        return function() {
            return clearTimeout(timer);
        };
    }, []);
    var dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(function() {
        dispatch((0,detailingSlice/* setModel */.j1)(data.generalInfo.id.toString()));
    }, [
        data.generalInfo.id
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            pageLoaded && /*#__PURE__*/ (0,jsx_runtime.jsx)(Finance, {
                modelId: data.generalInfo.id,
                modelName: data.generalInfo.name,
                popupOpen: popupOpen,
                setPopupOpen: setPopupOpen
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(scrollSection/* ScrollingProvider */.bG, {
                offset: isDesktop ? shared/* HEADER_ANIME_D */.oe : shared/* HEADER_ANIME_M */.yv,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CarModelPage_StyledPageWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCarModelNavBar, {
                            modelName: data === null || data === void 0 ? void 0 : (ref2 = data.generalInfo) === null || ref2 === void 0 ? void 0 : ref2.name,
                            $exit: scrollDirection === "down",
                            $isPastThreshold: isPastThreshold
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeaderCarPage, {
                            narrow: true,
                            $exit: scrollDirection === "down"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TopBanner_ModelPageTopBanner, {
                            data: data.topBannerDto
                        }),
                        (data === null || data === void 0 ? void 0 : data.outside) && /*#__PURE__*/ (0,jsx_runtime.jsx)(scrollSection/* Section */.$0, {
                            id: "exterior",
                            title: "חוץ",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(exterior_ExteriorSection, {
                                data: data,
                                setCalculatorPopupOpen: setPopupOpen
                            })
                        }),
                        (data === null || data === void 0 ? void 0 : data.inside) && /*#__PURE__*/ (0,jsx_runtime.jsx)(scrollSection/* Section */.$0, {
                            id: "interior",
                            title: "פנים",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(interior_InteriorSection, {
                                insideData: data === null || data === void 0 ? void 0 : data.inside
                            })
                        }),
                        (data === null || data === void 0 ? void 0 : data.volumeIllustration) && /*#__PURE__*/ (0,jsx_runtime.jsx)(scrollSection/* Section */.$0, {
                            id: "illustrate-size",
                            title: "המחשת נפח",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(illustrateSize_IllustrateSizeSection, {
                                illustrateSize: data === null || data === void 0 ? void 0 : data.volumeIllustration.volumeIllustrationElements
                            })
                        }),
                        (data === null || data === void 0 ? void 0 : data.drivingExpirience) && /*#__PURE__*/ (0,jsx_runtime.jsx)(scrollSection/* Section */.$0, {
                            id: "driving-experience",
                            title: "חוויית נהיגה",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(drivingExperience_DrivingExperienceSection, {
                                drivingExpirience: data === null || data === void 0 ? void 0 : data.drivingExpirience,
                                modelName: data === null || data === void 0 ? void 0 : (ref3 = data.generalInfo) === null || ref3 === void 0 ? void 0 : ref3.name,
                                modelImge: data === null || data === void 0 ? void 0 : (ref4 = data.generalInfo) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.image) === null || ref5 === void 0 ? void 0 : ref5.imageUrl
                            })
                        }),
                        (data === null || data === void 0 ? void 0 : data.safety) && /*#__PURE__*/ (0,jsx_runtime.jsx)(scrollSection/* Section */.$0, {
                            id: "safety",
                            title: "בטיחות",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(safety_SafetySection, {
                                data: data === null || data === void 0 ? void 0 : data.safety
                            })
                        }),
                        (data === null || data === void 0 ? void 0 : (ref6 = data.finishingLevels) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.engines) === null || ref7 === void 0 ? void 0 : ref7.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(scrollSection/* Section */.$0, {
                            id: "finishing_levels",
                            title: "רמות גימור",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(finishingLevels_FinishingLevelsSection, {
                                setCalculatorPopupOpen: setPopupOpen,
                                data: data === null || data === void 0 ? void 0 : data.finishingLevels,
                                modelName: data === null || data === void 0 ? void 0 : (ref8 = data.generalInfo) === null || ref8 === void 0 ? void 0 : ref8.name
                            })
                        }),
                        data.articles && /*#__PURE__*/ (0,jsx_runtime.jsx)(scrollSection/* Section */.$0, {
                            id: "reviews",
                            title: "סקירות",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(review_ReviewsSection, {
                                carData: data
                            })
                        }),
                        ((data === null || data === void 0 ? void 0 : data.regulation) || (data === null || data === void 0 ? void 0 : data.catalogs)) && /*#__PURE__*/ (0,jsx_runtime.jsx)(scrollSection/* Section */.$0, {
                            id: "specifications",
                            title: "מפרטים",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(specifications_SpecificationsSection, {
                                carData: data
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(navigation_StickyBottomCTA, {
                            setPopupOpen: setPopupOpen,
                            numberOfFinishingLevels: sumOfAllFinishingLevels,
                            modelId: data.generalInfo.id
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var carModelPage_CarModelPage = (CarModelPage);

;// CONCATENATED MODULE: ./src/pages/model/[modelId]/[modelSlug].tsx



var Model = function(param) {
    var modelData = param.modelData, seo = param.seo;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SeoMetaData/* default */.ZP, {
                data: seo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(carModelPage_CarModelPage, {
                data: modelData
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var _modelSlug_ = (Model);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4885,4245,2669,4856,6043,273,521,5726,9623,1163,4839,9419,6798,4548,9774,2888,179], function() { return __webpack_exec__(2711); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);